
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gi7cm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cy0MC = parcelRequire("cy0MC");


var $aq5p0 = parcelRequire("aq5p0");


var $d0O3C = parcelRequire("d0O3C");

const $fca955e9583784d7$var$DEFAULT_MAX_CONNECTORS = 3;
// Build the connector list from the static recommendation cascade + canonical
// container map. Connection state comes from outbound-auth ground truth.
const $fca955e9583784d7$var$buildConnectors = async (maxConnectors, outboundAuthPayload, recommendedProductKeys, env)=>{
    const mappedProductKeys = recommendedProductKeys// Drop providers without a canonical container mapping in this env —
    // rendering a Connect button for them would either 404 or open the
    // wrong OAuth flow.
    .filter((productKey)=>(0, $aq5p0.hasSmartLinkContainerMapping)(productKey, env)).slice(0, maxConnectors);
    const resolved = await Promise.all(mappedProductKeys.map(async (productKey)=>{
        const staticConfig = await (0, $cy0MC.ThirdPartyConfigs).get(productKey);
        const authUrl = (0, $aq5p0.buildSmartLinkAuthUrl)(productKey, env);
        if (!authUrl) return null;
        return {
            productKey: productKey,
            displayName: String(staticConfig?.displayName || productKey),
            authUrl: authUrl,
            icon: staticConfig?.icon,
            requiresOauth: staticConfig?.requiresOauth ?? true,
            isAuthenticated: (0, $aq5p0.isAuthenticatedForProduct)(outboundAuthPayload, productKey, env)
        };
    }));
    return resolved.filter((entry)=>entry !== null);
};
const $fca955e9583784d7$export$dd138e751e0a384e = ({ cloudId: cloudId, userId: userId, aaId: aaId, maxConnectors: maxConnectors = $fca955e9583784d7$var$DEFAULT_MAX_CONNECTORS, smartlinkConnectorRecommendationInputs: smartlinkConnectorRecommendationInputs })=>{
    const [connectorResources, setConnectorResources] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [outboundAuthPayload, setOutboundAuthPayload] = (0, $42omo.useState)(null);
    // Smart Link environment detected from the outbound-auth response. Stored
    // in state so the reconcile useEffect can pass it through to the helpers
    // without having to re-detect on every render.
    const [smartLinkEnv, setSmartLinkEnv] = (0, $42omo.useState)(undefined);
    const siteWideSmartlinkAppCounts = smartlinkConnectorRecommendationInputs?.siteWideSmartlinkAppCounts;
    const teamTypeSmartlinkAppCounts = smartlinkConnectorRecommendationInputs?.teamTypeSmartlinkAppCounts;
    // Full 3-tier cascade so cold-start tenants get the team-type-curated
    // Tier 3 row (or the `na` floor if no team type is known) directly from
    // the canonical recommendation source — no parallel "default app list"
    // is maintained inside the hook.
    const recommendedProductKeys = (0, $42omo.useMemo)(()=>(0, $d0O3C.resolveRecommendedProductKeys)({
            siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts,
            teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts,
            teamTypeKey: smartlinkConnectorRecommendationInputs?.teamTypeKey
        }, maxConnectors), [
        siteWideSmartlinkAppCounts,
        teamTypeSmartlinkAppCounts,
        smartlinkConnectorRecommendationInputs?.teamTypeKey,
        maxConnectors
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsLoading(true);
        (async ()=>{
            let fetchedOutboundAuth = null;
            try {
                // `fetchAccountsByAaId` caches by aaId for 30 minutes, so
                // co-mounted callers (e.g. post-office banner + onboarding
                // modal) share a single network request.
                fetchedOutboundAuth = await (0, $aq5p0.fetchOutboundAuthAccounts)(aaId);
                // Detect env from the payload UUIDs (env-scoped). Falls back
                // to hostname inside the helpers when the payload is empty.
                const detectedEnv = (0, $aq5p0.detectEnvFromPayload)(fetchedOutboundAuth) ?? undefined;
                setOutboundAuthPayload(fetchedOutboundAuth);
                setSmartLinkEnv(detectedEnv);
                const connectors = await $fca955e9583784d7$var$buildConnectors(maxConnectors, fetchedOutboundAuth, recommendedProductKeys, detectedEnv);
                setConnectorResources(connectors);
            } catch  {
                // Defensive — `fetchOutboundAuthAccounts` is non-throwing,
                // but keep the safety net so a render-time error still
                // degrades gracefully instead of stalling the spinner.
                setOutboundAuthPayload(fetchedOutboundAuth);
                const fallbackEnv = (0, $aq5p0.detectEnvFromPayload)(fetchedOutboundAuth) ?? undefined;
                const connectors = await $fca955e9583784d7$var$buildConnectors(maxConnectors, fetchedOutboundAuth, recommendedProductKeys, fallbackEnv);
                setConnectorResources(connectors);
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        aaId,
        maxConnectors,
        recommendedProductKeys
    ]);
    const onConnectorConnected = (0, $42omo.useCallback)((productKey)=>{
        // Keep our `isAuthenticated` in sync so sibling consumers of
        // this hook (e.g. the post-office banner) reflect the new state.
        setConnectorResources((currentResources)=>currentResources.map((resource)=>resource.productKey === productKey ? {
                    ...resource,
                    isAuthenticated: true
                } : resource));
        // Bypass the 30-min cache so a later re-mount sees the fresh
        // grant instead of the stale pre-OAuth payload.
        if (aaId) (0, $aq5p0.fetchOutboundAuthAccounts)(aaId, {
            forceRefresh: true
        }).then((payload)=>{
            if (payload) setOutboundAuthPayload(payload);
        });
    }, [
        aaId
    ]);
    // Reconcile each row's `isAuthenticated` against outbound-auth ground
    // truth whenever the payload changes. The shallow diff prevents an
    // infinite render loop when nothing actually changed.
    (0, $42omo.useEffect)(()=>{
        if (!outboundAuthPayload) return;
        setConnectorResources((currentResources)=>{
            let didChange = false;
            const next = currentResources.map((resource)=>{
                if (!(0, $aq5p0.hasSmartLinkContainerMapping)(resource.productKey, smartLinkEnv)) return resource;
                const groundTruth = (0, $aq5p0.isAuthenticatedForProduct)(outboundAuthPayload, resource.productKey, smartLinkEnv);
                if (groundTruth === resource.isAuthenticated) return resource;
                didChange = true;
                return {
                    ...resource,
                    isAuthenticated: groundTruth
                };
            });
            return didChange ? next : currentResources;
        });
    }, [
        outboundAuthPayload,
        smartLinkEnv
    ]);
    return {
        connectorResources: connectorResources,
        isLoading: isLoading,
        onConnectorConnected: onConnectorConnected
    };
};
module.exports["use3pConnectorResources"] = $fca955e9583784d7$export$dd138e751e0a384e;

});

parcelRegister("aq5p0", function(module, exports) {
/**
 * Utilities for talking to the Atlassian outbound-auth gateway, which is the
 * canonical source of truth for whether a user has a working OAuth connection
 * to a given Smart Link connector.
 *
 * Why this exists
 * ---------------
 * Previously we relied on the CDS endpoint
 *   GET /gateway/api/third-party-configuration/connected-data-sources/{cloudId}
 * (via `get3pSearchConfig`) to determine both the OAuth start URL and whether
 * the user was already connected. That endpoint has four well-known problems
 * for the Confluence onboarding "Connect your 3P tools" experience:
 *
 *   1. Edition-gated: CDS only works on Standard+ tenants with Rovo
 *      provisioned. Free tier tenants return 403.
 *   2. Lazy-init: the registry behind CDS (ERS) does not have a
 *      `smartlinks-connector-{provider}` row until a Smart Link resolve event
 *      for that provider has fired on the tenant. Brand-new tenants are
 *      effectively empty.
 *   3. Not a definitive provider universe: CDS only enumerates what's already
 *      been touched on this tenant, not what's available to connect.
 *   4. No back-population: even after a user connects via a fallback path,
 *      CDS does not see it (until/unless ERS gets the event), so downstream
 *      surfaces like the post-office banner keep re-prompting.
 *
 * The outbound-auth gateway endpoint
 *   GET /gateway/api/outbound-auth/aaId/{aaId}
 * powers id.atlassian.com/manage-profile/apps. It is cookie-authed (no ASAP
 * needed), works cross-origin from *.atlassian.net, and returns the user's
 * full OAuth-grant list with a per-account `status` field. This is the same
 * data the Atlassian ID Manage Profile UI uses.
 *
 * Canonical container UUIDs come from
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application-prod.yml
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application.yml      (staging)
 * under `linking-platform.providers[]`. The `containerId` + `serviceKey`
 * tuples in the outbound-auth response match those values exactly.
 *
 * Backwards-compat / defensive design
 * -----------------------------------
 *  - All network/parse failures return `null` and let callers fall back to
 *    whatever they were doing before. This module never throws.
 *  - The container maps are `Partial<Record<...>>` and helpers return `null`
 *    when a product has no mapping. Callers are expected to filter such
 *    providers out rather than render broken Connect buttons.
 */ 
var $78z3f = parcelRequire("78z3f");


var $abk4V = parcelRequire("abk4V");

// Verified identical in prod and staging gdrive CDS URLs.
const $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES = [
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
];
const $0de16cf0cbdeac18$export$860f54a43e361c13 = {
    [(0, $78z3f.ProductKeys3P).GoogleDrive]: {
        containerId: 'ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7_c50f3d56-68fc-4c3c-8191-6717f173dc54',
        serviceKey: 'gdrive',
        defaultScopes: $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $78z3f.ProductKeys3P).Slack]: {
        containerId: '25ab8ceb-e2e9-4b3a-b4ef-902049561d3a_74232f16-3f89-4bc8-9dcb-b5481bca783e',
        serviceKey: 'slack'
    },
    [(0, $78z3f.ProductKeys3P).OneDrive]: {
        containerId: '00f40f12-faac-4ac8-8d6d-310f96ac97f5_f039c3c2-7e00-41c4-b1cf-70743efbf91a',
        serviceKey: 'onedrive'
    },
    [(0, $78z3f.ProductKeys3P).Github]: {
        containerId: 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7',
        serviceKey: 'github'
    },
    [(0, $78z3f.ProductKeys3P).Figma]: {
        containerId: '7f89dc0c-5c1e-4b71-997f-220bf92361aa_73fbf758-c657-4f06-8edd-f721911f7f53',
        serviceKey: 'figma'
    },
    [(0, $78z3f.ProductKeys3P).Teams]: {
        containerId: 'fe8ece6c-97b6-45ac-959d-865da9a33409_61030824-303b-4751-bca5-1def33b6b0d0',
        serviceKey: 'ms-teams'
    },
    [(0, $78z3f.ProductKeys3P).Dropbox]: {
        containerId: 'd4d6a241-1008-42cf-b2d6-d0b380c096d6_b6796989-c34a-4e19-a4e1-ccc7655f8fd6',
        serviceKey: 'dropbox'
    },
    [(0, $78z3f.ProductKeys3P).Airtable]: {
        containerId: 'c5805f5a-3e9a-48a5-a8f5-7b04aac4ad16_572b2748-e9b1-4161-b36d-19f962646d1a',
        serviceKey: 'airtable'
    },
    [(0, $78z3f.ProductKeys3P).LaunchDarkly]: {
        containerId: '30ba2eba-6d3f-4124-8060-0ea9a9c9e990_d28912a6-171c-41a2-9adb-1426eccbc767',
        serviceKey: 'launchdarkly'
    },
    [(0, $78z3f.ProductKeys3P).ClickUp]: {
        containerId: '12967bc2-803e-4f8d-9e66-1aa48773a5a4_13a589a5-f514-4b63-a104-7d454b8dc676',
        serviceKey: 'clickup'
    },
    [(0, $78z3f.ProductKeys3P).Pipedrive]: {
        containerId: '1edf2d8e-c159-4ffe-8be0-165821a0ecf1_743950e9-2685-4558-a5b0-ae5d3b47853c',
        serviceKey: 'pipedrive'
    },
    [(0, $78z3f.ProductKeys3P).Gitlab]: {
        containerId: '790bd6ce-7ef8-404a-a9dc-798feb10b12b_049b63cb-90b1-4bfa-aa02-f3fdd9298b03',
        serviceKey: 'gitlab'
    },
    [(0, $78z3f.ProductKeys3P).Docusign]: {
        containerId: '35cd5415-c24c-457e-af7c-ac84df8c8628_0a7329e4-b658-41a1-89c2-419514a5ca08',
        serviceKey: 'docusign'
    },
    [(0, $78z3f.ProductKeys3P).Dovetail]: {
        containerId: 'b51f1664-8705-4938-a9a5-02a7eb3395cb_cba4f674-8eea-43aa-874f-8f16af6b75cb',
        serviceKey: 'dovetail'
    },
    [(0, $78z3f.ProductKeys3P).Box]: {
        containerId: '3a79e004-2e3e-45fe-8a21-84f53568a8ee_35421d47-ad3e-44f5-9cde-60bfa869e0b0',
        serviceKey: 'box'
    },
    [(0, $78z3f.ProductKeys3P).AdobeXD]: {
        containerId: '80c22a47-9ca7-4690-88db-65b375f402a7_ad251cf5-828d-494d-b555-4294d9654173',
        serviceKey: 'adobexd'
    },
    [(0, $78z3f.ProductKeys3P).Asana]: {
        containerId: '2487d697-ed1e-4cf5-9655-f1fb1355c341_a927cae4-3500-4386-9ac3-28e87671c2c8',
        serviceKey: 'asana'
    },
    [(0, $78z3f.ProductKeys3P).Smartsheet]: {
        containerId: '101a27da-d409-4f8c-9c75-326eec4fd5d4_fe89f892-8c94-4574-88f7-5898c05be186',
        serviceKey: 'smartsheet'
    },
    [(0, $78z3f.ProductKeys3P).Mural]: {
        containerId: 'cc21faf3-19fc-4522-af92-295866ef82e7_373f2501-6f74-4c0f-9bfa-c54cdea00066',
        serviceKey: 'mural'
    },
    [(0, $78z3f.ProductKeys3P).PowerBI]: {
        containerId: '9c59191f-63ab-44b2-a2cb-2f20adc75365_556e62ba-588b-494d-8c6c-b672e50537f6',
        serviceKey: 'power-bi'
    },
    [(0, $78z3f.ProductKeys3P).Miro]: {
        containerId: 'd01d8332-4637-4ea4-8b14-17a9d1a61504_a894175f-cb17-4e45-88fa-c348967f379c',
        serviceKey: 'miro'
    },
    [(0, $78z3f.ProductKeys3P).Hubspot]: {
        containerId: 'da0f0482-f78f-4eec-b7e6-0bc98ca5a54c_707406e8-d607-427a-b32e-e1d4710c0f2d',
        serviceKey: 'hubspot'
    },
    [(0, $78z3f.ProductKeys3P).Notion]: {
        containerId: '2bc172f6-c553-4fe1-85d4-3e2e087f84f6_be0969ca-ea7e-4685-abaa-7de142c01b36',
        serviceKey: 'notion'
    },
    [(0, $78z3f.ProductKeys3P).Sentry]: {
        containerId: '977cb3af-b6e9-4450-9ce5-bf40f9c73dff_3a8bcf5e-44ab-4f5b-b18d-340027b6a97e',
        serviceKey: 'sentry'
    },
    [(0, $78z3f.ProductKeys3P).PagerDuty]: {
        containerId: '49cdc160-0ad5-4dbf-adad-6a57fb082774_5cef1b1a-44aa-409e-97b3-b90065cbb39e',
        serviceKey: 'pagerduty'
    },
    [(0, $78z3f.ProductKeys3P).Salesforce]: {
        containerId: '2b45cadc-67a2-4902-8148-03e4de5ba747_db858b85-c098-45e7-96c8-9ccc9caf72da',
        serviceKey: 'salesforce'
    },
    [(0, $78z3f.ProductKeys3P).Amplitude]: {
        containerId: '1e30cfdf-cceb-43f4-b34a-dde94e1f9b21_939acc6f-274a-42da-acdc-8af5a14fe698',
        serviceKey: 'amplitude'
    },
    [(0, $78z3f.ProductKeys3P).Lucid]: {
        containerId: '9262005e-5c1a-49af-9ec0-4a354f581c73_80f25935-3f1f-40e1-9b2a-35db54297ebf',
        serviceKey: 'lucid'
    },
    [(0, $78z3f.ProductKeys3P).Zeplin]: {
        containerId: 'a401d4f0-b3d1-4b64-a85d-3952bd42d9a7_3da3c5e7-89db-4330-878f-dff1fe878556',
        serviceKey: 'zeplin'
    },
    [(0, $78z3f.ProductKeys3P).Todoist]: {
        containerId: '0202ace9-65df-40e3-b539-d831b446dad9_c7809c53-31e9-4fc0-8df9-8b8dcb418bb8',
        serviceKey: 'todoist'
    },
    [(0, $78z3f.ProductKeys3P).Stripe]: {
        containerId: 'bb81e8b8-7d0d-4a24-bb5b-acf31ab97bbc_f38b2a60-30a9-4abd-9086-efb78f6986ce',
        serviceKey: 'stripe'
    },
    [(0, $78z3f.ProductKeys3P).AzureDevops]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=6b34a992…]).
        containerId: '6b34a992-af2a-4a16-8a4d-89038c48a355_719d2d91-a89a-46f5-bacc-e3baf87d21c8',
        serviceKey: 'azuredevops'
    },
    [(0, $78z3f.ProductKeys3P).Webex]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=18025f11…]).
        containerId: '18025f11-aafe-49ca-ad45-d48f7005e459_19846c70-0c88-44f6-a7c1-d5bdd77c606c',
        serviceKey: 'webex'
    }
};
const $0de16cf0cbdeac18$export$e25d6f2386134a66 = {
    [(0, $78z3f.ProductKeys3P).GoogleDrive]: {
        containerId: '2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1_3b53863d-a6bb-4818-91da-4de04f975f48',
        serviceKey: 'gdrive',
        defaultScopes: $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $78z3f.ProductKeys3P).Slack]: {
        containerId: '32a368b4-220e-45a9-b65f-df104dc2e559_7ab21f60-b89a-44c1-bed3-00282c3e7b9e',
        serviceKey: 'slack'
    },
    [(0, $78z3f.ProductKeys3P).OneDrive]: {
        containerId: '6b74c0f8-ce5e-43b0-a68e-eba0fed27cea_4254f605-625b-4026-904a-bdf8ee6de413',
        serviceKey: 'onedrive'
    },
    [(0, $78z3f.ProductKeys3P).Github]: {
        containerId: '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f',
        serviceKey: 'github'
    },
    [(0, $78z3f.ProductKeys3P).Figma]: {
        containerId: '652e701c-09ac-4e05-bd96-4c95b5c8cac5_ccaebdc1-68e5-406a-b1f4-efcc5962aa40',
        serviceKey: 'figma'
    },
    [(0, $78z3f.ProductKeys3P).Teams]: {
        containerId: 'd27ee9f8-f60b-4076-910b-f16da23b7df4_b3763282-4b2e-4b4b-b924-3c8ba8f6e218',
        serviceKey: 'ms-teams'
    },
    [(0, $78z3f.ProductKeys3P).Dropbox]: {
        containerId: 'd7a3169c-13c8-4b76-96b6-e8f9f849313d_d73e8370-9035-494d-ae16-20854375cb6f',
        serviceKey: 'dropbox'
    },
    [(0, $78z3f.ProductKeys3P).Airtable]: {
        containerId: '070278f6-260c-420f-be4f-a7942a712c23_c2fe283b-51d2-4a0a-8e7f-4ce1199e0a10',
        serviceKey: 'airtable'
    },
    [(0, $78z3f.ProductKeys3P).LaunchDarkly]: {
        containerId: 'd63e3423-0a85-461f-9650-7f26342c62bf_49e197a6-c428-442e-a5ca-f9d4889c82d8',
        serviceKey: 'launchdarkly'
    },
    [(0, $78z3f.ProductKeys3P).ClickUp]: {
        containerId: 'fe20ccd3-b054-4139-aacb-8d98e086c16d_0b40b3c7-4c18-40e3-a030-101c94347723',
        serviceKey: 'clickup'
    },
    [(0, $78z3f.ProductKeys3P).Pipedrive]: {
        containerId: '6012b82a-da48-44ff-af6e-da1c73b279f6_e6a2cefa-c9fe-4d50-b8ea-36391a2d41e6',
        serviceKey: 'pipedrive'
    },
    [(0, $78z3f.ProductKeys3P).Gitlab]: {
        containerId: 'a7b83eeb-482d-402d-b87d-21ede67e73ed_3082dfec-249f-45d9-b84d-b49d256874e9',
        serviceKey: 'gitlab'
    },
    [(0, $78z3f.ProductKeys3P).Docusign]: {
        containerId: 'ec9d65b4-72ee-4030-8dd1-e393026cf335_f4f50986-99a8-4f96-8b52-917d4c6bbbb7',
        serviceKey: 'docusign'
    },
    [(0, $78z3f.ProductKeys3P).Dovetail]: {
        containerId: 'f9a3bf31-88d5-4b5a-80c2-cc32670259a2_c0c8e23b-ec93-45bb-928c-91b9671f0041',
        serviceKey: 'dovetail'
    },
    [(0, $78z3f.ProductKeys3P).Box]: {
        containerId: '43cd20d8-11a7-4910-8789-06523fb2e6db_957783c9-4448-4d91-93dc-0ad7b24a327a',
        serviceKey: 'box'
    },
    [(0, $78z3f.ProductKeys3P).AdobeXD]: {
        containerId: 'c1225a08-acd6-4908-84a7-d5b573f14cc1_e701a1e0-b819-4077-99ac-0b3525510c66',
        serviceKey: 'adobexd'
    },
    [(0, $78z3f.ProductKeys3P).Asana]: {
        containerId: '35462eee-abe5-4873-ba7a-610d4c85f640_cb8525b3-26b3-467d-b42c-cb944e912311',
        serviceKey: 'asana'
    },
    [(0, $78z3f.ProductKeys3P).Smartsheet]: {
        containerId: '48cb55a0-db03-4ce4-8f76-1f986f734652_e6b58d0f-fa9f-4543-9b67-5957b73dee6f',
        serviceKey: 'smartsheet'
    },
    [(0, $78z3f.ProductKeys3P).Mural]: {
        containerId: '95d1bad0-96d7-40a8-996f-b8226dfd8fa1_d6095215-c4a5-4be1-bdd9-7065ed65ae37',
        serviceKey: 'mural'
    },
    [(0, $78z3f.ProductKeys3P).PowerBI]: {
        containerId: 'ea3c5a46-228c-47ea-8c4b-f18e0f17fe8c_abc5ee35-a08c-4481-aa26-0439ce58b4c4',
        serviceKey: 'power-bi'
    },
    [(0, $78z3f.ProductKeys3P).Miro]: {
        containerId: 'e37bcd89-df89-4e65-90f9-98a92fa2dbd0_7c1ec941-d9e7-40be-96fb-69fae6b6bfd2',
        serviceKey: 'miro'
    },
    [(0, $78z3f.ProductKeys3P).Hubspot]: {
        containerId: 'aca58c62-2fb0-4abc-93f0-08bc704ab82a_c39eff84-66f8-4fa9-bb75-768ac83b5f6d',
        serviceKey: 'hubspot'
    },
    [(0, $78z3f.ProductKeys3P).Notion]: {
        containerId: '60913f14-f7e5-465a-9df7-a5f7974caad6_80617f98-fa46-4b5e-9c8e-a54bc42b7c3e',
        serviceKey: 'notion'
    },
    [(0, $78z3f.ProductKeys3P).Sentry]: {
        containerId: '59ec4558-3649-433e-a6b9-7964ae040b78_39660d3a-f2c9-446a-9a53-db433bbc7c2d',
        serviceKey: 'sentry'
    },
    [(0, $78z3f.ProductKeys3P).PagerDuty]: {
        containerId: '2db77a65-0037-45ea-9f57-642051d86ff5_dd18e9a6-e52a-4b80-9a2f-1aa487c9f747',
        serviceKey: 'pagerduty'
    },
    [(0, $78z3f.ProductKeys3P).Salesforce]: {
        containerId: 'd62184e4-87e4-41b2-9321-8b3c1dede9d7_433a0c54-84d5-41ee-9c21-684887b34330',
        serviceKey: 'salesforce'
    },
    [(0, $78z3f.ProductKeys3P).Amplitude]: {
        containerId: '953d4aed-a528-4a5e-9f84-fe42741063f5_eed898af-fb54-4a76-ba73-8d6261639a1a',
        serviceKey: 'amplitude'
    },
    [(0, $78z3f.ProductKeys3P).Lucid]: {
        containerId: 'd188e82f-311c-429d-a17f-bde97037890e_937a3756-c797-4f04-bde1-3eba582b91cf',
        serviceKey: 'lucid'
    },
    [(0, $78z3f.ProductKeys3P).Zeplin]: {
        containerId: '2e14b294-385f-4d3c-a0a0-3e29e1f3a30b_f156da1b-5880-4fc1-ae67-2581ab8fda87',
        serviceKey: 'zeplin'
    },
    [(0, $78z3f.ProductKeys3P).Todoist]: {
        containerId: '6ff1e497-21ac-4f8e-ac74-b869e2c3f274_0f5c1a58-fdae-41ae-841d-2bc5a2875c38',
        serviceKey: 'todoist'
    },
    [(0, $78z3f.ProductKeys3P).Stripe]: {
        containerId: '48824814-f7d3-465a-9535-f589940c8e5a_8a330cd4-3af2-4c32-8c8e-8e751a3fad8a',
        serviceKey: 'stripe'
    },
    [(0, $78z3f.ProductKeys3P).AzureDevops]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod —
        // ai-3p-connector's application-staging.yml does NOT declare a
        // per-provider serviceKey for Azure DevOps, but every other
        // provider in this file uses the same serviceKey across both
        // environments, so the prod value is the safe assumption.
        containerId: '784f3542-1a1d-4f49-8769-f3c2cb1e83b3_b91efd28-4d10-43d4-bcae-a5b0fef72bb1',
        serviceKey: 'azuredevops'
    },
    [(0, $78z3f.ProductKeys3P).Webex]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod
        // (see note on AzureDevops above).
        containerId: 'ead13644-c3c5-4f8d-8d31-58be86dc7c8e_cedff546-1b81-4f3c-b65d-30c4cb2d8c61',
        serviceKey: 'webex'
    }
};
const $0de16cf0cbdeac18$var$ATLASSIAN_ID_BASE_URLS = {
    prod: 'https://id.atlassian.com',
    staging: 'https://id.stg.internal.atlassian.com'
};
const $0de16cf0cbdeac18$var$CONTAINER_MAPS = {
    prod: $0de16cf0cbdeac18$export$860f54a43e361c13,
    staging: $0de16cf0cbdeac18$export$e25d6f2386134a66
};
const $0de16cf0cbdeac18$var$isProdHostname = ()=>{
    if (typeof window === 'undefined' || !window.location) return true;
    return window.location.hostname.endsWith('.atlassian.net');
};
const $0de16cf0cbdeac18$var$getEnvFromHostname = ()=>$0de16cf0cbdeac18$var$isProdHostname() ? 'prod' : 'staging';
const $0de16cf0cbdeac18$export$d73c6d475285293 = (payload)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return null;
    const prodUuids = new Set(Object.values($0de16cf0cbdeac18$export$860f54a43e361c13).map((m)=>m?.containerId));
    const stagingUuids = new Set(Object.values($0de16cf0cbdeac18$export$e25d6f2386134a66).map((m)=>m?.containerId));
    let prodHits = 0;
    let stagingHits = 0;
    for (const c of payload.containers){
        const id = c.container?.containerId;
        if (!id) continue;
        if (prodUuids.has(id)) prodHits++;
        if (stagingUuids.has(id)) stagingHits++;
    }
    if (prodHits === 0 && stagingHits === 0) return null;
    return prodHits >= stagingHits ? 'prod' : 'staging';
};
const $0de16cf0cbdeac18$var$getAtlassianIdBaseUrl = (env)=>$0de16cf0cbdeac18$var$ATLASSIAN_ID_BASE_URLS[env];
const $0de16cf0cbdeac18$var$getContainerMap = (env)=>$0de16cf0cbdeac18$var$CONTAINER_MAPS[env];
const $0de16cf0cbdeac18$export$50ff30f26c11fe5f = async (aaId, { forceRefresh: forceRefresh = false } = {})=>{
    if (!aaId) return null;
    try {
        const response = await (0, $abk4V.fetchAccountsByAaId)({
            aaid: aaId,
            // When `forceRefresh` is true, bypass the cache (always hit the
            // gateway). Otherwise, prefer cached values over the network when
            // they are still warm — the post-office banner re-mounts on most
            // navigation events and we don't want to thrash the gateway.
            onlyRefreshIfExpired: !forceRefresh,
            returnExpired: true
        });
        if (!response || !Array.isArray(response.containers)) return null;
        return response;
    } catch  {
        return null;
    }
};
const $0de16cf0cbdeac18$export$6d3a2e8837b79055 = (payload, productKey, env)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return false;
    // Prefer the env we detect from the payload itself (deterministic — the
    // gateway can only return UUIDs from one env at a time). Fall back to
    // hostname-based detection only if the payload contains no recognised
    // UUIDs in either map (defensive — should be unreachable since the
    // gateway always returns at least the user's atlassian-token-service-key
    // container, plus any Smart Link grants).
    const resolvedEnv = env ?? $0de16cf0cbdeac18$export$d73c6d475285293(payload) ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    const mapping = $0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return false;
    const matchingContainer = payload.containers.find((c)=>c.container?.containerId === mapping.containerId);
    if (!matchingContainer) return false;
    const services = Array.isArray(matchingContainer.services) ? matchingContainer.services : [];
    // Filter services by the expected serviceKey. For unique-container
    // providers this is a no-op (one service per container). For shared
    // containers it ensures we only look at accounts owned by the right
    // service.
    const matchingServices = services.filter((s)=>s.service?.serviceKey === mapping.serviceKey);
    return matchingServices.some((s)=>(Array.isArray(s.accounts) ? s.accounts : []).some((account)=>account.status === 'available'));
};
const $0de16cf0cbdeac18$export$8acaf25597d6f4b9 = (productKey, env)=>{
    const resolvedEnv = env ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    const mapping = $0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return null;
    const baseUrl = $0de16cf0cbdeac18$var$getAtlassianIdBaseUrl(resolvedEnv);
    const params = new URLSearchParams({
        serviceKey: mapping.serviceKey,
        containerId: mapping.containerId
    });
    if (mapping.defaultScopes?.length) params.set('scopes', mapping.defaultScopes.join(' '));
    // URLSearchParams encodes spaces as '+'; gateway expects RFC 3986 '%20'.
    return `${baseUrl}/outboundAuth/start?${params.toString().replace(/\+/g, '%20')}`;
};
const $0de16cf0cbdeac18$export$27e6019a895f8241 = (productKey, env)=>{
    const resolvedEnv = env ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    return Boolean($0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey]);
};
module.exports["detectEnvFromPayload"] = $0de16cf0cbdeac18$export$d73c6d475285293;
module.exports["fetchOutboundAuthAccounts"] = $0de16cf0cbdeac18$export$50ff30f26c11fe5f;
module.exports["isAuthenticatedForProduct"] = $0de16cf0cbdeac18$export$6d3a2e8837b79055;
module.exports["buildSmartLinkAuthUrl"] = $0de16cf0cbdeac18$export$8acaf25597d6f4b9;
module.exports["hasSmartLinkContainerMapping"] = $0de16cf0cbdeac18$export$27e6019a895f8241;

});

parcelRegister("d0O3C", function(module, exports) {

var $78z3f = parcelRequire("78z3f");

const $d64c569546f31d6e$export$9a80c24535b38e83 = 'confluence_3p_smartlink_connection_link_count';
const $d64c569546f31d6e$export$d02d73057c4016d5 = 'confluence_3p_smartlink_connection_link_count_by_team_type_';
const $d64c569546f31d6e$var$SUFFICIENCY_THRESHOLD = 20;
const $d64c569546f31d6e$export$545eb843b77efaec = 3;
const $d64c569546f31d6e$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $d64c569546f31d6e$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $d64c569546f31d6e$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
};
const $d64c569546f31d6e$export$db8c8b18ca3de852 = 'na';
const $d64c569546f31d6e$var$APP_ID_TO_PRODUCT_KEY_ALIASES = {
    drive: (0, $78z3f.ProductKeys3P).GoogleDrive,
    figma: (0, $78z3f.ProductKeys3P).Figma,
    github: (0, $78z3f.ProductKeys3P).Github,
    'google-drive': (0, $78z3f.ProductKeys3P).GoogleDrive,
    onedrive: (0, $78z3f.ProductKeys3P).OneDrive,
    sharepoint: (0, $78z3f.ProductKeys3P).Sharepoint,
    slack: (0, $78z3f.ProductKeys3P).Slack
};
const $d64c569546f31d6e$export$acda930d8972381e = (raw)=>{
    if (!raw || raw.trim().length === 0) return [];
    return raw.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0).map((entry)=>{
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex <= 0 || separatorIndex === entry.length - 1) return undefined;
        const appId = entry.slice(0, separatorIndex).trim();
        const count = Number(entry.slice(separatorIndex + 1).trim());
        if (appId.length === 0 || !Number.isFinite(count)) return undefined;
        return {
            appId: appId,
            count: count
        };
    }).filter((entry)=>entry !== undefined);
};
const $d64c569546f31d6e$export$fe68bf06dd562208 = (parsed)=>parsed.map((entry, index)=>({
            ...entry,
            index: index
        })).filter((entry)=>entry.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.index - b.index;
    }).map((entry)=>entry.appId);
const $d64c569546f31d6e$export$f9f1f4a4ade7c6e2 = (appId)=>{
    return $d64c569546f31d6e$var$APP_ID_TO_PRODUCT_KEY_ALIASES[appId.toLowerCase()];
};
const $d64c569546f31d6e$export$551da10284cad191 = (apps)=>apps.map($d64c569546f31d6e$export$f9f1f4a4ade7c6e2).filter((productKey)=>productKey !== undefined);
const $d64c569546f31d6e$export$7cc148373d70b178 = (existing, incoming, max)=>{
    const result = [];
    const seen = new Set();
    for (const productKey of [
        ...existing,
        ...incoming
    ])if (!seen.has(productKey)) {
        seen.add(productKey);
        result.push(productKey);
        if (result.length >= max) return result;
    }
    return result;
};
const $d64c569546f31d6e$export$5d0c03a62d0c5b9f = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts, teamTypeKey: teamTypeKey } = {}, maxRecommendedApps = $d64c569546f31d6e$export$545eb843b77efaec, options = {})=>{
    let productKeys = [];
    // Tier 1 — per-team-type TAP trait, gated on sufficiency.
    //
    // The sufficiency check is intentionally performed against the raw
    // (pre-filter) sum: it reflects whether the site as a whole has enough
    // activity for this team type to trust the signal, independent of which
    // apps we happen to support today. Only positive counts contribute so a
    // malformed TAP row with negatives (`"github:50, x:-40"`) cannot drag the
    // total below the threshold.
    const teamTypeParsed = $d64c569546f31d6e$export$acda930d8972381e(teamTypeSmartlinkAppCounts);
    const teamTypePositiveSum = teamTypeParsed.reduce((sum, entry)=>sum + Math.max(0, entry.count), 0);
    if (teamTypePositiveSum >= $d64c569546f31d6e$var$SUFFICIENCY_THRESHOLD) productKeys = $d64c569546f31d6e$export$7cc148373d70b178([], $d64c569546f31d6e$export$551da10284cad191($d64c569546f31d6e$export$fe68bf06dd562208(teamTypeParsed)), maxRecommendedApps);
    // Tier 2 — site-wide TAP trait backfill.
    if (productKeys.length < maxRecommendedApps) {
        const siteWideParsed = $d64c569546f31d6e$export$acda930d8972381e(siteWideSmartlinkAppCounts);
        productKeys = $d64c569546f31d6e$export$7cc148373d70b178(productKeys, $d64c569546f31d6e$export$551da10284cad191($d64c569546f31d6e$export$fe68bf06dd562208(siteWideParsed)), maxRecommendedApps);
    }
    // Tier 3 — HARDCODED_DEFAULTS for the user's team type.
    //
    // If the caller didn't pass a teamTypeKey, or passed one we don't have
    // a curated row for, fall through to the `na` row. Because
    // HARDCODED_DEFAULTS.na references DEFAULT_FALLBACK_APPS by identity,
    // this single tier covers both the team-type-known case and the
    // "no signal at all" floor — no separate Tier 4 is needed.
    //
    // Skipped when `options.traitOnly` is set so animation callers (which
    // have their own department-based fallback) can distinguish "real signal"
    // from "cold-start defaults".
    if (!options.traitOnly && productKeys.length < maxRecommendedApps) {
        const tier3AppIds = (teamTypeKey ? $d64c569546f31d6e$export$5dbf4404d8d730eb[teamTypeKey] : undefined) ?? $d64c569546f31d6e$export$5dbf4404d8d730eb[$d64c569546f31d6e$export$db8c8b18ca3de852] ?? [];
        productKeys = $d64c569546f31d6e$export$7cc148373d70b178(productKeys, $d64c569546f31d6e$export$551da10284cad191(tier3AppIds), maxRecommendedApps);
    }
    return productKeys;
};
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_TRAIT"] = $d64c569546f31d6e$export$9a80c24535b38e83;
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_BY_TEAM_TYPE_TRAIT_PREFIX"] = $d64c569546f31d6e$export$d02d73057c4016d5;
module.exports["DEFAULT_FALLBACK_APPS"] = $d64c569546f31d6e$export$8594dab83de99a34;
module.exports["parseAppCounts"] = $d64c569546f31d6e$export$acda930d8972381e;
module.exports["canonicalizeAppIdToProductKey"] = $d64c569546f31d6e$export$f9f1f4a4ade7c6e2;
module.exports["resolveRecommendedProductKeys"] = $d64c569546f31d6e$export$5d0c03a62d0c5b9f;

});

parcelRegister("7J0mn", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8b49379c5d937849$export$6b7fb3a1c8e98eb5 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("712CL")));

const $8b49379c5d937849$export$c0196c29b1811a8e = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3mLjZ")));

const $8b49379c5d937849$export$ce2899c234bb1e82 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jxslc")));

const $8b49379c5d937849$export$61337663f5eaf5c2 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3WyTD")));

const $8b49379c5d937849$export$4bcbb897e0641d3 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fpOVu")));



var $d0O3C = parcelRequire("d0O3C");

const $e9197596153e89d9$export$a02c2a50480baf7b = [
    'figma',
    'github',
    'slack',
    'google-drive',
    'onedrive'
];
const $e9197596153e89d9$export$7cd9f89abe222b98 = [
    'design',
    'product_management',
    'marketing',
    'engineering',
    'information_technology',
    'other',
    'operations',
    'finance',
    'legal',
    'human_resources',
    'na',
    'program_management',
    'sales'
];
const $e9197596153e89d9$var$DEPARTMENTS = new Set($e9197596153e89d9$export$7cd9f89abe222b98);
const $e9197596153e89d9$var$PRODUCT_KEY_TO_ANIMATION_APP = {
    figma: 'figma',
    drive: 'google-drive',
    github: 'github',
    onedrive: 'onedrive',
    slack: 'slack'
};
const $e9197596153e89d9$var$isAnimationProductKey = (productKey)=>Object.prototype.hasOwnProperty.call($e9197596153e89d9$var$PRODUCT_KEY_TO_ANIMATION_APP, productKey);
const $e9197596153e89d9$var$filterParsedAppCountsToVisibleProductKeys = (rawAppCounts, visibleProductKeys)=>(0, $d0O3C.parseAppCounts)(rawAppCounts).filter((entry)=>{
        const productKey = (0, $d0O3C.canonicalizeAppIdToProductKey)(entry.appId);
        return productKey !== undefined && visibleProductKeys.has(productKey);
    });
const $e9197596153e89d9$var$serializeAppCounts = (parsed)=>parsed.map(({ appId: appId, count: count })=>`${appId}:${count}`).join(',');
const $e9197596153e89d9$var$resolveVisibleTraitRecommendedProductKeys = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts } = {}, visibleProductKeys)=>{
    const visibleProductKeySet = new Set(visibleProductKeys.map((productKey)=>(0, $d0O3C.canonicalizeAppIdToProductKey)(productKey) ?? productKey));
    if (visibleProductKeySet.size === 0) return [];
    // Filtering first lets the existing resolver recompute the team-type
    // threshold on only visible apps while preserving site-wide backfill.
    return (0, $d0O3C.resolveRecommendedProductKeys)({
        siteWideSmartlinkAppCounts: $e9197596153e89d9$var$serializeAppCounts($e9197596153e89d9$var$filterParsedAppCountsToVisibleProductKeys(siteWideSmartlinkAppCounts, visibleProductKeySet)),
        teamTypeSmartlinkAppCounts: $e9197596153e89d9$var$serializeAppCounts($e9197596153e89d9$var$filterParsedAppCountsToVisibleProductKeys(teamTypeSmartlinkAppCounts, visibleProductKeySet))
    }, visibleProductKeySet.size, {
        traitOnly: true
    });
};
const $e9197596153e89d9$export$5ea506cfb5216de9 = ({ connectorProductKeys: connectorProductKeys, smartlinkConnectorRecommendationInputs: smartlinkConnectorRecommendationInputs, teamTypeKey: teamTypeKey })=>{
    let candidateProductKeys;
    if (connectorProductKeys !== undefined) // Visible connector product keys constrain the animation candidate set,
    // but TAP traits still decide the ranking within that visible set.
    // Tier 3 HARDCODED_DEFAULTS are intentionally excluded so weak or
    // missing visible-app trait data can fall through to department mapping.
    candidateProductKeys = $e9197596153e89d9$var$resolveVisibleTraitRecommendedProductKeys(smartlinkConnectorRecommendationInputs, connectorProductKeys);
    else // When there is no explicit connector app list, animation picks the
    // highest-priority recommended app ONLY when that app comes from real
    // TAP-trait signal (Tier 1 or Tier 2). We use the `traitOnly` option to
    // opt out of Tier 3 HARDCODED_DEFAULTS, because the department-based
    // animation fallback below already encodes the same team-type-curated
    // mapping in a more visually-coherent way (e.g. engineering animates
    // GitHub directly via the department switch even though Tier 3 would
    // also pick GitHub as the engineering default). Letting Tier 3 fire
    // here would always return non-empty results and rob the department
    // branch of ever running for cold-start tenants.
    candidateProductKeys = (0, $d0O3C.resolveRecommendedProductKeys)(smartlinkConnectorRecommendationInputs, undefined, {
        traitOnly: true
    });
    const firstSupportedAnimationProductKey = candidateProductKeys.find($e9197596153e89d9$var$isAnimationProductKey);
    const topApp = firstSupportedAnimationProductKey ? $e9197596153e89d9$var$PRODUCT_KEY_TO_ANIMATION_APP[firstSupportedAnimationProductKey] : undefined;
    return {
        topApps: topApp ? [
            topApp
        ] : [],
        department: teamTypeKey && $e9197596153e89d9$var$DEPARTMENTS.has(teamTypeKey) ? teamTypeKey : undefined
    };
};
function $e9197596153e89d9$var$getAnimationSvgForApp(app) {
    switch(app){
        case 'figma':
            return 0, $8b49379c5d937849$export$6b7fb3a1c8e98eb5;
        case 'github':
            return 0, $8b49379c5d937849$export$ce2899c234bb1e82;
        case 'slack':
            return 0, $8b49379c5d937849$export$4bcbb897e0641d3;
        case 'google-drive':
            return 0, $8b49379c5d937849$export$c0196c29b1811a8e;
        case 'onedrive':
            return 0, $8b49379c5d937849$export$61337663f5eaf5c2;
    }
}
function $e9197596153e89d9$export$fdb84c48733d7de8({ topApps: topApps, department: department }) {
    // Step 1: return the SVG for the highest-priority app if any are provided.
    // topApps is pre-filtered to AnimationApp values, so every element has a
    // dedicated SVG — we just take the first one.
    if (topApps && topApps.length > 0) return $e9197596153e89d9$var$getAnimationSvgForApp(topApps[0]);
    // Step 2: department-based fallback
    if (department) switch(department){
        case 'design':
        case 'product_management':
        case 'marketing':
            return 0, $8b49379c5d937849$export$6b7fb3a1c8e98eb5;
        case 'engineering':
        case 'information_technology':
            return 0, $8b49379c5d937849$export$ce2899c234bb1e82;
        case 'other':
        case 'operations':
            return 0, $8b49379c5d937849$export$4bcbb897e0641d3;
        case 'finance':
        case 'legal':
        case 'human_resources':
        case 'na':
        case 'program_management':
        case 'sales':
            return 0, $8b49379c5d937849$export$c0196c29b1811a8e;
    }
    // Final fallback: Google Drive (matches the original hardcoded SvgTeamUpdate)
    return 0, $8b49379c5d937849$export$c0196c29b1811a8e;
}
module.exports["ANIMATION_APP_KEYS"] = $e9197596153e89d9$export$a02c2a50480baf7b;
module.exports["DEPARTMENT_KEYS"] = $e9197596153e89d9$export$7cd9f89abe222b98;
module.exports["resolveAnimationInputs"] = $e9197596153e89d9$export$5ea506cfb5216de9;
module.exports["getAnimationSvg"] = $e9197596153e89d9$export$fdb84c48733d7de8;

});

parcelRegister("712CL", function(module, exports) {

let $51baa9883100e69c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51baa9883100e69c$var$load("6xnQl").then(()=>parcelRequire('nFWod'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3mLjZ", function(module, exports) {

let $273822332f7938ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $273822332f7938ce$var$load("4YBc7").then(()=>parcelRequire('2UZcb'));

});

parcelRegister("jxslc", function(module, exports) {

let $e397154ae7b74c1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e397154ae7b74c1f$var$load("74KCn").then(()=>parcelRequire('eG9jh'));

});

parcelRegister("3WyTD", function(module, exports) {

let $2df1db94ab0c5aef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2df1db94ab0c5aef$var$load("9Alkx").then(()=>parcelRequire('dNnPQ'));

});

parcelRegister("fpOVu", function(module, exports) {

let $b390b1b55a576e63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b390b1b55a576e63$var$load("huFh2").then(()=>parcelRequire('jHguh'));

});

parcelRegister("kpbJr", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $lAFHW = parcelRequire("lAFHW");


var $6f0Oj = parcelRequire("6f0Oj");

var $cwkWT = parcelRequire("cwkWT");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $291hi = parcelRequire("291hi");

var $bWLcG = parcelRequire("bWLcG");


var $2oc5y = parcelRequire("2oc5y");


var $jP23Y = parcelRequire("jP23Y");

const $a65d01ef02cf06ae$var$styles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $a65d01ef02cf06ae$var$dynamicComponentEdgeToEdgeStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%'
});
const $a65d01ef02cf06ae$var$imageContainerStyles = (0, $ecnYn.xcss)({
    display: 'none',
    [(0, $bWLcG.media).above.sm]: {
        overflow: 'hidden',
        display: 'block'
    }
});
const $a65d01ef02cf06ae$var$formStyles = (0, $ecnYn.xcss)({
    padding: 'space.600'
});
const $a65d01ef02cf06ae$var$gridStyles = (0, $ecnYn.xcss)({
    gridTemplateColumns: '1fr',
    height: '100%',
    [(0, $bWLcG.media).above.sm]: {
        gridTemplateColumns: '1fr 1fr'
    }
});
const $a65d01ef02cf06ae$var$leftSectionStyles = (0, $ecnYn.xcss)({
    minHeight: '0px',
    overflowY: 'auto'
});
const $a65d01ef02cf06ae$var$updatedStyles = {
    headingContainer: "_n3tdu2gc"
};
const $a65d01ef02cf06ae$export$c3b4cf34b667dcac = ({ applyUpdatedLayout: applyUpdatedLayout = false, title: title, subtitle: subtitle, screen: screen, imageComponent: Image, dynamicComponent: dynamicComponent, isDynamicComponentEdgeToEdge: isDynamicComponentEdgeToEdge = false, imageAlt: imageAlt, footer: footer, children: children, hideLogo: hideLogo = false })=>{
    const layoutProps = {
        title: title,
        subtitle: subtitle,
        screen: screen,
        children: children,
        hideLogo: hideLogo
    };
    const shouldApplyAriaHidden = (0, $c6GJD.default).getExperimentValue('cc_activation_a11y_fixes', 'isEnabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        xcss: $a65d01ef02cf06ae$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        spread: "space-between",
        space: "space.400",
        xcss: [
            $a65d01ef02cf06ae$var$formStyles,
            $a65d01ef02cf06ae$var$leftSectionStyles
        ]
    }, applyUpdatedLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a65d01ef02cf06ae$var$UpdatedLayout, layoutProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a65d01ef02cf06ae$var$OldLayout, layoutProps), footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $291hi.Hide), {
        below: "sm",
        xcss: $a65d01ef02cf06ae$var$imageContainerStyles
    }, Image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Image, {
        viewBox: "0 0 565 665",
        title: imageAlt,
        "aria-label": imageAlt,
        preserveAspectRatio: "xMinYMid slice",
        width: "100%",
        height: "100%",
        ...!imageAlt && {
            'aria-hidden': true,
            role: 'presentation'
        }
    }), !!dynamicComponent && !Image && (isDynamicComponentEdgeToEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "split-screen-dynamic-component-wrapper",
        xcss: $a65d01ef02cf06ae$var$dynamicComponentEdgeToEdgeStyles
    }, dynamicComponent) : shouldApplyAriaHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        "aria-hidden": "true",
        testId: "split-screen-dynamic-component-wrapper",
        xcss: $a65d01ef02cf06ae$var$dynamicComponentEdgeToEdgeStyles
    }, dynamicComponent) : dynamicComponent)));
};
const $a65d01ef02cf06ae$var$OldLayout = ({ title: title, subtitle: subtitle, screen: screen, children: children, hideLogo: hideLogo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.400"
    }, !hideLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceLogo), {
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: hideLogo ? 'space.200' : 'space.100'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oc5y.Heading), {
        size: "xlarge",
        testId: `${screen}-heading`,
        id: `${screen}-heading`
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jP23Y.Text), {
        color: "color.text.subtle"
    }, subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a65d01ef02cf06ae$var$styles
    }, children)));
const $a65d01ef02cf06ae$var$UpdatedLayout = ({ title: title, subtitle: subtitle, screen: screen, children: children, hideLogo: hideLogo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.400"
    }, !hideLogo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceLogo), {
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: hideLogo ? 'space.200' : 'space.100',
        xcss: (0, $1Whri.cx)($a65d01ef02cf06ae$var$updatedStyles.headingContainer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2oc5y.Heading), {
        size: "xlarge",
        testId: `${screen}-heading`,
        id: `${screen}-heading`
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jP23Y.Text), {
        color: "color.text.subtle"
    }, subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a65d01ef02cf06ae$var$styles
    }, children))));
module.exports["SplitScreen"] = $a65d01ef02cf06ae$export$c3b4cf34b667dcac;

});

parcelRegister("2oc5y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cO1el = parcelRequire("cO1el");


var $7iqHL = parcelRequire("7iqHL");

const $e7a066f1bc668853$var$marketingHeadingStyles = null;
const $e7a066f1bc668853$export$a8a3e93435678ff9 = ({ ...rest })=>{
    const { product: product } = (0, $7iqHL.useProductContext)();
    if (product === 'marketing') return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_p0ov15f2"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), rest));
    return /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), rest);
};
module.exports["Heading"] = $e7a066f1bc668853$export$a8a3e93435678ff9;

});

parcelRegister("7iqHL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");

const $efe3e21079c040a0$var$ProductContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $efe3e21079c040a0$export$4605adbeec93a222 = ({ product: product, children: children })=>/*#__PURE__*/ $42omo.createElement($efe3e21079c040a0$var$ProductContext.Provider, {
        value: {
            product: product
        }
    }, children);
const $efe3e21079c040a0$export$b5aab9e12d92574f = ()=>{
    const context = (0, $42omo.useContext)($efe3e21079c040a0$var$ProductContext);
    const defaultContext = {
        product: 'confluence'
    };
    if (!context) // Would be better to throw an error here, but some Confluence packages import this component and don't wrap it in a context provider.
    return defaultContext;
    return context;
};
module.exports["ProductContextProvider"] = $efe3e21079c040a0$export$4605adbeec93a222;
module.exports["useProductContext"] = $efe3e21079c040a0$export$b5aab9e12d92574f;

});

parcelRegister("jP23Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iXCQx = parcelRequire("iXCQx");


var $7iqHL = parcelRequire("7iqHL");

const $f1a80a87d13c4865$var$marketingTextStyles = null;
const $f1a80a87d13c4865$var$marketingTextSizes = {
    UNSAFE_small: "_1n10mccc",
    small: "_1n10mccc",
    medium: "_1n10wk7l",
    large: "_1n101gpt"
};
const $f1a80a87d13c4865$export$5f1af8db9871e1d6 = ({ size: size, ...rest })=>{
    const { product: product } = (0, $7iqHL.useProductContext)();
    if (product === 'marketing') return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_p0ov35zn",
            size && $f1a80a87d13c4865$var$marketingTextSizes[size]
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), rest));
    return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        size: size,
        ...rest
    });
};
module.exports["Text"] = $f1a80a87d13c4865$export$5f1af8db9871e1d6;

});

parcelRegister("eZjNP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $8y5oM = parcelRequire("8y5oM");

const $54ea054a5df3d7bf$var$styles = {
    container: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x",
    row: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _1doce4h9 _1il9nqa1 _1o3i1l7x",
    rowLast: "_1il9glyw"
};
const $54ea054a5df3d7bf$export$136740b583f35b01 = ({ connectorResources: connectorResources, isPrimaryButton: isPrimaryButton, onConnectorAuthSuccess: onConnectorAuthSuccess, onConnectorConnected: onConnectorConnected, screenName: screenName, touchpoint: touchpoint })=>{
    const connectorItems = connectorResources.map((resource)=>({
            key: resource.productKey,
            props: {
                connectorInfo: resource,
                isPrimaryButton: isPrimaryButton,
                screenName: screenName,
                onConnected: ()=>{
                    onConnectorAuthSuccess?.(resource.productKey);
                    onConnectorConnected?.(resource.productKey);
                },
                touchpoint: touchpoint
            }
        }));
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($54ea054a5df3d7bf$var$styles.container)
    }, connectorItems.map((item, index)=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            key: item.key,
            xcss: (0, $1Whri.cx)($54ea054a5df3d7bf$var$styles.row, index === connectorItems.length - 1 && $54ea054a5df3d7bf$var$styles.rowLast)
        }, /*#__PURE__*/ $42omo.createElement((0, $8y5oM.ThirdPartyConnector), item.props))));
};
module.exports["ThirdPartyConnectorList"] = $54ea054a5df3d7bf$export$136740b583f35b01;

});

parcelRegister("eB1TF", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $9zUhf.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $9zUhf.createActionsHook)($bf0e479659c73d50$var$Store);
module.exports["useUniversalCreateState"] = $bf0e479659c73d50$export$c7381b2490bb4d36;
module.exports["useUniversalCreateActions"] = $bf0e479659c73d50$export$6c5b9a107b000099;

});

parcelRegister("b4fs3", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500 = 'nav4CollapseReminderSpotlight';
const $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1 = (0, $aXWIB.defineMessages)({
    heading: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.heading",
        defaultMessage: "Want to hide the sidebar?"
    },
    body: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.body",
        defaultMessage: "Select the collapse icon in the top left of your screen. You can expand it again at any time."
    },
    dismissButton: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.dismiss",
        defaultMessage: "OK"
    }
});
const $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2 = (setIsNav4CollapseReminderSpotlightActive)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const dismissSpotlight = ()=>{
        // Fire analytics event
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'done',
                source: $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500
            }
        }).fire();
        // Hide the spotlight
        setIsNav4CollapseReminderSpotlightActive(false);
        // Mark as dismissed in onboarding state
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED),
            value: new Date().toISOString()
        });
    };
    return {
        dismissSpotlight: dismissSpotlight
    };
};
module.exports["NAV_4_COLLAPSE_REMINDER_SOURCE"] = $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500;
module.exports["nav4CollapseReminderI18n"] = $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1;
module.exports["useNav4CollapseReminderDismissal"] = $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2;

});

parcelRegister("eaL9e", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $7boqA = parcelRequire("7boqA");


var $8w1c1 = parcelRequire("8w1c1");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $hAiCi = parcelRequire("hAiCi");





var $aXWIB = parcelRequire("aXWIB");


var $5izcQ = parcelRequire("5izcQ");


var $8zs3p = parcelRequire("8zs3p");


var $e1eDr = parcelRequire("e1eDr");


var $2SvFZ = parcelRequire("2SvFZ");


var $dTIqH = parcelRequire("dTIqH");

var $idPUB = parcelRequire("idPUB");

var $9vGun = parcelRequire("9vGun");


var $inPa6 = parcelRequire("inPa6");


var $bedQP = parcelRequire("bedQP");








var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");


var $iXCQx = parcelRequire("iXCQx");


var $b4fs3 = parcelRequire("b4fs3");

const $e0356f01208b13d1$export$6cddb4d20889bca4 = ({ children: children, isVisible: isVisible, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { dismissSpotlight: dismissSpotlight } = (0, $b4fs3.useNav4CollapseReminderDismissal)(setIsNav4CollapseReminderSpotlightActive);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isVisible,
        placement: "right-end",
        dismiss: dismissSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "nav4-collapse-reminder-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismissSpotlight
    }, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).dismissButton)))))));
};



var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $kvJHJ = parcelRequire("kvJHJ");





var $kVysQ = parcelRequire("kVysQ");


var $4NX9d = parcelRequire("4NX9d");


var $de2j9 = parcelRequire("de2j9");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");








var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


const $1e0f0aa871cc51c1$var$EditionAwarenessLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "v8ebQ",
    name: "EditionAwarenessLoadable",
    loader: async ()=>(await (parcelRequire("77oON"))).EditionAwareness
});
const $1e0f0aa871cc51c1$export$a55b02efe3d62583 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_TRANSMUTERS
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e0f0aa871cc51c1$var$EditionAwarenessLoadable, null);
});



var $9wGTI = parcelRequire("9wGTI");


var $c5zvz = parcelRequire("c5zvz");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $78QFu = parcelRequire("78QFu");


var $1xpoY = parcelRequire("1xpoY");


var $eBBZq = parcelRequire("eBBZq");


var $1B659 = parcelRequire("1B659");

/* SiteLogoButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");








var $lAFHW = parcelRequire("lAFHW");


var $2rzyy = parcelRequire("2rzyy");

var $iG5N1 = parcelRequire("iG5N1");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $1NBp8 = parcelRequire("1NBp8");


var $gz8ZY = parcelRequire("gz8ZY");


const $760ef9e13b699b30$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("8DSzV"))).fireLogoClickedAnalytics);
const $760ef9e13b699b30$var$customLogo = null;
const $760ef9e13b699b30$export$48df75a983e1f3fb = ({ siteConfiguration: siteConfiguration, siteSettings: siteSettings, siteDescription: siteDescription, onLoadCustomLogo: onLoadCustomLogo })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = $760ef9e13b699b30$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    const siteTitle = siteSettings && siteSettings.siteTitle;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const CustomNavLogo = (0, $42omo.useMemo)(()=>{
        if (siteConfiguration?.customSiteLogo && siteDescription?.logoUrl) {
            if (isNav4Enabled) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl ?? undefined,
                    onLoad: onLoadCustomLogo
                });
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl ?? undefined,
                    onLoad: onLoadCustomLogo,
                    className: (0, $gMc0m.default)([
                        "_1bsb1f4h _4t3i1f4h"
                    ])
                });
        }
        return null;
    }, [
        isNav4Enabled,
        onLoadCustomLogo,
        siteConfiguration?.customSiteLogo,
        siteDescription?.logoUrl
    ]);
    return CustomNavLogo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iG5N1.CustomLogo), {
        label: siteTitle ?? 'Confluence',
        logo: CustomNavLogo,
        icon: CustomNavLogo,
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2rzyy.AppLogo), {
        label: siteTitle ?? 'Confluence',
        icon: (0, $lAFHW.ConfluenceIcon),
        name: "Confluence",
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    });
};





/**
 * @generated SignedSource<<2820f5d0c8576a9e81d4c4fa8e69af88>>
 * @relayHash 07605b0f94d6bfbf5c86ce6f43ee8794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e
const $4442fad673926b38$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v1 = {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ]
        },
        "params": {
            "cacheID": "07605b0f94d6bfbf5c86ce6f43ee8794",
            "id": "be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e",
            "metadata": {},
            "name": "HelpButtonQuery",
            "operationKind": "query",
            "text": "query HelpButtonQuery{user:confluence_atlassianUser(current:true){emails{value},id}}"
        }
    };
}();
$4442fad673926b38$var$node.hash = "ea68606a14f00f692f5d23a208b10f51";
var $4442fad673926b38$export$2e2bcd8739ae039 = $4442fad673926b38$var$node;












var $6xdDU = parcelRequire("6xdDU");


var $hOWPZ = parcelRequire("hOWPZ");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");


var $14QAi = parcelRequire("14QAi");


var $dIDyF = parcelRequire("dIDyF");


var $56QzY = parcelRequire("56QzY");





var $1kHsc = parcelRequire("1kHsc");





var $6GD8y = parcelRequire("6GD8y");





var $bQIml = parcelRequire("bQIml");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $bnxm6 = parcelRequire("bnxm6");

const $c7ca3b61d6326579$export$e89f639882b1384b = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.SYSTEM_HELP)
        }),
        (0, $dYU3e.query)({
            query: (0, $bnxm6.default)
        })
    ]);
};



var $efvKr = parcelRequire("efvKr");








var $3fBqY = parcelRequire("3fBqY");


var $8aF6s = parcelRequire("8aF6s");


var $6wrL8 = parcelRequire("6wrL8");

const $48d2632049a03f8d$var$HelpButtonQuery = (0, $4442fad673926b38$export$2e2bcd8739ae039);
const $48d2632049a03f8d$export$78bddedbcf2939ac = ()=>{
    const $ = (0, $frIzR.c)(38);
    const triggerButtonRef = (0, $42omo.useRef)(null);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const inProductHelp = (0, $cLgYq.useInProductHelpActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== rightSidebarContext) {
        t0 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t0;
    } else t0 = $[1];
    const isHelpPanelOpen = t0 === (0, $dIDyF.HELP_PANEL_ID);
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($48d2632049a03f8d$var$HelpButtonQuery, {
        __callerPackage__: "@confluence/app-navigation"
    });
    let t2;
    if ($[2] !== data) {
        t2 = (0, $3fBqY.isAtlassianStaff)(data);
        $[2] = data;
        $[3] = t2;
    } else t2 = $[3];
    const isInternalAtlassianUser = t2;
    const [activeDialog, setActiveDialog] = (0, $42omo.useState)(null);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== experienceTracker || $[6] !== inProductHelp || $[7] !== isHelpPanelOpen || $[8] !== rightSidebarContext || $[9] !== routeData.current?.href || $[10] !== routeData.current?.routeName) {
        t3 = ()=>{
            if (isHelpPanelOpen) rightSidebarContext.close((0, $dIDyF.HELP_PANEL_ID));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                    attributes: {
                        navVersion: "4"
                    }
                });
                rightSidebarContext.open((0, $dIDyF.HELP_PANEL_ID), (0, $dIDyF.HELP_PANEL_WIDTH));
                rightSidebarContext.setTriggerButtonRef?.(triggerButtonRef);
                const { routeName: routeName, routeGroup: routeGroup } = (0, $14QAi.getRouteData)(routeData.current?.href || "");
                inProductHelp.setRouteName(routeName);
                inProductHelp.setRouteGroup(routeGroup);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "help",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = experienceTracker;
        $[6] = inProductHelp;
        $[7] = isHelpPanelOpen;
        $[8] = rightSidebarContext;
        $[9] = routeData.current?.href;
        $[10] = routeData.current?.routeName;
        $[11] = t3;
    } else t3 = $[11];
    const onClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setActiveDialog(null);
        };
        $[12] = t4;
    } else t4 = $[12];
    const closeDialog = t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[13] = t5;
    } else t5 = $[13];
    const openDialog = t5;
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>openDialog($48d2632049a03f8d$var$_temp);
        $[14] = t6;
    } else t6 = $[14];
    const openShortcutsDialog = t6;
    let t7;
    if ($[15] !== showModal) {
        t7 = ()=>{
            showModal((0, $6wrL8.DevToolsDialog), {});
        };
        $[15] = showModal;
        $[16] = t7;
    } else t7 = $[16];
    const openDevToolsDialog = t7;
    const preloadMenu = $48d2632049a03f8d$var$_temp2;
    let t8;
    if ($[17] !== intl) {
        t8 = intl.formatMessage($48d2632049a03f8d$var$i18n.help);
        $[17] = intl;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isHelpPanelOpen || $[20] !== onClick || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hOWPZ.Help), {
            onClick: onClick,
            label: t8,
            isSelected: isHelpPanelOpen,
            ref: triggerButtonRef
        }));
        $[19] = isHelpPanelOpen;
        $[20] = onClick;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isLiveEditMode || $[24] !== isOnEditRoute) {
        t10 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_HELP_SHORTCUT) : [
            (0, $gnkil.HELP_SHORTCUT),
            (0, $gnkil.UNIVERSAL_HELP_SHORTCUT)
        ];
        $[23] = isLiveEditMode;
        $[24] = isOnEditRoute;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: t10,
            listener: openShortcutsDialog,
            isAppNavigationShortcut: true
        });
        $[26] = t10;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== isInternalAtlassianUser || $[29] !== openDevToolsDialog) {
        t12 = isInternalAtlassianUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT),
            listener: openDevToolsDialog,
            isAppNavigationShortcut: true,
            allowInDialog: true
        });
        $[28] = isInternalAtlassianUser;
        $[29] = openDevToolsDialog;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== activeDialog) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activeDialog);
        $[31] = activeDialog;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t11, t12, t13);
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t9;
        $[37] = t14;
    } else t14 = $[37];
    return t14;
};
const $48d2632049a03f8d$var$i18n = (0, $aXWIB.defineMessages)({
    help: {
        id: "app-navigation.top-navigation.help",
        defaultMessage: "Help"
    }
});
function $48d2632049a03f8d$var$_temp(onClose) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bQIml.KeyboardShortcutsDialog), {
        onClose: onClose
    });
}
function $48d2632049a03f8d$var$_temp2() {
    (0, $c7ca3b61d6326579$export$e89f639882b1384b)();
}



var $9MAeh = parcelRequire("9MAeh");














var $9xVAL = parcelRequire("9xVAL");











var $d9tcB = parcelRequire("d9tcB");














var $aXjWU = parcelRequire("aXjWU");

const $f31df34f0e245783$export$d5e80b5916277837 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { id: id, children: children } = t0;
    let t1;
    if ($[0] !== id) {
        t1 = {
            triggerId: id
        };
        $[0] = id;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: fireTrigger } = (0, $aXjWU.useFirePostOfficeTrigger)(t1);
    let t2;
    let t3;
    if ($[2] !== fireTrigger) {
        t2 = ()=>{
            fireTrigger({
                isActive: true
            });
            return ()=>{
                fireTrigger({
                    isActive: false
                });
            };
        };
        t3 = [
            fireTrigger
        ];
        $[2] = fireTrigger;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[5] !== children || $[6] !== id) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: id
        }, children);
        $[5] = children;
        $[6] = id;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};


const $5f8faa2e47e4a6d0$export$e2457e1974c298c3 = ()=>{
    const $ = (0, $frIzR.c)(7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== push || $[2] !== routeData.current?.routeName) {
        t0 = (e)=>{
            const url = (0, $1NBp8.ADMIN_SETTINGS).toUrl();
            if (e.metaKey) window.open(url, "_blank", "noreferrer");
            else push(url);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "settings",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = push;
        $[2] = routeData.current?.routeName;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t1;
    if ($[4] !== isAdmin || $[5] !== onClick) {
        t1 = isAdmin ? (0, $9wGTI.fg)("post-office_ep_migration_inapp_715_nav4") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f31df34f0e245783$export$d5e80b5916277837), {
            id: "ep-migration-inapp-715-target"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xVAL.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $5f8faa2e47e4a6d0$var$i18n.settings)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xVAL.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $5f8faa2e47e4a6d0$var$i18n.settings)
        }) : null;
        $[4] = isAdmin;
        $[5] = onClick;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
const $5f8faa2e47e4a6d0$var$i18n = (0, $aXWIB.defineMessages)({
    settings: {
        id: "app-navigation.top-navigation.settings",
        defaultMessage: "Confluence administration"
    }
});

















const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>{
    return (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER)
    });
};


/**
 * @generated SignedSource<<ce0084368c55148e5ae50d656a24a7d2>>
 * @relayHash 8a5f88c31eae893c420fe6862fbb6c53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3
const $9d6b1a9db83da49f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "creatorAccountIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "creatorAccountIds",
                    "variableName": "creatorAccountIds"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "TRASHED"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "PERSONAL"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8a5f88c31eae893c420fe6862fbb6c53",
            "id": "f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3",
            "metadata": {},
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "operationKind": "query",
            "text": "query AccountMenuTrashedPersonalSpacesQuery($creatorAccountIds:[String!]){spaces(type:\"PERSONAL\",creatorAccountIds:$creatorAccountIds,status:\"TRASHED\"){nodes{alias,key,id}}}"
        }
    };
}();
$9d6b1a9db83da49f$var$node.hash = "441235242490f35c2f56b55ed716011d";
var $9d6b1a9db83da49f$export$2e2bcd8739ae039 = $9d6b1a9db83da49f$var$node;






var $T1bCI = parcelRequire("T1bCI");





var $7rvPL = parcelRequire("7rvPL");








var $9820v = parcelRequire("9820v");


var $hoiF1 = parcelRequire("hoiF1");


var $lSGOy = parcelRequire("lSGOy");

const $67301818cb50b3e2$export$f03eabcc4a75d4f3 = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9820v.LogIn), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $hoiF1.NAVIGATION_CHANNEL));
        },
        label: (0, $lSGOy.logInTooltip)
    });









var $7Ek7o = parcelRequire("7Ek7o");


var $asAwU = parcelRequire("asAwU");


var $lGKVd = parcelRequire("lGKVd");

const $b76fc04bd00366e5$export$83537fb6d03c400d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $aXWIB.useIntl)();
    const state = (0, $asAwU.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $lGKVd.messages).triggerTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Ek7o.Profile), {
        ...props,
        isSelected: props['aria-expanded'],
        ref: ref,
        label: email || tooltip,
        src: trustPicture || state === 'loaded' ? picture : undefined
    });
});



var $4mshv = parcelRequire("4mshv");

const $5842fbd79e33e7af$export$a63b6ac98b2ba9a8 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4mshv.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $67301818cb50b3e2$export$f03eabcc4a75d4f3),
        AccountMenuTrigger: (0, $b76fc04bd00366e5$export$83537fb6d03c400d)
    });
};



var $T9xHm = parcelRequire("T9xHm");





var $6ld6a = parcelRequire("6ld6a");





var $3u0dr = parcelRequire("3u0dr");














var $hSqtY = parcelRequire("hSqtY");


var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");




/* eslint-disable check-file/filename-blocklist */ var $7faba016ec71910a$export$5f48252a98452965 = /*#__PURE__*/ function(PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES) {
    PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES["NOT_SUPPORTED"] = "not-supported";
    PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES["PRE_TRIAL"] = "pre-trial";
    return PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES;
}({});
const $7faba016ec71910a$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $7faba016ec71910a$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $7faba016ec71910a$export$2a064af61b9d478a = 'persistent-upgrade';
const $7faba016ec71910a$export$d6b0a8b694d349bf = 'upgradeFlow';
const $7faba016ec71910a$export$30c8df1fa0e8fecf = 'persistent-upgrade-button';



const $d3462440acba7541$export$a1562d08625f5d7e = 'sendUIEvent';
const $d3462440acba7541$export$12346a674644c156 = 'sendOperationalEvent';
const $d3462440acba7541$export$e0a4e20835d53012 = ({ eventAction: eventAction, touchpointSubject: touchpointSubject, currentEdition: currentEdition, touchpointId: touchpointId, flowId: flowId, experimentAttributes: experimentAttributes })=>{
    return {
        type: $d3462440acba7541$export$a1562d08625f5d7e,
        data: {
            action: eventAction,
            actionSubject: touchpointSubject,
            source: (0, $7faba016ec71910a$export$bebf43b5d37dab0),
            attributes: {
                currentEdition: currentEdition,
                touchpointId: touchpointId,
                flowId: flowId,
                growthFeature: (0, $7faba016ec71910a$export$bebf43b5d37dab0),
                ...experimentAttributes
            }
        }
    };
};





















var $5nBzc = parcelRequire("5nBzc");









const $295ae67a78108eac$export$a1562d08625f5d7e = 'sendUIEvent';
const $295ae67a78108eac$export$12346a674644c156 = 'sendOperationalEvent';
const $295ae67a78108eac$export$318bf6d071b9c12a = 'persistentUpgradeMenu';
const $295ae67a78108eac$export$3be04a6bfdd40c53 = 'preTrialMenu';
const $295ae67a78108eac$export$87e7aba52331cd4 = {
    [(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]: $295ae67a78108eac$export$3be04a6bfdd40c53
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $295ae67a78108eac$var$MenuItemContent = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1n261q9c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $295ae67a78108eac$var$LozengeContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s817e2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s817e2",
            __cmplp.className
        ])
    });
});
const $295ae67a78108eac$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "persistent-upgrade.section.message.persistent-upgrade.menuitem.freeplan.title",
        defaultMessage: "UPGRADE"
    },
    persistentUpgradeMenuItemFreePlanTitleUpdated: {
        id: "persistent-upgrade.section.message.persistent-upgrade.menuitem.freeplan.title.updated",
        defaultMessage: "Upgrade"
    },
    persistentUpgradeMenuItemFreePlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try Standard or Premium"
    },
    persistentUpgradeMenuItemFreePlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE TRIAL"
    },
    persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge.updated",
        defaultMessage: "Free trial"
    }
});
const $295ae67a78108eac$export$130fb52e75130e77 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    let t0;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== currentEdition) {
        t0 = ()=>{
            if (currentEdition) createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
                eventAction: "viewed",
                ...$295ae67a78108eac$export$1b1d874427f720f9(currentEdition)
            })).fire();
        };
        t1 = [
            createAnalyticsEvent,
            currentEdition
        ];
        $[0] = createAnalyticsEvent;
        $[1] = currentEdition;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLabelExperiment);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($295ae67a78108eac$var$MenuItemContent, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($295ae67a78108eac$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "inprogress",
            isBold: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9wGTI.fg)("confluence_lozenge_text_update") ? $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated : $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperiment))));
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    (0, $42omo.useEffect)(()=>{
        if (currentEdition) createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
            eventAction: 'viewed',
            ...$295ae67a78108eac$export$1b1d874427f720f9(currentEdition)
        })).fire();
    }, [
        createAnalyticsEvent,
        currentEdition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($295ae67a78108eac$var$MenuItemContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLabelExperiment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($295ae67a78108eac$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "inprogress",
        isBold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9wGTI.fg)('confluence_lozenge_text_update') ? $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated : $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperiment))));
};
const $295ae67a78108eac$export$1b1d874427f720f9 = (currentEdition)=>({
        touchpointSubject: $295ae67a78108eac$export$318bf6d071b9c12a,
        currentEdition: currentEdition,
        touchpointId: $295ae67a78108eac$export$87e7aba52331cd4[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL],
        flowId: (0, $7faba016ec71910a$export$d6b0a8b694d349bf)
    });



var $BHGIm = parcelRequire("BHGIm");

const $55c779eece50e78c$export$17da940073c80266 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const [renderFailed, setRenderFailed] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { currentEdition: currentEdition, cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    const { showModal: showTrialComparisonModal } = (0, $BHGIm.useTrialPlanComparisonModalActions)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== currentEdition || $[2] !== showTrialComparisonModal) {
        t0 = ()=>{
            createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
                eventAction: "clicked",
                ...(0, $295ae67a78108eac$export$1b1d874427f720f9)(currentEdition)
            })).fire();
            showTrialComparisonModal({
                touchpointId: (0, $295ae67a78108eac$export$87e7aba52331cd4)[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = currentEdition;
        $[2] = showTrialComparisonModal;
        $[3] = t0;
    } else t0 = $[3];
    const onUpgradeMenuItemClick = t0;
    const shouldRenderPersistentUpgradeMenuSection = currentEdition === (0, $euL71.ConfluenceEdition).FREE && Boolean(isSiteAdmin) && Boolean(cloudId) && !renderFailed;
    if (shouldRenderPersistentUpgradeMenuSection) {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                onError: ()=>setRenderFailed(true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $295ae67a78108eac$export$130fb52e75130e77), null));
            $[4] = t1;
        } else t1 = $[4];
        let t2;
        if ($[5] !== onUpgradeMenuItemClick) {
            const menuSection = {
                heading: (0, $9wGTI.fg)("confluence_lozenge_text_update") ? (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitleUpdated : (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitle,
                items: [
                    {
                        action: onUpgradeMenuItemClick,
                        content: t1
                    }
                ]
            };
            t2 = [
                menuSection
            ];
            $[5] = onUpgradeMenuItemClick;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    } else {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [];
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
} : ()=>{
    const [renderFailed, setRenderFailed] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { currentEdition: currentEdition, cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    const { showModal: showTrialComparisonModal } = (0, $BHGIm.useTrialPlanComparisonModalActions)();
    const onUpgradeMenuItemClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
            eventAction: 'clicked',
            ...(0, $295ae67a78108eac$export$1b1d874427f720f9)(currentEdition)
        })).fire();
        showTrialComparisonModal({
            touchpointId: (0, $295ae67a78108eac$export$87e7aba52331cd4)[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]
        });
    }, [
        createAnalyticsEvent,
        currentEdition,
        showTrialComparisonModal
    ]);
    const shouldRenderPersistentUpgradeMenuSection = currentEdition === (0, $euL71.ConfluenceEdition).FREE && Boolean(isSiteAdmin) && Boolean(cloudId) && !renderFailed;
    if (shouldRenderPersistentUpgradeMenuSection) {
        const menuSection = {
            heading: (0, $9wGTI.fg)('confluence_lozenge_text_update') ? (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitleUpdated : (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitle,
            items: [
                {
                    action: onUpgradeMenuItemClick,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $295ae67a78108eac$export$130fb52e75130e77), null))
                }
            ]
        };
        return [
            menuSection
        ];
    } else return [];
};



var $kRW4Y = parcelRequire("kRW4Y");


var $gqqjz = parcelRequire("gqqjz");


var $awSMG = parcelRequire("awSMG");

function $7567c74a2233d8d4$export$1fe43c489c085f15() {
    if ('indexedDB' in window && indexedDB.databases) indexedDB.databases().then((databases)=>{
        const offlineStepsDatabases = databases.filter((db)=>db.name && db.name.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)));
        offlineStepsDatabases.forEach((db)=>{
            if (!db.name) return;
            const openReq = indexedDB.open(db.name);
            openReq.onsuccess = (event)=>{
                const req = event.target;
                const idb = req.result;
                try {
                    const tx = idb.transaction([
                        'steps',
                        'meta'
                    ], 'readwrite');
                    tx.objectStore('steps').clear();
                    tx.objectStore('meta').clear();
                    tx.oncomplete = ()=>{
                        idb.close();
                    };
                    tx.onerror = ()=>{
                        idb.close();
                    };
                } catch  {
                    idb.close();
                }
            };
        });
    });
}


/**
 * @generated SignedSource<<918eb2e46f1b07526fcf7e7bba62fdef>>
 * @relayHash 7cebb6100267d8ac81b652ebb261dbf2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64
const $30a6006f81533dde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "HardDeleteSpacePayload",
            "kind": "LinkedField",
            "name": "hardDeleteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7cebb6100267d8ac81b652ebb261dbf2",
            "id": "adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64",
            "metadata": {},
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation useTrashedSpaceHardDeleteSpaceMutation($spaceKey:String!){hardDeleteSpace(spaceKey:$spaceKey){taskId,success}}"
        }
    };
}();
$30a6006f81533dde$var$node.hash = "795f694b982fb4bd1390300de6001133";
var $30a6006f81533dde$export$2e2bcd8739ae039 = $30a6006f81533dde$var$node;


/**
 * @generated SignedSource<<35b09daba846118312b83219b5eec24a>>
 * @relayHash 1986e4071459ef825acb60fb30fd9e0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603
const $c483e9485a6240f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "RestoreSpacePayload",
            "kind": "LinkedField",
            "name": "restoreSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1986e4071459ef825acb60fb30fd9e0f",
            "id": "c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603",
            "metadata": {},
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation useTrashedSpaceRestoreSpaceMutation($spaceKey:String!){restoreSpace(spaceKey:$spaceKey){success}}"
        }
    };
}();
$c483e9485a6240f5$var$node.hash = "81c7e77af145a944ec2ee17a6ddeb1af";
var $c483e9485a6240f5$export$2e2bcd8739ae039 = $c483e9485a6240f5$var$node;


/**
 * @generated SignedSource<<ea1d49ef067cb8ff46e5635310fc38a5>>
 * @relayHash 5415582d46c1093ed99dc8b056690f92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071
const $1c05e71164dfb2a4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "concreteType": "ConfluenceLongTask",
                    "kind": "LinkedField",
                    "name": "longTask",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "elapsedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5415582d46c1093ed99dc8b056690f92",
            "id": "77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071",
            "metadata": {},
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "operationKind": "query",
            "text": "query useTrashedSpaceHardDeleteSpaceLongTaskQuery($id:ID!){confluence{longTask(id:$id){id,state{elapsedTime,name,__typename}}}}"
        }
    };
}();
$1c05e71164dfb2a4$var$node.hash = "d91db87dfbba3e56df610cf732a702b0";
var $1c05e71164dfb2a4$export$2e2bcd8739ae039 = $1c05e71164dfb2a4$var$node;









var $6UBEn = parcelRequire("6UBEn");





var $CRB7F = parcelRequire("CRB7F");





var $7zgzO = parcelRequire("7zgzO");














var $iEfsZ = parcelRequire("iEfsZ");


var $lvOsp = parcelRequire("lvOsp");


var $308Wd = parcelRequire("308Wd");


var $gW6rh = parcelRequire("gW6rh");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");

const $471b21c5f758aa1c$var$i18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "space-directory.space.restore.error-title",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "space-directory.space.restore.error-description",
        defaultMessage: "Refresh and try again."
    },
    successTitle: {
        id: "space-directory.space.delete.success-title",
        defaultMessage: "Space successfully deleted"
    },
    deletingProgressTitle: {
        id: "space-directory.space.delete.progress.title",
        defaultMessage: "Deleting space"
    },
    deletingProgress: {
        id: "space-directory.space.delete.progress",
        defaultMessage: "Deleting..."
    }
});
const $471b21c5f758aa1c$var$POLL_INTERVAL_MS = 500;
const $471b21c5f758aa1c$var$POLL_TIMEOUT_MS = 80000;

const $471b21c5f758aa1c$export$3773e9c668f3a570 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Z_hkD",
    name: "DeleteSpaceDialogLoader",
    loader: async ()=>(await (parcelRequire("5YH7h"))).DeleteSpaceDialog
});
const $471b21c5f758aa1c$export$9d49f71132b637a1 = ({ spaceKey: spaceKey, spaceAlias: spaceAlias, spaceId: spaceId, source: source, flags: flags, modifyTrashedCache: modifyTrashedCache })=>{
    const { toUrl: toUrl, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const intl = (0, $aXWIB.useIntl)();
    const timeoutRef = (0, $42omo.useRef)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [hardDeleteLongTaskQuery, { data: longTaskData, error: longTaskError, stopPolling: stopPolling }] = (0, $lvOsp.useLazyQueryInterop)((0, $1c05e71164dfb2a4$export$2e2bcd8739ae039), {
        fetchPolicy: 'network-only',
        pollInterval: $471b21c5f758aa1c$var$POLL_INTERVAL_MS,
        __callerPackage__: "@confluence/space-directory"
    });
    const onError = (0, $42omo.useCallback)((action, experience, error)=>{
        flags.hideFlag('deleting-space-progress');
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $471b21c5f758aa1c$var$i18n.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $471b21c5f758aa1c$var$i18n.errorDescription),
            isAutoDismiss: true
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'space',
                source: source,
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        experience && experienceTracker.fail({
            name: experience,
            error: new Error(error || 'An unknown error has occurred'),
            attributes: {
                spaceId: spaceId
            }
        });
    }, [
        flags,
        createAnalyticsEvent,
        spaceId,
        source,
        experienceTracker
    ]);
    const [mutateRestoreSpace] = (0, $308Wd.useMutationInterop)((0, $c483e9485a6240f5$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        onError: ()=>onError('restoreError', (0, $irVI7.RESTORE_SPACE_EXPERIENCE), 'Restore space mutation failed'),
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.RESTORE_SPACE_EXPERIENCE),
                attributes: {
                    spaceId: spaceId
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'restored',
                    actionSubject: 'space',
                    source: source,
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            //go to the restored space
            push(toUrl((0, $1NBp8.SPACE_OVERVIEW).name, {
                spaceKey: spaceAlias || spaceKey
            }));
        },
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: (0, $gW6rh.default)
            },
            {
                query: (0, $4eIcx.default),
                variables: {
                    selectedSpaceKey: spaceKey
                }
            },
            {
                query: (0, $4H4Pj.default)
            },
            {
                query: (0, $iEfsZ.default),
                variables: {
                    location: 'system.user'
                }
            }
        ],
        __callerPackage__: "@confluence/space-directory"
    });
    const [hardDeleteSpace] = (0, $308Wd.useMutationInterop)((0, $30a6006f81533dde$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        onError: ()=>onError('deleteError', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), 'Hard delete space mutation failed'),
        onCompleted: (data)=>{
            if (data?.hardDeleteSpace?.taskId) {
                // poll the long task's progress
                const taskIdAri = (0, $CRB7F.ConfluenceLongRunningTaskAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    taskId: data.hardDeleteSpace.taskId
                });
                hardDeleteLongTaskQuery({
                    variables: {
                        id: taskIdAri.toString()
                    }
                });
                // show the progress flag
                flags.showInfoFlag({
                    id: 'deleting-space-progress',
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $471b21c5f758aa1c$var$i18n.deletingProgressTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UBEn.default), {
                        ariaLabel: intl.formatMessage($471b21c5f758aa1c$var$i18n.deletingProgress),
                        isIndeterminate: true
                    })
                });
            }
        },
        __callerPackage__: "@confluence/space-directory"
    });
    (0, $42omo.useEffect)(()=>{
        // if the long task is still in progress after 60 seconds, show an error flag
        if (longTaskData?.confluence?.longTask?.state?.__typename === 'ConfluenceLongTaskInProgress' && stopPolling) timeoutRef.current = setTimeout(()=>{
            stopPolling();
            onError('deleteTimeout', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), 'Long task timeout');
        }, $471b21c5f758aa1c$var$POLL_TIMEOUT_MS);
    }, [
        longTaskData?.confluence?.longTask?.state?.__typename,
        stopPolling,
        onError,
        spaceKey,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (longTaskError) {
            onError('deleteError', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), longTaskError);
            stopPolling();
            clearTimeout(timeoutRef.current);
        } else if (longTaskData?.confluence?.longTask?.state?.__typename === 'ConfluenceLongTaskSuccess') {
            // long task completed successfully, stop polling and show success flag
            stopPolling();
            clearTimeout(timeoutRef.current);
            flags.hideFlag('deleting-space-progress');
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $471b21c5f758aa1c$var$i18n.successTitle),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE),
                attributes: {
                    spaceId: spaceId
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'space',
                    source: source,
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            // remove the space from the cache
            modifyTrashedCache && modifyTrashedCache(spaceKey);
        }
    }, [
        flags,
        longTaskData,
        longTaskError,
        stopPolling,
        onError,
        modifyTrashedCache,
        spaceKey,
        spaceId,
        source,
        experienceTracker,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    const handleStartDelete = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE),
            attributes: {
                spaceId: spaceId
            }
        });
        hardDeleteSpace();
    }, [
        hardDeleteSpace,
        experienceTracker,
        spaceId
    ]);
    const handleRestoreClick = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.RESTORE_SPACE_EXPERIENCE),
            attributes: {
                spaceId: spaceId
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restoreSpaceButton',
                source: source
            }
        }).fire();
        mutateRestoreSpace();
    }, [
        mutateRestoreSpace,
        createAnalyticsEvent,
        source,
        spaceId,
        experienceTracker
    ]);
    const handleDeleteClick = (0, $42omo.useCallback)((dialogs)=>{
        dialogs.showModal($471b21c5f758aa1c$export$3773e9c668f3a570, {
            handleStartDelete: handleStartDelete
        });
    }, [
        handleStartDelete
    ]);
    return {
        handleRestoreClick: handleRestoreClick,
        handleDeleteClick: handleDeleteClick,
        handleStartDelete: handleStartDelete
    };
};






var $jEeDd = parcelRequire("jEeDd");


var $7J5Uc = parcelRequire("7J5Uc");


var $ictHB = parcelRequire("ictHB");


var $disnP = parcelRequire("disnP");





var $6mKj3 = parcelRequire("6mKj3");





var $1wScy = parcelRequire("1wScy");




/* eslint-disable no-console */ 
var $jiJCD = parcelRequire("jiJCD");





var $2twC9 = parcelRequire("2twC9");


var $6F6hl = parcelRequire("6F6hl");





var $jlIaF = parcelRequire("jlIaF");


var $hjhCz = parcelRequire("hjhCz");


var $cMvQV = parcelRequire("cMvQV");





const $3577c171740792d7$export$66c678344942e78 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "l42Eo",
    name: "LazyAboutConfluenceDialog",
    loader: async ()=>(await (parcelRequire("3ft1X"))).AboutConfluenceDialog
});






const $70f1925d36f87de3$export$833e3c61be5fbc6f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pg4P3",
    name: "LazyGiveFeedbackDialog",
    loader: async ()=>(await (parcelRequire("9qutx"))).GiveFeedbackDialog
});









var $6R5uz = parcelRequire("6R5uz");


var $cGtPE = parcelRequire("cGtPE");





const $900853aff92d6b38$export$687b3538513cb3cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "sW558",
    name: "ThemePopupMenu",
    loader: async ()=>(await (parcelRequire("bIfof"))).ThemePopupMenu
});


const $86397fec8483a8db$var$ThemeMenuItemComponent = ({ item: item, isSelected: isSelected, closeMenu: closeMenu, ...linkItemProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $900853aff92d6b38$export$687b3538513cb3cc), {
        isOpen: isSelected,
        onSelected: closeMenu,
        closeMenu: linkItemProps.onClick,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
                ...triggerProps,
                ...linkItemProps,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    spacing: "spacious",
                    label: "",
                    size: "small"
                }),
                ref: triggerRef
            }, item.content)
    });
};
const $86397fec8483a8db$export$d11c29d48d32448a = (0, $aXWIB.injectIntl)($86397fec8483a8db$var$ThemeMenuItemComponent);


(0, $cMvQV.setUserAgent)();
const $ce34965c368cb83e$var$addQueryParamsToUrl = function addQueryParamsToUrl(params, url) {
    const parsedUrl = {
        ...(0, $jiJCD.parse)(url, true),
        search: undefined
    };
    parsedUrl.query = Object.assign({}, parsedUrl.query, params);
    return (0, $jiJCD.format)(parsedUrl);
};
const $ce34965c368cb83e$var$cleanURL = (url, userId)=>url.replace('$generalUtil.doubleUrlEncode($helper.action.authenticatedUser.name)', userId);
/**
 * A connect add-on web-item with `ap-dialog` or `ap-inline-dialog` class name will trigger opening Connect Dialog.
 * @param styleClass
 * @returns {boolean}
 */ const $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog = (styleClass)=>styleClass.indexOf('ap-dialog') >= 0 || styleClass.indexOf('ap-inline-dialog') >= 0;
/**
 * Add `action` for a Atlaskit dropdown menu item so that when dropdown menu item is selected, `action` is called and trigger click event on anchor element automatically.
 * @param {Object} item - dropdown menu object. A new `action` attribute will be added.
 * @returns {Function} a callback function which is used to pass `ref` prop.
 */ const $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor = (item)=>{
    return (anchorEl)=>{
        item.action = ()=>anchorEl.click();
    };
};
/**
 * createFakeWebDriverTarget will add an invisible dom element in the dropdown item, which allows old pageobjects of
 * AUIDropdown to target atlaskit dropdowns. Hopefully it's temporary.
 *
 * @param id
 */ const $ce34965c368cb83e$var$createFakeWebDriverTarget = (id)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-primitives-text, @atlassian/i18n/no-literal-string-in-jsx -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        id: id,
        style: {
            opacity: 0
        },
        "aria-hidden": true
    }, "-");
const $ce34965c368cb83e$var$createAboutConfluenceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3577c171740792d7$export$66c678344942e78), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createGiveFeedbackDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70f1925d36f87de3$export$833e3c61be5fbc6f), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createAddPesonalSpaceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjhCz.LazyAddPersonalSpaceDialog), {
        onClose: onClose
    });
const $ce34965c368cb83e$export$62ed5eb75de5c4d9 = ({ url: url, params: params, label: label, moduleKey: moduleKey, id: id = '', tooltip: tooltip = '', styleClass: styleClass = '' }, push, userId, callbackAction)=>{
    label = (0, (/*@__PURE__*/$parcel$interopDefault($2twC9)))(label);
    switch(moduleKey){
        case 'confluence-about':
            const about = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAboutConfluenceDialog,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('confluence-about-link'),
                content: label
            };
            return about;
        //we are removing gadgets
        case 'gadget-directory':
            const gadget = null;
            return gadget;
        case 'user-history':
            const userHistory = {
                key: moduleKey,
                action: ()=>console.log('open ViewRecentsModalContainer'),
                content: label
            };
            return userHistory;
        case 'user-profile':
            const additionalQueryParamsForAnalytics = 'src=usermenu';
            const userProfileUrl = `${(0, $jlIaF.CONTEXT_PATH)}/people/${userId}?${additionalQueryParamsForAnalytics}`;
            return {
                key: moduleKey,
                href: userProfileUrl,
                content: label,
                title: tooltip
            };
        case 'keyboard-shortcuts-dialog-help-menu':
            const keyboardShortcuts = {
                key: moduleKey,
                action: callbackAction,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('keyboard-shortcuts-link'),
                content: label
            };
            return keyboardShortcuts;
        case 'create-personal-space':
            const createPersonalSpace = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAddPesonalSpaceDialog,
                content: label
            };
            return createPersonalSpace;
        case 'personal-space':
            const personalSpace = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: url,
                title: tooltip
            };
            return personalSpace;
        case 'admin-restore-personal-space':
            const adminRestorePersonalSpace = {
                key: moduleKey,
                action: callbackAction,
                content: label,
                title: tooltip
            };
            return adminRestorePersonalSpace;
        case 'my-tasks-menu-item':
            const task = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: `${(0, $jlIaF.CONTEXT_PATH)}/home/tasks`,
                title: tooltip
            };
            return task;
        case 'adg3-give-feedback':
            const giveFeedback = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createGiveFeedbackDialog,
                content: label
            };
            return giveFeedback;
        case 'user-favourites':
            const userFavourites = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: (0, $1NBp8.MY_SAVED_FOR_LATER).toUrl(),
                title: tooltip
            };
            return userFavourites;
        case 'user-theme':
            const userThemePreference = {
                key: moduleKey,
                component: (0, $86397fec8483a8db$export$d11c29d48d32448a),
                content: label,
                title: tooltip,
                action: callbackAction,
                closeAction: ()=>{} // No-op, don't close
            };
            return userThemePreference;
        case 'login':
            const { pathname: pathname, search: search, hash: hash } = window.location;
            let currentLocation = pathname + search + hash;
            if (currentLocation.startsWith((0, $jlIaF.CONTEXT_PATH))) currentLocation = currentLocation.slice((0, $jlIaF.CONTEXT_PATH).length);
            const login = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$addQueryParamsToUrl({
                    os_destination: currentLocation
                }, url),
                content: label
            };
            return login;
        case 'logout':
            const logout = {
                key: moduleKey,
                action: ()=>{
                    push(url);
                },
                content: label
            };
            return logout;
        default:
            const item = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$cleanURL(url, userId),
                target: params && params.target || '_self',
                content: label,
                title: tooltip
            };
            const shouldRenderProxyAnchor = $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog(styleClass);
            item.iconAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, id ? $ce34965c368cb83e$var$createFakeWebDriverTarget(id) : null, shouldRenderProxyAnchor ? // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: item.href,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: styleClass,
                ref: $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor(item),
                "aria-hidden": "true",
                tabIndex: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, item.title ?? '')) : null);
            if (shouldRenderProxyAnchor) {
                // `item.action` value will be overridden by `ref` callback.
                // prevent rendering anchor element for dropdown menu item because there is a above proxy anchor
                // which helps to trigger a click event when dropdown menu item is selected.
                item.href = '';
                item.target = '';
            }
            return item;
    }
};


// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $9abf739da8d121fb$var$i18n = (0, $aXWIB.defineMessages)({
    'system.user/adg3-section': {
        id: "navigation.help.us.improve",
        defaultMessage: "Help us improve"
    },
    'system.user/user-content': {
        id: "navigation.adg3.user.profile.user-content",
        defaultMessage: "Confluence"
    },
    'system.help/pages': {
        id: "navigation.help.name",
        defaultMessage: "Help"
    },
    'system.help/pages/legal-section': {
        id: "navigation.system.help.legal",
        defaultMessage: "Legal"
    }
});
const $9abf739da8d121fb$export$fb03cba5560d3c7b = (webItems, webSections, options)=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const items = [];
    if (webItems && webItems.length) {
        const groupedSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wScy)))(webItems, 'section');
        webSections.forEach((sectionName)=>{
            if (!sectionName) return;
            const webItemRecords = groupedSections[sectionName];
            if (!webItemRecords) return;
            const tempItems = webItemRecords.map((webItemRecord)=>(0, $ce34965c368cb83e$export$62ed5eb75de5c4d9)(webItemRecord, push, options?.userId, webItemRecord.moduleKey && options?.callbackActions ? options?.callbackActions[webItemRecord.moduleKey] : undefined)).filter((item)=>!!item);
            items.push({
                heading: $9abf739da8d121fb$var$i18n.hasOwnProperty(sectionName) ? {
                    ...$9abf739da8d121fb$var$i18n[sectionName]
                } : null,
                items: tempItems
            });
        });
    }
    return items;
};


/* PopupMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $76b9de0c86704e7a$var$styles = null;
const $76b9de0c86704e7a$export$d84e735b83737942 = ({ item: item, onClickHandler: onClickHandler, closeMenu: closeMenu, isSelected: isSelected })=>{
    const ItemComponent = item.component;
    const onKeyPress = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === 'Space') onClickHandler();
    }, [
        onClickHandler
    ]);
    const commonProps = (0, $42omo.useMemo)(()=>{
        const tabIndex = item.href ? undefined : 0;
        const role = item.href ? undefined : 'link';
        return {
            onClick: onClickHandler,
            closeMenu: closeMenu,
            isSelected: isSelected,
            onKeyPress: // The following 3 attributes are needed for accessibility
            // Otherwise, a link item's onClick is not usable by keyboard
            onKeyPress,
            tabIndex: // Only needed if the href attribute is missing, for accessibility
            tabIndex,
            role: role
        };
    }, [
        onClickHandler,
        isSelected,
        onKeyPress,
        item,
        closeMenu
    ]);
    return ItemComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemComponent, {
        item: item,
        ...commonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
        testId: "default-popup-menu-item",
        ...item.href && {
            href: item.href
        },
        target: item.target || undefined,
        iconAfter: item.iconAfter || null,
        ...commonProps,
        className: (0, $gMc0m.default)([
            "_1nrm1r31 _1ydc1r31 _c2waglyw _1x28glyw _1iohnqa1 _1726nqa1 _9h8hi7uo _1053i7uo"
        ])
    }, item.content);
};





const $22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery = (0, $9d6b1a9db83da49f$export$2e2bcd8739ae039);
/* Excluded web items include 'confluence.user.menu:user-favourites' (carried over from ProfileMenu)
 * as well as web items that are already supported by the platform Account Menu.
 * We are passing in an excluded list instead of an included list to avoid missing any web items.
 * Currently expected web items include the following:
 * - com.atlassian.confluence.plugins.confluence-frontend-support:adg3-give-feedback
 * - confluence.user.menu:create-personal-space
 * - confluence.user.menu:personal-space
 * - confluence.user.menu:admin-restore-personal-space
 * - com.atlassian.confluence.plugins.confluence-inline-tasks:my-tasks-menu-item
 * - confluence.user.menu:settings
 * - com.atlassian.plugins.atlassian-connect-plugin:confluence-chats-integration__profile
 * - extension points (begin with com.atlassian.plugins.atlassian-connect-plugin:connect-playground-confluence)
 */ const $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS = [
    'confluence.user.menu:user-favourites',
    'confluence.user.menu:user-profile',
    'confluence.user.menu:user-theme',
    'confluence.user.menu:logout'
];
const $22e97f2cae5620a3$var$getManageAccountUrl = (destinationAccountEmail, environment)=>{
    const loginLink = (0, $jEeDd.getLoginLink)($22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink(environment));
    return `${loginLink}&login_hint=${encodeURIComponent(destinationAccountEmail)}&prompt=none`;
};
const $22e97f2cae5620a3$var$getSwitchAccountUrl = ()=>{
    const loginLink = (0, $jEeDd.getLoginLink)();
    return `${loginLink}&prompt=select_account`;
};
const $22e97f2cae5620a3$var$manageProfileUrlSuffix = 'manage-profile/profile-and-visibility';
const $22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink = (environment)=>{
    if ((0, $T9xHm.isIsolatedCloud)()) // dynamically generate identity URL based on IC shard (defined in /confluence/next/tools/config/env/)
    return `https://${"id.atlassian.com"}/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
    else return environment === 'PRODUCTION' ? `https://id.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}` : `https://id.stg.internal.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
};
const $22e97f2cae5620a3$var$AccountMenuComponent = /*#__PURE__*/ (0, $42omo.memo)(({ user: user, webItems: webItems, webSections: webSections, dialogFn: dialogFn, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const getThemePreference = (0, $42omo.useCallback)(()=>(0, $ictHB.fetchGlobalColorMode)(user?.id), [
        user?.id
    ]);
    const [globalColorMode, loadGlobalColorModeOnce] = (0, $disnP.useColorModeState)(getThemePreference, user?.id);
    const userId = user?.id || '';
    const profileIconUrl = user?.photos?.[0]?.value || '';
    const accountEmail = user?.emails?.[0]?.value || '';
    const accountDisplayName = user?.displayName || '';
    const manageAccountUrl = $22e97f2cae5620a3$var$getManageAccountUrl(accountEmail, environment);
    const switchAccountUrl = $22e97f2cae5620a3$var$getSwitchAccountUrl();
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    const persistentUpgradeMenuSection = (0, $55c779eece50e78c$export$17da940073c80266)();
    const standardToPremiumEASection = (0, $c5zvz.useConfluenceStandardToPremiumPUBTouchpoint)('nav4');
    const [itemSelected, setItemSelected] = (0, $42omo.useState)(undefined);
    // if webItems has 'admin-restore-personal-space', then we need to call the query to get the trashed personal space data
    const hasTrashedPersonalSpace = webItems.some((obj)=>obj.completeKey === 'confluence.user.menu:admin-restore-personal-space');
    const { data: data } = (0, $jMyy4.useQueryInterop)($22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery, {
        skip: !hasTrashedPersonalSpace,
        variables: {
            creatorAccountIds: [
                userId || ''
            ]
        },
        __callerPackage__: "@confluence/nav-menus"
    });
    const node = data?.spaces?.nodes?.[0];
    const spaceKey = node?.key || '';
    const spaceId = node?.id || '';
    const spaceAlias = node?.alias || '';
    const { handleRestoreClick: handleRestoreClick } = (0, $471b21c5f758aa1c$export$9d49f71132b637a1)({
        spaceKey: spaceKey,
        spaceAlias: spaceAlias,
        spaceId: spaceId,
        flags: flags,
        source: 'profileMenu'
    });
    const callbackActions = {
        'user-theme': ()=>{
            itemSelected === 'user-theme' ? setItemSelected(undefined) : setItemSelected('user-theme');
        },
        'admin-restore-personal-space': ()=>handleRestoreClick()
    };
    const menuItems = (0, $9abf739da8d121fb$export$fb03cba5560d3c7b)(webItems, webSections, {
        userId: userId,
        callbackActions: callbackActions
    });
    const accountMenuItems = [
        ...persistentUpgradeMenuSection,
        ...standardToPremiumEASection,
        ...menuItems
    ];
    const getSectionTitle = (group)=>{
        if (group.heading) {
            if (typeof group.heading === 'string') return group.heading;
            else return formatMessage(group.heading);
        } else return undefined;
    };
    const onLogoutClickCallback = (_event, _analyticsEvent)=>{
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) (0, $7567c74a2233d8d4$export$1fe43c489c085f15)();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5842fbd79e33e7af$export$a63b6ac98b2ba9a8), {
        globalColorMode: (0, $9wGTI.fg)('shared-user-preferences') ? globalColorMode : undefined,
        onThemeSwitcherOpenChange: loadGlobalColorModeOnce,
        testId: "confluence-account-menu",
        name: accountDisplayName,
        picture: profileIconUrl,
        trustPicture: true,
        email: accountEmail,
        viewProfileLink: "/wiki/users/viewmyprofile.action",
        manageProfileLink: manageAccountUrl,
        logOutLink: "/wiki/logout.action",
        currentTheme: themeState?.theme?.colorMode,
        onThemeChange: themingActions.setColorModePreference,
        switchAccountLink: switchAccountUrl,
        onLogoutClick: onLogoutClickCallback,
        extraMenuItems: accountMenuItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
                key: getSectionTitle(group),
                hasSeparator: true,
                title: getSectionTitle(group)
            }, group.items.map((item)=>{
                const itemGetDialog = item.hasOwnProperty('getDialog') ? item.getDialog : null;
                const dialogHandler = itemGetDialog ? ()=>{
                    dialogFn(itemGetDialog);
                } : null;
                const onClick = item.action || dialogHandler;
                const closeAction = item.closeAction;
                const onClickHandler = ()=>{
                    if (closeAction) closeAction();
                    if (onClick) onClick();
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76b9de0c86704e7a$export$d84e735b83737942), {
                    key: item.key,
                    item: item,
                    onClickHandler: onClickHandler,
                    closeMenu: closeAction || (()=>{}),
                    isSelected: itemSelected === item.key
                });
            })))
    });
});
const $22e97f2cae5620a3$export$ff20d75d5eda4388 = /*#__PURE__*/ (0, $42omo.memo)(({ user: user, dialogFn: dialogFn })=>{
    const { webItems: webItems, webSections: webSections } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER),
        notAllowedWebItems: $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (dialogs, flags)=>{
        const accountMenuProps = {
            user: user,
            dialogFn: dialogFn,
            webItems: webItems,
            webSections: webSections,
            dialogs: dialogs,
            flags: flags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22e97f2cae5620a3$var$AccountMenuComponent, accountMenuProps));
    });
});


const $e40e4f4e333d3274$export$6d6e8f8ac62271dd = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { user: user } = t0;
    const [activeDialog, setActiveDialog] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setActiveDialog(null);
        };
        $[0] = t1;
    } else t1 = $[0];
    const closeDialog = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[1] = t2;
    } else t2 = $[1];
    const openDialog = t2;
    const preloadMenu = $e40e4f4e333d3274$var$_temp;
    const t3 = user.id ?? null;
    const t4 = user.displayName ?? null;
    let t5;
    if ($[2] !== user.emails) {
        t5 = user.emails?.map($e40e4f4e333d3274$var$_temp2) || null;
        $[2] = user.emails;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== user.photos) {
        t6 = user.photos?.map($e40e4f4e333d3274$var$_temp3) || null;
        $[4] = user.photos;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
        t7 = {
            id: t3,
            displayName: t4,
            emails: t5,
            photos: t6
        };
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const accountMenuUser = t7;
    let t8;
    if ($[11] !== accountMenuUser) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22e97f2cae5620a3$export$ff20d75d5eda4388), {
            user: accountMenuUser,
            dialogFn: openDialog
        }));
        $[11] = accountMenuUser;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== activeDialog) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activeDialog);
        $[13] = activeDialog;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
};
function $e40e4f4e333d3274$var$_temp() {
    (0, $c0dbaa4ed1720915$export$5ca34e43e28ce619)();
}
function $e40e4f4e333d3274$var$_temp2(email) {
    return {
        value: email?.value || null
    };
}
function $e40e4f4e333d3274$var$_temp3(photo) {
    return {
        value: photo?.value || null
    };
}



var $3yPEN = parcelRequire("3yPEN");

/* CreateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $3gadb = parcelRequire("3gadb");








var $4ri4I = parcelRequire("4ri4I");


var $7NoF3 = parcelRequire("7NoF3");





var $fZAJP = parcelRequire("fZAJP");








var $dkIiA = parcelRequire("dkIiA");

















var $9A2e6 = parcelRequire("9A2e6");

/* LazyTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $6mkwk = parcelRequire("6mkwk");


var $dpPtd = parcelRequire("dpPtd");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");


var $cei05 = parcelRequire("cei05");





var $hnvzE = parcelRequire("hnvzE");


var $4rFRN = parcelRequire("4rFRN");

function $f67c117a92e3943c$export$a546442f39c56898({ id: id, children: children }) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[id];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: experienceObj.experienceId
    }, children);
}



var $gWF6I = parcelRequire("gWF6I");


var $19BZl = parcelRequire("19BZl");


var $VSkIN = parcelRequire("VSkIN");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $ffCOo = parcelRequire("ffCOo");

function $d7c773b6c8a524b1$export$63b55d605f8a2340({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        }
    }, children);
}






var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $lGgRw = parcelRequire("lGgRw");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");








var $7K3dX = parcelRequire("7K3dX");








var $fFa3V = parcelRequire("fFa3V");

function $20cb900309b02b52$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const unbind = (0, $fFa3V.bind)(el, {
            type: 'click',
            listener: (e)=>{
                if (isOpen) {
                    e.stopPropagation();
                    handleClose(e);
                }
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}









var $a1Oiu = parcelRequire("a1Oiu");





var $hpf3U = parcelRequire("hpf3U");


var $dv953 = parcelRequire("dv953");




var $jjCkw = parcelRequire("jjCkw");

function $6be040ea1058f318$export$61de563e38fe014d() {
    const { user: currentUser } = (0, $caUKj.useUserContext)();
    const { fetchUser: fetchUser } = (0, $dv953.useFetchUser)();
    /**
   * Conditionally fetches user data if menu items require it.
   * Supports both V1 (flat items array) and V2 (sections with items) data structures.
   *
   * @param params - Object containing either items array or sections array
   */ const fetchUserIfNeeded = ({ items: items, sections: sections })=>{
        // Skip if user already available
        if (currentUser) return;
        // Check V1 format (flat items array)
        if (items) {
            const willNeedUser = items.some((item)=>{
                return item.ati && (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati);
            });
            if (willNeedUser) fetchUser();
        }
        // Check V2 format (sections with items)
        if (sections && Array.isArray(sections)) {
            const willNeedUser = sections.some((section)=>Array.isArray(section.items) && section.items.some((item)=>item && item.ati && (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati)));
            if (willNeedUser) fetchUser();
        }
    };
    return {
        fetchUserIfNeeded: fetchUserIfNeeded
    };
}






var $jJf3a = parcelRequire("jJf3a");









function $364339a651e8ac31$export$c1b17113cb5b0556() {
    const loadPromiseRef = (0, $42omo.useRef)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { product: product, suggestionConfig: suggestionConfig, crossAppCreationConfig: crossAppCreationConfig } = (0, $19BZl.useMenuStateContext)();
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        if (loadPromiseRef.current) return;
        // Only load if either suggestion config or cross-app creation is enabled
        if (!suggestionConfig.enabled && !crossAppCreationConfig?.enabled) return;
        const { cloudId: cloudId, environment: environment } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : suggestionConfig.enabled ? suggestionConfig : {};
        const finalEnvironment = environment || 'prod';
        const loadingPromise = (async ()=>{
            try {
                if (cloudId) {
                    const [{ initLoomSDK: initLoomSDK }, { convertSourceProductToProductType: convertSourceProductToProductType }] = await Promise.all([
                        (parcelRequire("kOiVn")),
                        (parcelRequire("25I5T"))
                    ]);
                    await initLoomSDK({
                        environment: finalEnvironment,
                        cloudId: cloudId,
                        productName: convertSourceProductToProductType(product),
                        experienceTracker: experienceTracker,
                        entryPointLocation: (0, $jjCkw.SOURCE_LOCATION)
                    });
                }
            } catch  {
            // ignore
            }
        })();
        loadPromiseRef.current = loadingPromise;
    }, [
        experienceTracker,
        product,
        suggestionConfig,
        crossAppCreationConfig
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}


function $a646309de174f54b$export$4dcd17e50290e364() {
    const { sections: sections, product: product, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig } = (0, $19BZl.useMenuStateContext)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const shouldSkip = !crossAppCreationConfig.enabled;
    const shouldFetchData = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $364339a651e8ac31$export$c1b17113cb5b0556)();
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $hpf3U.sectionsToAppMenuConfig)(sections), [
        sections
    ]);
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $6be040ea1058f318$export$61de563e38fe014d)();
    /**
   * Fetching menu items
   */ const { data: data, fetchUCMenuItems: fetchUCMenuItems } = (0, $a1Oiu.useUCMenuItems)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchData
    });
    const prefetchTriggered = (0, $42omo.useRef)(false);
    const userFetchTriggered = (0, $42omo.useRef)(false);
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        if (prefetchTriggered.current || !shouldFetchData) return;
        prefetchTriggered.current = true;
        triggerPrefetchLoom();
        fetchUCMenuItems();
    }, [
        shouldFetchData,
        fetchUCMenuItems,
        triggerPrefetchLoom
    ]);
    // Reactively fetch user data when sections become available
    (0, $42omo.useEffect)(function fetchUserWhenDataReady() {
        if (!shouldFetchData || !data?.sections || userFetchTriggered.current) return;
        userFetchTriggered.current = true;
        fetchUserIfNeeded({
            sections: data.sections
        });
    }, [
        shouldFetchData,
        data?.sections,
        fetchUserIfNeeded
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}


const $ea48362f2f432197$var$emptyEntryPointParams = {};
const $ea48362f2f432197$var$noop = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
function $ea48362f2f432197$var$EntryPointPopupInner({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, isOpen: isOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { preventClose: preventClose, product: product, crossAppCreationConfig: crossAppCreationConfig, isV2Mode: isV2Mode } = (0, $19BZl.useMenuStateContext)();
    const isPrefetchEnabled = crossAppCreationConfig.enabled && Boolean(crossAppCreationConfig.prefetch);
    const { triggerPrefetch: triggerPrefetch } = (0, $a646309de174f54b$export$4dcd17e50290e364)();
    const id = (0, $42omo.useMemo)(()=>entryPoint.root.getModuleName() || 'unknown', [
        entryPoint
    ]);
    const [content, setContent] = (0, $42omo.useState)(()=>$ea48362f2f432197$var$noop);
    const contentLoadedRef = (0, $42omo.useRef)(false);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        if (product === 'confluence' && preventClose) return;
        onClose?.(event, currentLevel);
        setContent(()=>$ea48362f2f432197$var$noop);
        contentLoadedRef.current = false;
    }, [
        preventClose,
        product,
        onClose
    ]);
    // Compute effective isOpen state based on feature gate
    const isPopupOpen = isOpen ?? false;
    const triggerCloseRef = (0, $20cb900309b02b52$export$46ec6629f411921d)({
        isOpen: isPopupOpen,
        handleClose: handleClose
    });
    const prevIsOpenRef = (0, $42omo.useRef)(isPopupOpen);
    const entryPointLoadTriggeredRef = (0, $42omo.useRef)(false);
    const { fireMenuStateChanged: fireMenuStateChanged, fireEntryPointLoadTriggered: fireEntryPointLoadTriggered } = (0, $7K3dX.useUniversalCreateAnalytics)();
    (0, $42omo.useEffect)(function fireMenuStateChangedEffect() {
        const prevIsOpen = prevIsOpenRef.current;
        // Only fire analytics on actual state transitions (use displayed state)
        if (isPopupOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isPopupOpen ? 'expanded' : 'collapsed',
            version: isV2Mode ? 'v2' : 'v1'
        });
        prevIsOpenRef.current = isPopupOpen;
    }, [
        isPopupOpen,
        fireMenuStateChanged,
        prevIsOpenRef,
        isV2Mode
    ]);
    const version = isV2Mode ? 'v2' : 'v1';
    // on hover callback
    const load = (0, $42omo.useCallback)((trigger = 'hover')=>{
        if (!entryPointLoadTriggeredRef.current) {
            entryPointLoadTriggeredRef.current = true;
            fireEntryPointLoadTriggered({
                trigger: trigger,
                version: version
            });
        }
        if (isPrefetchEnabled) triggerPrefetch();
        return (0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $ea48362f2f432197$var$emptyEntryPointParams);
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        fireEntryPointLoadTriggered,
        isPrefetchEnabled,
        triggerPrefetch,
        version
    ]);
    // on menu loaded callback
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when already loaded
        if (contentLoadedRef.current) return;
        contentLoadedRef.current = true;
        setContent(()=>(contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
                    id: id,
                    entryPointReference: entryPointReference,
                    fallback: fallback || null,
                    errorFallback: errorFallback,
                    runtimeProps: {
                        entryPointProps: entryPointProps,
                        onClose: handleClose,
                        contentProps: contentProps
                    },
                    onError: onError,
                    forcedError: forcedReportErrorUFO
                }));
    }, [
        setContent,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    // Primary button onLoad - preload but don't open popup
    const onLoadPrimary = (0, $42omo.useCallback)(()=>{
    // Primary button should only preload, NOT open the popup
    // The preloaded reference will be disposed automatically by usePressablePreloadRef
    // The actual click behavior is handled by primaryActionItem.onClick
    }, []);
    // Separate ref for the primary button with ONLY preload functionality (no popup opening)
    const primaryButtonRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoadPrimary
    });
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            splitButtonPrimaryRef: primaryButtonRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        primaryButtonRef
    ]);
    const popupContent = (0, $42omo.useCallback)((contentProps)=>content(contentProps), [
        content
    ]);
    // Track previous values to detect prop changes
    // Initialize as undefined to detect initial render with isOpen={true}
    const prevIsOpenPropRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(function preloadWithControlledOpenState() {
        const isOpenPropChanged = isOpen !== prevIsOpenPropRef.current;
        prevIsOpenPropRef.current = isOpen;
        if (isOpen && isOpenPropChanged && !contentLoadedRef.current) {
            const triggerLoading = ()=>{
                const preloadedRef = load('controlled');
                if (preloadedRef) onLoad({
                    reference: preloadedRef
                });
            };
            const timeoutId = setTimeout(triggerLoading, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isPopupOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
function $ea48362f2f432197$export$8f8a5b7d7394d1f8(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A2e6.GenericErrorBoundary), {
        name: "entry-point-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ea48362f2f432197$var$EntryPointPopupInner, props));
}



var $amdkE = parcelRequire("amdkE");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4KS7f = parcelRequire("4KS7f");


var $9gE7g = parcelRequire("9gE7g");


var $g5gZt = parcelRequire("g5gZt");


var $ghftu = parcelRequire("ghftu");


var $hmuev = parcelRequire("hmuev");


var $aGop9 = parcelRequire("aGop9");

var $iVuOI = parcelRequire("iVuOI");


var $1lhEF = parcelRequire("1lhEF");




var $dh538 = parcelRequire("dh538");


var $291hi = parcelRequire("291hi");

var $26eSY = parcelRequire("26eSY");

var $fFc6D = parcelRequire("fFc6D");














var $fNh3C = parcelRequire("fNh3C");

const $be8eb3f37dd41711$var$triggerButton = null; /**
                             * Clean up nav3 button once Confluence has cleaned up nav3
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $be8eb3f37dd41711$var$nav3ButtonTextStyles = null;
const $be8eb3f37dd41711$var$messages = (0, $aXWIB.defineMessages)({
    secondaryButtonTooltipText: {
        id: "platform.navigation-experiences.universal-create.secondary-tooltip-text",
        defaultMessage: "More create options"
    }
});
function $be8eb3f37dd41711$var$TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: text,
        tag: "span",
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: true
    }, children);
}
function $be8eb3f37dd41711$var$TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: isEntryPointEnabled = false, buttonOnly: buttonOnly = false }) {
    const isButtonOnly = buttonOnly;
    const { product: product, sections: sections } = (0, $19BZl.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isDesktop = (0, $fFc6D.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const version = sections?.length ? 'v2' : 'v1';
    const hasHoveredRef = (0, $42omo.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? 'split' : 'standard';
    const hasFiredViewEvent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(function fireButtonViewEvent() {
        if (hasFiredViewEvent.current) return;
        hasFiredViewEvent.current = true;
        fireCreateButtonViewed({
            buttonVariant: buttonVariant,
            version: version,
            isButtonOnly: isButtonOnly
        });
    }, [
        fireCreateButtonViewed,
        buttonVariant,
        version,
        isButtonOnly
    ]); // Extract splitPrimaryRef from triggerProps for split button variant
    const { splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = triggerProps ?? {};
    const onButtonClick = (0, $42omo.useCallback)(()=>{
        /// For entrypoint path (isEntryPointEnabled is true), set to expanded when isOpen is true
        // For non-entrypoint path (isEntryPointEnabled is false), set to expanded when isOpen is false (current state), as in the legacy mode, the event is fired before menu opens.
        const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        const clickedButtonPart = isSplitButton ? 'dropdown' : 'full';
        const clickedButtonVariant = isSplitButton ? 'split' : 'standard';
        fireCreateButtonClicked({
            itemState: itemState,
            buttonPart: clickedButtonPart,
            buttonVariant: clickedButtonVariant
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick,
        isEntryPointEnabled,
        isButtonOnly,
        isSplitButton
    ]);
    const primaryItemOnClick = primaryActionItem?.onClick;
    const onPrimaryButtonClick = (0, $42omo.useCallback)((event)=>{
        const itemState = isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        fireCreateButtonClicked({
            itemState: itemState,
            buttonPart: 'primary',
            buttonVariant: 'split'
        });
        primaryItemOnClick?.(event);
    }, [
        fireCreateButtonClicked,
        isEntryPointEnabled,
        isOpen,
        primaryItemOnClick
    ]);
    const CreateIcon = isButtonOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))) : isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt)));
    const createEnterEvent = (0, $42omo.useCallback)(({ buttonPart: buttonPart, shouldTriggerMouseEnterProp: shouldTriggerMouseEnterProp = true })=>(event)=>{
            if (!hasHoveredRef.current) {
                hasHoveredRef.current = true;
                const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
                fireCreateButtonHovered({
                    buttonPart: buttonPart,
                    buttonVariant: buttonVariant,
                    itemState: itemState,
                    version: version
                });
            }
            if (shouldTriggerMouseEnterProp) onMouseEnter?.(event);
        }, [
        onMouseEnter,
        fireCreateButtonHovered,
        isOpen,
        isEntryPointEnabled,
        version,
        buttonVariant,
        isButtonOnly
    ]);
    const enterEvent = createEnterEvent({
        buttonPart: 'full'
    });
    const enterEventPrimary = createEnterEvent({
        buttonPart: 'primary'
    });
    const enterEventDropdown = createEnterEvent({
        buttonPart: 'dropdown'
    });
    const leaveEvent = (0, $42omo.useCallback)((event)=>{
        onMouseLeave?.(event);
    }, [
        onMouseLeave
    ]);
    const nav3Button = !isNav4Enabled ? /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ])
    }, product === 'confluence' ? /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $4KS7f.default), {
        ...restTriggerProps,
        appearance: "primary",
        theme: buttonTheme,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        onClick: onButtonClick,
        iconBefore: /*#__PURE__*/ $42omo.createElement(CreateIcon, {
            label: "",
            "data-vc": "global-content-create-button"
        }),
        testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children,
        isSelected: isOpen
    }, /*#__PURE__*/ $42omo.createElement((0, $26eSY.Show), {
        above: "sm",
        as: "span"
    }, children))) : /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $42omo.createElement((0, $aGop9.Button), {
        ...restTriggerProps,
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        iconBefore: CreateIcon,
        testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children
    }, /*#__PURE__*/ $42omo.createElement((0, $26eSY.Show), {
        above: "sm",
        as: "span"
    }, children)))) : null;
    const responsiveSafeButton = isNav4Enabled ? /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $26eSY.Show), {
        above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
        as: "span"
    }, /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $42omo.createElement((0, $aGop9.Button), {
        ...isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        iconBefore: CreateIcon,
        testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children,
        "data-responsive-variant": "desktop"
    }, children))), /*#__PURE__*/ $42omo.createElement((0, $291hi.Hide), {
        above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
        as: "span"
    }, /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $42omo.createElement((0, $iVuOI.IconButton), {
        ...!isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        icon: CreateIcon,
        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
        label: children,
        "data-responsive-variant": "mobile"
    })))) : null;
    const splitButtonVariant = primaryActionItem ? /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), null, /*#__PURE__*/ $42omo.createElement((0, $26eSY.Show), {
        above: (0, $jjCkw.RESPONSIVE_BREAKPOINT)
    }, /*#__PURE__*/ $42omo.createElement((0, $9gE7g.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $42omo.createElement((0, $aGop9.Button), {
        ref: splitButtonPrimaryRef,
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        onMouseEnter: enterEventPrimary,
        "aria-label": children,
        testId: "uc-trigger-button-primary"
    }, children)), /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: formatMessage($be8eb3f37dd41711$var$messages.secondaryButtonTooltipText),
        isScreenReaderAnnouncementDisabled: false
    }, /*#__PURE__*/ $42omo.createElement((0, $iVuOI.IconButton), {
        ...isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        isSelected: isOpen,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
        "data-responsive-variant": "desktop",
        label: children,
        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-split`,
        onMouseEnter: enterEventDropdown,
        onMouseLeave: leaveEvent
    })))), /*#__PURE__*/ $42omo.createElement((0, $291hi.Hide), {
        above: "sm"
    }, /*#__PURE__*/ $42omo.createElement($be8eb3f37dd41711$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $42omo.createElement((0, $iVuOI.IconButton), {
        ...!isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        icon: CreateIcon,
        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
        label: children,
        "data-responsive-variant": "mobile"
    })))) : null;
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : nav3Button;
    if (!(0, $dh538.fg)('navx_uc_spotlight_upgrade') && triggerButtonSpotlightTarget) return /*#__PURE__*/ $42omo.createElement((0, $5izcQ.default), {
        name: triggerButtonSpotlightTarget
    }, /*#__PURE__*/ $42omo.createElement((0, $1lhEF.Pulse), {
        radius: 3,
        pulse: enableTriggerPulse
    }, buttonToRender));
    return buttonToRender;
}
const $be8eb3f37dd41711$export$4129321aecd13375 = (0, $fNh3C.withIntlProvider)($be8eb3f37dd41711$var$TriggerButtonInner);









var $cAXnn = parcelRequire("cAXnn");

function $2c526ef00c6d159b$export$7080b3e976bc91ab(eventName, subscriber) {
    (0, $42omo.useEffect)(()=>{
        return (0, $cAXnn.eventEmitter).on(eventName, subscriber);
    }, [
        eventName,
        subscriber
    ]);
}





const $c41240a1ed387cb5$var$MODULE_ID = 'universal-create-popup-content';
function $c41240a1ed387cb5$export$1fd7afacc69597bb() {
    const { fireJSChunkLoadTime: fireJSChunkLoadTime } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    const loadStartTimesRef = (0, $42omo.useRef)(new Map());
    const handleLoadStart = (0, $42omo.useCallback)((event)=>{
        if (event.moduleId === $c41240a1ed387cb5$var$MODULE_ID && !hasFiredRef.current) loadStartTimesRef.current.set(event.transactionId, performance.now());
    }, []);
    const handleLoadCompleteOrError = (0, $42omo.useCallback)((event)=>{
        const startTime = loadStartTimesRef.current.get(event.transactionId);
        if (startTime !== undefined) loadStartTimesRef.current.delete(event.transactionId);
        if (event.moduleId === $c41240a1ed387cb5$var$MODULE_ID && startTime !== undefined && !hasFiredRef.current) {
            const loadTime = performance.now() - startTime;
            hasFiredRef.current = true;
            fireJSChunkLoadTime({
                durationInMs: loadTime,
                hasError: Boolean(event.error)
            });
        }
    }, [
        fireJSChunkLoadTime
    ]);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.start', handleLoadStart);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.complete', handleLoadCompleteOrError);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.error', handleLoadCompleteOrError);
}



var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $a81e67dd023ae48b$export$8970f497f10bcb6 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("2UkG4")).then((module)=>({
                default: module.PopupContent
            })), {
        moduleId: "e6344ac7",
        priority: "interaction",
        moduleId: 'universal-create-popup-content'
    }),
    getPreloadProps: (_params)=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});


function $933f33bb35905b38$var$UniversalCreateButtonLazyInner(props) {
    const { children: children, testId: testId, onClick: onClick, onClose: onClose, isOpen: isOpen, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent, buttonOnly: buttonOnly = false } = props;
    const isButtonOnly = buttonOnly;
    const primaryActionItem = 'primaryActionItem' in props ? props.primaryActionItem : undefined;
    const isResponsive = (0, $VSkIN.useIsResponsiveView)(); // Track JS chunk load time - must be called before the lazy chunk loads
    (0, $c41240a1ed387cb5$export$1fd7afacc69597bb)();
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>false);
    const handleTriggerButtonClick = (0, $42omo.useCallback)(()=>{
        setLocalIsOpen(!isLocalOpen); // Notify parent
        onClick?.();
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onClick
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setLocalIsOpen(false);
        onClose?.();
    }, [
        setLocalIsOpen,
        onClose
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((event)=>{
        onMouseEnter?.(event);
    }, [
        onMouseEnter
    ]);
    const [growthRecommendationsSessionId, setGrowthRecommendationsSessionId] = (0, $42omo.useState)(undefined);
    const menuStateContextValue = (0, $42omo.useMemo)(()=>{
        const sections = 'sections' in props && props.sections ? props.sections : [];
        const crossAppCreationConfig = 'crossAppCreationConfig' in props ? props.crossAppCreationConfig ?? {
            enabled: false
        } : {
            enabled: false
        };
        const selectedItem = 'selectedItem' in props ? props.selectedItem : undefined;
        return {
            isV2Mode: true,
            // to be removed
            items: [],
            // to be removed
            product: props.product ?? 'unknown',
            subProduct: props.subProduct,
            isNav4Enabled: isNav4Enabled,
            sections: sections,
            crossAppCreationConfig: crossAppCreationConfig,
            suggestionConfig: {
                enabled: false
            },
            selectedItem: // to be removed
            selectedItem,
            preventClose: props.preventClose,
            primaryActionItem: primaryActionItem,
            growthRecommendationsSessionId: growthRecommendationsSessionId,
            setGrowthRecommendationsSessionId: setGrowthRecommendationsSessionId
        };
    }, [
        props,
        isNav4Enabled,
        primaryActionItem,
        growthRecommendationsSessionId
    ]);
    const sharedTriggerButtonProps = (0, $42omo.useMemo)(()=>({
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: handleTriggerButtonClick,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme
        }), [
        testId,
        triggerButtonSpotlightTarget,
        enableTriggerPulse,
        handleMouseEnter,
        onMouseLeave,
        handleTriggerButtonClick,
        isNav4Enabled,
        buttonTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19BZl.MenuStateContext).Provider, {
        value: menuStateContextValue
    }, isButtonOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $be8eb3f37dd41711$export$4129321aecd13375), {
        ...sharedTriggerButtonProps,
        buttonOnly: true
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea48362f2f432197$export$8f8a5b7d7394d1f8), {
        isOpen: isLocalOpen,
        placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
        shouldRenderToParent: shouldRenderToParent,
        onClose: handleClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $be8eb3f37dd41711$export$4129321aecd13375), {
                ...sharedTriggerButtonProps,
                buttonOnly: undefined,
                isEntryPointEnabled: true,
                triggerProps: triggerProps,
                isOpen: triggerProps['aria-expanded'],
                primaryActionItem: primaryActionItem
            }, children),
        entryPoint: (0, $a81e67dd023ae48b$export$8970f497f10bcb6),
        entryPointProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amdkE.LoadingMenu), {
            padded: true
        })
    }));
}
function $933f33bb35905b38$export$3739611c05de95f9(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f67c117a92e3943c$export$a546442f39c56898), {
        id: "universalCreateComponentLoad"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caUKj.BFFProvider), {
        consumer: (0, $4jETc.BFFConsumerEnum).UNIVERSAL_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cei05.UniversalCreateBFFProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7c773b6c8a524b1$export$63b55d605f8a2340), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($933f33bb35905b38$var$UniversalCreateButtonLazyInner, props)))))));
}


function $3c02e04bd46fd309$export$5c89068caaa33f77(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A2e6.GenericErrorBoundary), {
        name: "universal-create-button-lazy",
        app: props.product
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $933f33bb35905b38$export$3739611c05de95f9), props));
}



var $7aRa9 = parcelRequire("7aRa9");








var $lBYCH = parcelRequire("lBYCH");














var $ep3mz = parcelRequire("ep3mz");








var $3jwuS = parcelRequire("3jwuS");





var $e4o8D = parcelRequire("e4o8D");


var $eB1TF = parcelRequire("eB1TF");


























var $1KBSi = parcelRequire("1KBSi");


var $yuLaV = parcelRequire("yuLaV");





var $kDja4 = parcelRequire("kDja4");








var $8cKgI = parcelRequire("8cKgI");





var $7EIq6 = parcelRequire("7EIq6");


var $fSDMD = parcelRequire("fSDMD");













function $74f584384b392485$export$ac119ad1f3e15167() {
    const $ = (0, $frIzR.c)(6);
    const { accessStatus: accessStatus, edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const isStandardUser = edition === (0, $d9tcB.ConfluenceEdition).STANDARD;
    let t0;
    if ($[0] !== isAnonymousUser || $[1] !== isStandardUser) {
        t0 = isStandardUser && !isAnonymousUser ? (0, $6mKj3.expVal)("navx_universal_create_cwr_split_button", "cohort", "control") : "not-enrolled";
        $[0] = isAnonymousUser;
        $[1] = isStandardUser;
        $[2] = t0;
    } else t0 = $[2];
    const cohort = t0;
    const isEnabled = cohort === "variant_1" || cohort === "variant_2";
    let t1;
    if ($[3] !== cohort || $[4] !== isEnabled) {
        t1 = {
            cohort: cohort,
            isEnabled: isEnabled
        };
        $[3] = cohort;
        $[4] = isEnabled;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
}





parcelRequire("42omo");





var $e0ycV = parcelRequire("e0ycV");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");











var $jyA9t = parcelRequire("jyA9t");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");




const $27cf2e1d8d21e923$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af(t0) {
    const $ = (0, $frIzR.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[5] !== createHref || $[6] !== hybridLinkClick || $[7] !== isRovoLLMEnabled || $[8] !== onClick || $[9] !== openModal || $[10] !== push || $[11] !== source || $[12] !== spaceKey) {
        t3 = (e)=>{
            onClick("createLiveDocPopoverItem");
            if (isRovoLLMEnabled && (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "cohort", "variant3")) {
                e?.preventDefault();
                openModal({
                    entryPoint: `${source}-cwrBlankObject`,
                    spaceKey: spaceKey,
                    initialOutcomeType: "liveDoc",
                    lockInitialOutcomeType: true,
                    onCloseCallback: ()=>push(createHref)
                });
                return;
            }
            hybridLinkClick(e);
        };
        $[5] = createHref;
        $[6] = hybridLinkClick;
        $[7] = isRovoLLMEnabled;
        $[8] = onClick;
        $[9] = openModal;
        $[10] = push;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t3;
    } else t3 = $[13];
    const handleClick = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:livedoc");
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== formatMessage) {
        t5 = formatMessage($27cf2e1d8d21e923$var$messages.title);
        $[15] = formatMessage;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== enforceStorageLimit || $[18] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[17] = enforceStorageLimit;
        $[18] = handleClick;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== createHref || $[21] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[20] = createHref;
        $[21] = shouldBlockCreate;
        $[22] = t7;
    } else t7 = $[22];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            ...t7,
            testId: t8
        };
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
}









var $8jHAi = parcelRequire("8jHAi");

























const $f6498381976d168b$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f(t0) {
    const $ = (0, $frIzR.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-page-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[5] !== createHref || $[6] !== hybridPageLinkClick || $[7] !== isRovoLLMEnabled || $[8] !== onClick || $[9] !== openModal || $[10] !== push || $[11] !== source || $[12] !== spaceKey) {
        t3 = (e)=>{
            onClick("createPagePopoverItem");
            if (isRovoLLMEnabled && (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "cohort", "variant3")) {
                e.preventDefault();
                openModal({
                    entryPoint: `${source}-cwrBlankObject`,
                    spaceKey: spaceKey,
                    initialOutcomeType: "page",
                    lockInitialOutcomeType: true,
                    onCloseCallback: ()=>push(createHref)
                });
                return;
            }
            hybridPageLinkClick(e);
        };
        $[5] = createHref;
        $[6] = hybridPageLinkClick;
        $[7] = isRovoLLMEnabled;
        $[8] = onClick;
        $[9] = openModal;
        $[10] = push;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t3;
    } else t3 = $[13];
    const handleClick = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== formatMessage) {
        t5 = formatMessage($f6498381976d168b$var$messages.title);
        $[15] = formatMessage;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== enforceStorageLimit || $[18] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[17] = enforceStorageLimit;
        $[18] = handleClick;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== createHref || $[21] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[20] = createHref;
        $[21] = shouldBlockCreate;
        $[22] = t7;
    } else t7 = $[22];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            ...t7,
            testId: t8
        };
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
}















var $ZDq1z = parcelRequire("ZDq1z");





var $gj7hi = parcelRequire("gj7hi");








var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");







var $eVXGa = parcelRequire("eVXGa");




















var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $dcUvx = parcelRequire("dcUvx");

const $10e7e2c648ba4dd0$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $10e7e2c648ba4dd0$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $10e7e2c648ba4dd0$var$F1GameWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children } = t0;
    const [showRacecarIcon, setShowRacecarIcon] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (_)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (__0)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleOnMouseLeave = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.itemWrapper
        ]);
        t4 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.childrenWrapper
        ]);
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== children) {
        t5 = children();
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== showRacecarIcon) {
        t7 = showRacecarIcon && (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            alt: "",
            testId: "confluence-whiteboards-car-icon",
            className: (0, $gMc0m.default)([
                $10e7e2c648ba4dd0$var$f1GameStyles.rightIcon
            ])
        });
        $[8] = showRacecarIcon;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handleOnMouseEnter,
            onFocus: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onBlur: handleOnMouseLeave,
            className: t3
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5(t0) {
    const $ = (0, $frIzR.c)(43);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== isOpen) {
        t1 = (0, $9wGTI.fg)("load-whiteboards-paywall-query-when-menu-is-open") && !isOpen;
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    const skipPaywallQuery = t1;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "create-whiteboard-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== deactivationIdentifier || $[4] !== parentId || $[5] !== paywallStatus || $[6] !== source || $[7] !== spaceKey) {
        t3 = (t4, t5)=>{
            const creationOverrides = t4 === undefined ? {} : t4;
            const sourceSuffix = t5 === undefined ? "" : t5;
            return (0, $bZSO8.buildCreationLink)({
                contentType: "whiteboard",
                parentPageId: parentId,
                withFallback: true,
                source: source + sourceSuffix,
                spaceKey: spaceKey,
                deactivationIdentifier: deactivationIdentifier,
                paywallStatus: paywallStatus,
                ...creationOverrides
            });
        };
        $[3] = deactivationIdentifier;
        $[4] = parentId;
        $[5] = paywallStatus;
        $[6] = source;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const buildWhiteboardCreationLink = t3;
    let t4;
    if ($[9] !== buildWhiteboardCreationLink) {
        t4 = buildWhiteboardCreationLink();
        $[9] = buildWhiteboardCreationLink;
        $[10] = t4;
    } else t4 = $[10];
    const createHref = t4;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t5;
    if ($[11] !== buildWhiteboardCreationLink || $[12] !== createAnalyticsEvent || $[13] !== creationPaywallError || $[14] !== experienceTracker || $[15] !== hybridLinkClick || $[16] !== onClick || $[17] !== paywallStatus || $[18] !== showModal || $[19] !== showPaywallBeforeCreate || $[20] !== source) {
        t5 = (e)=>{
            onClick("createWhiteboardPopoverItem");
            if ((0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled")) {
                experienceTracker.start({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                    collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
                });
                if (creationPaywallError) experienceTracker.fail({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    error: creationPaywallError
                });
            }
            if (showPaywallBeforeCreate) {
                e.stopPropagation();
                e.preventDefault();
                showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                    buildWhiteboardCreationLink: buildWhiteboardCreationLink
                });
            } else {
                if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "createUnsetWhiteboardLink",
                        source: source,
                        attributes: {
                            reason: creationPaywallError ? "error" : "loading"
                        }
                    }
                }).fire();
                hybridLinkClick(e);
            }
        };
        $[11] = buildWhiteboardCreationLink;
        $[12] = createAnalyticsEvent;
        $[13] = creationPaywallError;
        $[14] = experienceTracker;
        $[15] = hybridLinkClick;
        $[16] = onClick;
        $[17] = paywallStatus;
        $[18] = showModal;
        $[19] = showPaywallBeforeCreate;
        $[20] = source;
        $[21] = t5;
    } else t5 = $[21];
    const handleClick = t5;
    let t6;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:whiteboard");
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== creationPaywallError) {
        t7 = !(0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }));
        $[23] = creationPaywallError;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== formatMessage) {
        t8 = formatMessage($10e7e2c648ba4dd0$var$messages.title);
        $[25] = formatMessage;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t7, t8);
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== enforceStorageLimit || $[31] !== handleClick) {
        t10 = enforceStorageLimit(handleClick);
        $[30] = enforceStorageLimit;
        $[31] = handleClick;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && {
            Wrapper: $10e7e2c648ba4dd0$var$F1GameWrapper
        };
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== createHref || $[35] !== isAllowedToCreateWhiteboard || $[36] !== shouldBlockCreate) {
        t12 = !shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        };
        $[34] = createHref;
        $[35] = isAllowedToCreateWhiteboard;
        $[36] = shouldBlockCreate;
        $[37] = t12;
    } else t12 = $[37];
    const t13 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t14;
    if ($[38] !== t10 || $[39] !== t12 || $[40] !== t13 || $[41] !== t9) {
        t14 = {
            ati: t6,
            children: t9,
            onClick: t10,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            ...t11,
            ...t12,
            testId: t13
        };
        $[38] = t10;
        $[39] = t12;
        $[40] = t13;
        $[41] = t9;
        $[42] = t14;
    } else t14 = $[42];
    return t14;
}









var $6B0jU = parcelRequire("6B0jU");













const $c6e82055c002803e$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-database-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "database",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createDatabasePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:database");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($c6e82055c002803e$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}









var $9RVmI = parcelRequire("9RVmI");













const $b66cd3653b467139$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0(t0) {
    const $ = (0, $frIzR.c)(21);
    const { source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-blog-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== source || $[2] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "blog",
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = source;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[4] !== hybridPageLinkClick || $[5] !== onClick) {
        t3 = (e)=>{
            onClick("createBlogPopoverItem");
            hybridPageLinkClick(e);
        };
        $[4] = hybridPageLinkClick;
        $[5] = onClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:blogpost");
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($b66cd3653b467139$var$messages.title);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== enforceStorageLimit || $[11] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[10] = enforceStorageLimit;
        $[11] = handleClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== createHref || $[14] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[13] = createHref;
        $[14] = shouldBlockCreate;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            ...t7,
            testId: t8
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
}









var $duwSm = parcelRequire("duwSm");













const $2e6ededdd99584ac$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-smart-link-embed-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "smartLinkEmbed",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createSmartLinkEmbedPopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:embed");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2e6ededdd99584ac$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}









var $buthI = parcelRequire("buthI");


var $hbYDZ = parcelRequire("hbYDZ");





var $gdv5Z = parcelRequire("gdv5Z");











var $bAyaS = parcelRequire("bAyaS");



















const $293cf5b691bb25ab$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal({
            entryPoint: 'globalCreateSpaceButton',
            spaceKey: ''
        });
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}















var $2Yaht = parcelRequire("2Yaht");


var $jojoK = parcelRequire("jojoK");





var $4R3wx = parcelRequire("4R3wx");





var $f5Ulo = parcelRequire("f5Ulo");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");








var $7QM6o = parcelRequire("7QM6o");











var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");





var $ibDKJ = parcelRequire("ibDKJ");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== lozenge || $[3] !== useLabsLozenge) {
        t2 = useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, lozenge);
        $[2] = lozenge;
        $[3] = useLabsLozenge;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};


const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(flags, error, loading, source) {
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage || $[2] !== source) {
        t0 = (t1)=>{
            const { children: children } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
                entryPointId: "loom-confluence-create-menu",
                sourceComponent: source,
                shouldRenderToParent: false,
                title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
                sourceActionSubjectId: "createLoomPopoverItem",
                triggerLink: (_, triggerProps)=>children({
                        triggerProps: triggerProps
                    }),
                flags: (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined
            });
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = source;
        $[3] = t0;
    } else t0 = $[3];
    const PopupWrapper = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6yCpa.Ati).parse("ati:cloud:loom:video");
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== error || $[6] !== href || $[7] !== loading) {
        t2 = !(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") && !error && !loading && {
            href: href
        };
        $[5] = error;
        $[6] = href;
        $[7] = loading;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== formatMessage) {
        t4 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[11] = formatMessage;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t3
        }, t4);
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== PopupWrapper || $[17] !== loading || $[18] !== t2 || $[19] !== t5) {
        t6 = {
            ati: t1,
            ...t2,
            isLoading: loading,
            target: "_blank",
            testId: "create-menu-link-item",
            children: t5,
            Wrapper: PopupWrapper,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
        };
        $[16] = PopupWrapper;
        $[17] = loading;
        $[18] = t2;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== flags) {
        t1 = {
            entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
            flags: flags
        };
        $[0] = flags;
        $[1] = t1;
    } else t1 = $[1];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized } = (0, $9uAPw.useLoomRecorderEntryPoint)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "record-loom-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== onClick || $[5] !== openLoomRecorder || $[6] !== parentId || $[7] !== push || $[8] !== source || $[9] !== spaceId || $[10] !== spaceKey) {
        t3 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        withFallback: true,
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: "topNav"
            });
        };
        $[3] = createAnalyticsEvent;
        $[4] = onClick;
        $[5] = openLoomRecorder;
        $[6] = parentId;
        $[7] = push;
        $[8] = source;
        $[9] = spaceId;
        $[10] = spaceKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:loom:video");
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== formatMessage) {
        t5 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = !isLoomRecorderInitialized;
    let t7;
    if ($[15] !== enforceStorageLimit || $[16] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[15] = enforceStorageLimit;
        $[16] = handleClick;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            ati: t4,
            children: t5,
            isLoading: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
            testId: "create-menu-button-item",
            onClick: t7
        };
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(props.flags, error, loading, props.source);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}





/**
 * @generated SignedSource<<d4e02d489d993b0f8ae8e4a8e3324d49>>
 * @relayHash cf7a8142cdcbe37d3303e9f1a6d24404
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db18d4aba9bfa7ce2b7393b1ffebf66fee2f7f03be07c4dc73c55dc9b234bbef
const $61db8fda73852157$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAgentItemStudioPermissionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAgentItemStudioPermissionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cf7a8142cdcbe37d3303e9f1a6d24404",
            "id": "db18d4aba9bfa7ce2b7393b1ffebf66fee2f7f03be07c4dc73c55dc9b234bbef",
            "metadata": {},
            "name": "useAgentItemStudioPermissionsQuery",
            "operationKind": "query",
            "text": "query useAgentItemStudioPermissionsQuery($cloudId:ID!){atlassianStudio_userSiteContext(cloudId:$cloudId){__typename,...on AtlassianStudioUserSiteContextOutput{userPermissions{isAbleToCreateAgents}}}}"
        }
    };
}();
$61db8fda73852157$var$node.hash = "e36ad0baf31f5ea68cd229d0a5f813d5";
var $61db8fda73852157$export$2e2bcd8739ae039 = $61db8fda73852157$var$node;












var $7rzV8 = parcelRequire("7rzV8");


var $hge3g = parcelRequire("hge3g");





var $blT4H = parcelRequire("blT4H");























const $2ff1eff0e2529636$var$CONNIE_CREATE_SOURCE = 'connie-create';
const $2ff1eff0e2529636$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.agent.title",
        defaultMessage: "Create agent"
    },
    titleV2: {
        id: "create-blank-fabric-page.universal-create.agent.title.v2",
        defaultMessage: "Agent"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.agent.new-lozenge",
        defaultMessage: "New"
    }
});
const $2ff1eff0e2529636$var$AgentMenuItem = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { source: source } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "createAgentPopoverItem",
                    attributes: {
                        source: source
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($2ff1eff0e2529636$var$messages.newLozenge);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage($2ff1eff0e2529636$var$messages.title);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t3
        }, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
function $2ff1eff0e2529636$export$392c5ffed7e61e1e(t0) {
    const $ = (0, $frIzR.c)(33);
    const { onClick: onClick, source: source, isMenuOpen: isMenuOpen } = t0;
    const { cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchPoint: $2ff1eff0e2529636$var$CONNIE_CREATE_SOURCE
        };
        $[0] = t1;
    } else t1 = $[0];
    const [csid, t2] = (0, $7rzV8.useRovoAgentCreateAnalytics)(t1);
    const { trackCreateSessionStart: trackCreateSessionStart } = t2;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t3;
    if ($[1] !== cloudId || $[2] !== isAnonymousUser || $[3] !== isMenuOpen || $[4] !== isRovoLLMEnabled) {
        t3 = isRovoLLMEnabled && !isAnonymousUser && !!cloudId && !!isMenuOpen && (0, $9wGTI.fg)("cc_fd_agent_creation_connie_create_gate");
        $[1] = cloudId;
        $[2] = isAnonymousUser;
        $[3] = isMenuOpen;
        $[4] = isRovoLLMEnabled;
        $[5] = t3;
    } else t3 = $[5];
    const shouldCheckAgentsPermissions = t3;
    let t4;
    if ($[6] !== cloudId) {
        t4 = {
            cloudId: cloudId
        };
        $[6] = cloudId;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = !shouldCheckAgentsPermissions;
    let t6;
    let t7;
    if ($[8] !== createAnalyticsEvent || $[9] !== source) {
        t6 = (resp)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: source,
                    action: "success",
                    actionSubject: "studioPermissionsQuery",
                    actionSubjectId: "confluenceCreateMenu",
                    attributes: {
                        isAbleToCreateAgents: resp?.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents
                    }
                }
            }).fire();
        };
        t7 = (error)=>{
            if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error) && ((0, $1uFM6.isUnauthorizedError)(error) || error?.message.includes("Failed to fetch"))) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return;
            }
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: source,
                    action: "error",
                    actionSubject: "studioPermissionsQuery",
                    actionSubjectId: "confluenceCreateMenu",
                    attributes: {
                        errorMessage: error.message
                    }
                }
            }).fire();
        };
        $[8] = createAnalyticsEvent;
        $[9] = source;
        $[10] = t6;
        $[11] = t7;
    } else {
        t6 = $[10];
        t7 = $[11];
    }
    let t8;
    if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
        t8 = {
            variables: t4,
            skip: t5,
            interopApolloAggClient: true,
            onCompleted: t6,
            onError: t7
        };
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $61db8fda73852157$export$2e2bcd8739ae039), {
        ...t8,
        __callerPackage__: "@confluence/create-blank-fabric-page"
    });
    const hasPermission = data?.atlassianStudio_userSiteContext?.userPermissions?.isAbleToCreateAgents ?? false;
    const isEligible = shouldCheckAgentsPermissions && hasPermission;
    let t9;
    if ($[17] !== cloudId || $[18] !== csid) {
        t9 = (0, $blT4H.getAtlassianStudioNLCreateUrl)(cloudId, $2ff1eff0e2529636$var$CONNIE_CREATE_SOURCE, csid);
        $[17] = cloudId;
        $[18] = csid;
        $[19] = t9;
    } else t9 = $[19];
    const createAgentUrl = t9;
    let t10;
    if ($[20] !== onClick || $[21] !== trackCreateSessionStart) {
        t10 = ()=>{
            trackCreateSessionStart();
            onClick("createAgentPopoverItem");
        };
        $[20] = onClick;
        $[21] = trackCreateSessionStart;
        $[22] = t10;
    } else t10 = $[22];
    const handleClick = t10;
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:rovo");
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== source) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2ff1eff0e2529636$var$AgentMenuItem, {
            source: source
        });
        $[24] = source;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== createAgentUrl || $[27] !== handleClick || $[28] !== t12) {
        t13 = {
            ati: t11,
            children: t12,
            href: createAgentUrl,
            target: "_blank",
            onClick: handleClick,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hge3g))),
            testId: "create-menu-link-item"
        };
        $[26] = createAgentUrl;
        $[27] = handleClick;
        $[28] = t12;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== isEligible || $[31] !== t13) {
        t14 = [
            t13,
            isEligible
        ];
        $[30] = isEligible;
        $[31] = t13;
        $[32] = t14;
    } else t14 = $[32];
    return t14;
}












var $h7YX1 = parcelRequire("h7YX1");





var $16lEl = parcelRequire("16lEl");

var $hUyPY = parcelRequire("hUyPY");





var $dDAsV = parcelRequire("dDAsV");








var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};














var $9xkp4 = parcelRequire("9xkp4");











var $cbBHq = parcelRequire("cbBHq");

function $bbf9a31d260032f2$export$22e3b23b85c78fe8(t0) {
    const $ = (0, $frIzR.c)(9);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isDisabled: t2, includePromptSuggestions: t3 } = t1;
    const isDisabled = t2 === undefined ? false : t2;
    const includePromptSuggestions = t3 === undefined ? true : t3;
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const { loadSuggestions: loadSuggestions } = $bbf9a31d260032f2$var$useOptionalPromptSuggestions(includePromptSuggestions);
    let t4;
    if ($[2] !== includePromptSuggestions || $[3] !== isDisabled || $[4] !== loadSuggestions || $[5] !== preloadSmartCreationModal) {
        t4 = ()=>{
            preloadSmartCreationModal();
            if (!includePromptSuggestions) return;
            if (!isDisabled && (0, $9wGTI.fg)("confluence_personalized_prompts_header_preload") && (0, $6mKj3.expValEquals)("confluence_personalized_prompt_suggestions", "isEnabled", true)) loadSuggestions?.();
        };
        $[2] = includePromptSuggestions;
        $[3] = isDisabled;
        $[4] = loadSuggestions;
        $[5] = preloadSmartCreationModal;
        $[6] = t4;
    } else t4 = $[6];
    const preload = t4;
    let t5;
    if ($[7] !== preload) {
        t5 = {
            preload: preload
        };
        $[7] = preload;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
}
function $bbf9a31d260032f2$var$useOptionalPromptSuggestions(includePromptSuggestions) {
    const $ = (0, $frIzR.c)(4);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            assistanceServiceParams: {
                product: "confluence",
                experienceId: "confluence-smart-create",
                touchpointSource: "smart-create-preload-prompt-suggestions",
                siteId: cloudId
            }
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const promptSuggestionsParams = t0;
    const { loadSuggestions: loadSuggestions } = (0, $9xkp4.usePromptSuggestions)(promptSuggestionsParams);
    const t1 = includePromptSuggestions ? loadSuggestions : undefined;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            loadSuggestions: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
}





const $03068ae1a528f6bf$var$i18n = (0, $aXWIB.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2(t0) {
    const $ = (0, $frIzR.c)(34);
    const { spaceKey: spaceKey, onClick: onClick, source: source, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)("");
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $42omo.useState)(true);
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setSpaceKeyLoading(true);
            $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[2] !== isDisabled) {
        t4 = {
            isDisabled: isDisabled
        };
        $[2] = isDisabled;
        $[3] = t4;
    } else t4 = $[3];
    const { preload: smartCreatePreload } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t4);
    let t5;
    let t6;
    if ($[4] !== isCwrSplitButtonEnabled || $[5] !== isOpen || $[6] !== smartCreatePreload) {
        t5 = ()=>{
            if (isCwrSplitButtonEnabled || !isOpen) return;
            smartCreatePreload();
        };
        t6 = [
            isCwrSplitButtonEnabled,
            isOpen,
            smartCreatePreload
        ];
        $[4] = isCwrSplitButtonEnabled;
        $[5] = isOpen;
        $[6] = smartCreatePreload;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[9] !== experienceTracker || $[10] !== fetchedSpaceKey || $[11] !== openModal || $[12] !== source || $[13] !== spaceKey) {
        t7 = ()=>{
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal({
                entryPoint: source,
                spaceKey: spaceKey ?? fetchedSpaceKey
            });
        };
        $[9] = experienceTracker;
        $[10] = fetchedSpaceKey;
        $[11] = openModal;
        $[12] = source;
        $[13] = spaceKey;
        $[14] = t7;
    } else t7 = $[14];
    const handleOpenCreateWithRovoExperience = t7;
    let t8;
    if ($[15] !== handleOpenCreateWithRovoExperience || $[16] !== onClick) {
        t8 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenCreateWithRovoExperience();
        };
        $[15] = handleOpenCreateWithRovoExperience;
        $[16] = onClick;
        $[17] = t8;
    } else t8 = $[17];
    const handleItemOnClick = t8;
    let t9;
    if ($[18] !== handleOpenCreateWithRovoExperience || $[19] !== source || $[20] !== spaceKeyLoading) {
        t9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a873bb1c9107ef25$export$8432db7340d3c5cd), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children());
        $[18] = handleOpenCreateWithRovoExperience;
        $[19] = source;
        $[20] = spaceKeyLoading;
        $[21] = t9;
    } else t9 = $[21];
    const CreateWithRovoSpotlightWrapper = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[22] = t10;
    } else t10 = $[22];
    const href = t10;
    let t11;
    if ($[23] !== formatMessage) {
        t11 = ()=>{
            if ((0, $9wGTI.fg)("aifc_onboarding_ga_enabled")) {
                if ((0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true)) return formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
                useLabsLozenge: true
            }, formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle));
        };
        $[23] = formatMessage;
        $[24] = t11;
    } else t11 = $[24];
    const getChildren = t11;
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:rovo");
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== getChildren) {
        t13 = getChildren();
        $[26] = getChildren;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== handleItemOnClick) {
        t14 = (e_0)=>handleItemOnClick(e_0, "createAISmartCreatePopoverItem");
        $[28] = handleItemOnClick;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== CreateWithRovoSpotlightWrapper || $[31] !== t13 || $[32] !== t14) {
        t15 = {
            ati: t12,
            children: t13,
            Wrapper: CreateWithRovoSpotlightWrapper,
            onClick: t14,
            href: href,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
            testId: "create-menu-link-item"
        };
        $[30] = CreateWithRovoSpotlightWrapper;
        $[31] = t13;
        $[32] = t14;
        $[33] = t15;
    } else t15 = $[33];
    return t15;
}












var $g5QRf = parcelRequire("g5QRf");
























const $6bc7537bf6fb1efd$var$i18n = (0, $aXWIB.defineMessages)({
    slideTitle: {
        id: "create-blank-fabric-page.create.content.slides.title",
        defaultMessage: "Slides"
    },
    labsLozenge: {
        id: "create-blank-fabric-page.create.content.slides.labs-lozenge",
        defaultMessage: "LABS"
    }
});
const $6bc7537bf6fb1efd$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $6bc7537bf6fb1efd$export$d71a131cfb663e9a(t0) {
    const $ = (0, $frIzR.c)(31);
    const { spaceKey: spaceKey, onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            includePromptSuggestions: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const { preload: preloadSmartCreate } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t1);
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)("");
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            $6bc7537bf6fb1efd$var$getSpaceKeyForCreation().then(setFetchedSpaceKey);
        };
        t3 = [];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCwrSplitButtonEnabled || $[4] !== isOpen || $[5] !== preloadSmartCreate) {
        t4 = ()=>{
            if (isCwrSplitButtonEnabled || !isOpen) return;
            preloadSmartCreate();
        };
        t5 = [
            isCwrSplitButtonEnabled,
            isOpen,
            preloadSmartCreate
        ];
        $[3] = isCwrSplitButtonEnabled;
        $[4] = isOpen;
        $[5] = preloadSmartCreate;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[8] !== experienceTracker || $[9] !== fetchedSpaceKey || $[10] !== openModal || $[11] !== source || $[12] !== spaceKey) {
        t6 = ()=>{
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal({
                entryPoint: source,
                spaceKey: spaceKey ?? fetchedSpaceKey,
                initialOutcomeType: "slides"
            });
        };
        $[8] = experienceTracker;
        $[9] = fetchedSpaceKey;
        $[10] = openModal;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t6;
    } else t6 = $[13];
    const handleOpenSlideCreation = t6;
    let t7;
    if ($[14] !== handleOpenSlideCreation || $[15] !== onClick) {
        t7 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenSlideCreation();
        };
        $[14] = handleOpenSlideCreation;
        $[15] = onClick;
        $[16] = t7;
    } else t7 = $[16];
    const handleItemOnClick = t7;
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[17] = t8;
    } else t8 = $[17];
    const href = t8;
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:slide");
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== formatMessage) {
        t10 = formatMessage($6bc7537bf6fb1efd$var$i18n.labsLozenge);
        $[19] = formatMessage;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== formatMessage) {
        t11 = formatMessage($6bc7537bf6fb1efd$var$i18n.slideTitle);
        $[21] = formatMessage;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t10 || $[24] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t10
        }, t11);
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== handleItemOnClick) {
        t13 = (e_0)=>handleItemOnClick(e_0, "createSlidePopoverItem");
        $[26] = handleItemOnClick;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t12 || $[29] !== t13) {
        t14 = {
            ati: t9,
            children: t12,
            onClick: t13,
            href: href,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
            testId: "create-menu-slide-link-item"
        };
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
}



var $kvDd7 = parcelRequire("kvDd7");

const $279d18c421fdc96b$export$9131280d9d18988b = 'globalCreateContentPopover';
const $279d18c421fdc96b$export$9c9b6bde1131681e = 5;
const $279d18c421fdc96b$var$messages = (0, $aXWIB.defineMessages)({
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
const $279d18c421fdc96b$var$toAppDefinedSection = (section)=>({
        type: 'appDefinedSection',
        ...section
    });
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom, isMenuOpen) {
    const $ = (0, $frIzR.c)(166);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { cohort: cwrSplitButtonCohort, isEnabled: splitButtonExperimentEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isOnEditRoute || $[3] !== openFrom || $[4] !== routeDataRef) {
        t0 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: $279d18c421fdc96b$export$9131280d9d18988b,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        openFrom: openFrom,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isOnEditRoute;
        $[3] = openFrom;
        $[4] = routeDataRef;
        $[5] = t0;
    } else t0 = $[5];
    const handleAnalyticsAndResetStickySearch = t0;
    let t1;
    if ($[6] !== closeMenu || $[7] !== handleAnalyticsAndResetStickySearch) {
        t1 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            closeMenu?.();
        };
        $[6] = closeMenu;
        $[7] = handleAnalyticsAndResetStickySearch;
        $[8] = t1;
    } else t1 = $[8];
    const onClick = t1;
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const t2 = !isMenuOpen;
    let t3;
    if ($[9] !== t2) {
        t3 = {
            skip: t2
        };
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const { isEnabled: isTemplateTouchpointEnabled } = (0, $8cKgI.useCfind5291TemplateTouchpoint)(t3);
    let t4;
    if ($[11] !== contentId || $[12] !== onClick || $[13] !== spaceKey) {
        t4 = {
            source: "globalCreateDropdown-startFromTemplate",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[11] = contentId;
        $[12] = onClick;
        $[13] = spaceKey;
        $[14] = t4;
    } else t4 = $[14];
    const startFromTemplate = (0, $kvDd7.useStartFromTemplateItem)(t4);
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const isAifcEnabled = isRovoLLMEnabled && !isAnonymousUser;
    const t5 = !isAifcEnabled;
    let t6;
    if ($[15] !== onClick || $[16] !== openFrom || $[17] !== spaceKey || $[18] !== t5) {
        t6 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onClick,
            openFrom: openFrom,
            isDisabled: t5
        };
        $[15] = onClick;
        $[16] = openFrom;
        $[17] = spaceKey;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    const smartCreate = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t6);
    let t7;
    if ($[20] !== onClick || $[21] !== spaceKey) {
        t7 = {
            source: "globalCreateDropdown-slide",
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[20] = onClick;
        $[21] = spaceKey;
        $[22] = t7;
    } else t7 = $[22];
    const slide = (0, $6bc7537bf6fb1efd$export$d71a131cfb663e9a)(t7);
    let t8;
    if ($[23] !== contentId || $[24] !== onClick || $[25] !== spaceKey) {
        t8 = {
            source: "globalCreateDropdown-liveDoc",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[23] = contentId;
        $[24] = onClick;
        $[25] = spaceKey;
        $[26] = t8;
    } else t8 = $[26];
    const liveDoc = (0, $27cf2e1d8d21e923$export$5af7ed73ba9cf3af)(t8);
    let t9;
    if ($[27] !== contentId || $[28] !== onClick || $[29] !== spaceKey) {
        t9 = {
            source: "globalCreateDropdown-page",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[27] = contentId;
        $[28] = onClick;
        $[29] = spaceKey;
        $[30] = t9;
    } else t9 = $[30];
    const page = (0, $f6498381976d168b$export$e324b86258d66a8f)(t9);
    let t10;
    if ($[31] !== contentId || $[32] !== onClick || $[33] !== spaceKey) {
        t10 = {
            source: "globalCreateDropdown-whiteboard",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[31] = contentId;
        $[32] = onClick;
        $[33] = spaceKey;
        $[34] = t10;
    } else t10 = $[34];
    const whiteboard = (0, $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5)(t10);
    let t11;
    if ($[35] !== contentId || $[36] !== onClick || $[37] !== spaceKey) {
        t11 = {
            source: "globalCreateDropdown-database",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[35] = contentId;
        $[36] = onClick;
        $[37] = spaceKey;
        $[38] = t11;
    } else t11 = $[38];
    const database = (0, $c6e82055c002803e$export$c03ba1b69410a0fd)(t11);
    let t12;
    if ($[39] !== contentId || $[40] !== onClick || $[41] !== spaceKey) {
        t12 = {
            source: "globalCreateDropdown-blog",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[39] = contentId;
        $[40] = onClick;
        $[41] = spaceKey;
        $[42] = t12;
    } else t12 = $[42];
    const blog = (0, $b66cd3653b467139$export$1850e31ba3eb45b0)(t12);
    let t13;
    if ($[43] !== contentId || $[44] !== onClick || $[45] !== spaceKey) {
        t13 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[43] = contentId;
        $[44] = onClick;
        $[45] = spaceKey;
        $[46] = t13;
    } else t13 = $[46];
    const embed = (0, $2e6ededdd99584ac$export$da2a30a64353a280)(t13);
    let t14;
    if ($[47] !== contentId || $[48] !== flags || $[49] !== onClick || $[50] !== spaceKey) {
        t14 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            flags: flags
        };
        $[47] = contentId;
        $[48] = flags;
        $[49] = onClick;
        $[50] = spaceKey;
        $[51] = t14;
    } else t14 = $[51];
    const loom = (0, $3e0600a499c498b6$export$2c423d86f10c527b)(t14);
    let t15;
    if ($[52] !== contentId || $[53] !== isMenuOpen || $[54] !== onClick || $[55] !== spaceKey) {
        t15 = {
            source: "globalCreateDropdown-createAgent",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            isMenuOpen: isMenuOpen
        };
        $[52] = contentId;
        $[53] = isMenuOpen;
        $[54] = onClick;
        $[55] = spaceKey;
        $[56] = t15;
    } else t15 = $[56];
    const [createAgent, isAgentItemEligible] = (0, $2ff1eff0e2529636$export$392c5ffed7e61e1e)(t15);
    let t16;
    if ($[57] !== contentId || $[58] !== onClick || $[59] !== spaceKey) {
        t16 = {
            source: $279d18c421fdc96b$export$9131280d9d18988b,
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[57] = contentId;
        $[58] = onClick;
        $[59] = spaceKey;
        $[60] = t16;
    } else t16 = $[60];
    const space = (0, $293cf5b691bb25ab$export$4adf07b2777336fa)(t16);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    let t17;
    if ($[61] !== isWhiteboardFeatureEnabled) {
        t17 = isWhiteboardFeatureEnabled("whiteboardOptOut");
        $[61] = isWhiteboardFeatureEnabled;
        $[62] = t17;
    } else t17 = $[62];
    const isOptedOutedOfWhiteboards = t17;
    let t18;
    if ($[63] !== isWhiteboardFeatureEnabled) {
        t18 = isWhiteboardFeatureEnabled("whiteboardsEnabled");
        $[63] = isWhiteboardFeatureEnabled;
        $[64] = t18;
    } else t18 = $[64];
    const isWhiteboardsEnabled = t18;
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    let t19;
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database") && !(0, $9wGTI.fg)("confluence_frontend_databases_opt-out");
        $[65] = t19;
    } else t19 = $[65];
    const databaseOptIn = t19;
    let t20;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
        $[66] = t20;
    } else t20 = $[66];
    const slideOptIn = t20;
    const isSlideBaseEnabled = slideOptIn && isRovoLLMEnabled && !isAnonymousUser;
    let t21;
    if ($[67] !== isSlideBaseEnabled || $[68] !== slide) {
        t21 = ()=>isSlideBaseEnabled && (0, $6mKj3.expValEquals)("confluence_frontend_cwr_outcome_type_picker", "isEnabled", true) ? [
                slide
            ] : [];
        $[67] = isSlideBaseEnabled;
        $[68] = slide;
        $[69] = t21;
    } else t21 = $[69];
    const getSlideItem = t21;
    let t22;
    if ($[70] !== blog || $[71] !== database || $[72] !== embed || $[73] !== getSlideItem || $[74] !== isCreateBlogEnabled || $[75] !== isCreateDatabaseEnabled || $[76] !== isCreateSmartLinkEnabled || $[77] !== isCreateWhiteboardEnabled || $[78] !== whiteboard || $[79] !== whiteboardOptIn) {
        t22 = ()=>[
                ...getSlideItem(),
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : []
            ];
        $[70] = blog;
        $[71] = database;
        $[72] = embed;
        $[73] = getSlideItem;
        $[74] = isCreateBlogEnabled;
        $[75] = isCreateDatabaseEnabled;
        $[76] = isCreateSmartLinkEnabled;
        $[77] = isCreateWhiteboardEnabled;
        $[78] = whiteboard;
        $[79] = whiteboardOptIn;
        $[80] = t22;
    } else t22 = $[80];
    const getCommonItems = t22;
    let t23;
    if ($[81] !== canCreateSpace || $[82] !== createAgent || $[83] !== getCommonItems || $[84] !== isAgentItemEligible || $[85] !== isCreateLiveDocEnabled || $[86] !== isCreateSmartLinkEnabled || $[87] !== isLoomEntryPointEnabled || $[88] !== liveDoc || $[89] !== loom || $[90] !== page || $[91] !== space) {
        t23 = ()=>[
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...getCommonItems(),
                ...canCreateSpace ? [
                    space
                ] : [],
                ...isAgentItemEligible && (0, $6mKj3.expValEquals)("cc_fd_agent_creation_connie_create", "isEnabled", true) ? [
                    createAgent
                ] : [],
                ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                    loom
                ] : []
            ];
        $[81] = canCreateSpace;
        $[82] = createAgent;
        $[83] = getCommonItems;
        $[84] = isAgentItemEligible;
        $[85] = isCreateLiveDocEnabled;
        $[86] = isCreateSmartLinkEnabled;
        $[87] = isLoomEntryPointEnabled;
        $[88] = liveDoc;
        $[89] = loom;
        $[90] = page;
        $[91] = space;
        $[92] = t23;
    } else t23 = $[92];
    const getRemainingItems = t23;
    let t24;
    if ($[93] !== canCreateSpace || $[94] !== getCommonItems || $[95] !== isAifcEnabled || $[96] !== isCreateLiveDocEnabled || $[97] !== liveDoc || $[98] !== page || $[99] !== smartCreate || $[100] !== space || $[101] !== splitButtonExperimentEnabled) {
        t24 = ()=>[
                ...isAifcEnabled && !splitButtonExperimentEnabled ? [
                    smartCreate
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...getCommonItems(),
                ...canCreateSpace ? [
                    space
                ] : []
            ];
        $[93] = canCreateSpace;
        $[94] = getCommonItems;
        $[95] = isAifcEnabled;
        $[96] = isCreateLiveDocEnabled;
        $[97] = liveDoc;
        $[98] = page;
        $[99] = smartCreate;
        $[100] = space;
        $[101] = splitButtonExperimentEnabled;
        $[102] = t24;
    } else t24 = $[102];
    const getNativeItems = t24;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t25;
    let t26;
    if ($[103] !== blog || $[104] !== canCreateSpace || $[105] !== createAgent || $[106] !== cwrSplitButtonCohort || $[107] !== database || $[108] !== embed || $[109] !== formatMessage || $[110] !== getNativeItems || $[111] !== getRemainingItems || $[112] !== getSlideItem || $[113] !== isAgentItemEligible || $[114] !== isAifcEnabled || $[115] !== isCreateBlogEnabled || $[116] !== isCreateDatabaseEnabled || $[117] !== isCreateLiveDocEnabled || $[118] !== isCreateSmartLinkEnabled || $[119] !== isCreateWhiteboardEnabled || $[120] !== isLoomEntryPointEnabled || $[121] !== isTemplateTouchpointEnabled || $[122] !== liveDoc || $[123] !== loom || $[124] !== page || $[125] !== smartCreate || $[126] !== space || $[127] !== splitButtonExperimentEnabled || $[128] !== startFromTemplate || $[129] !== whiteboard || $[130] !== whiteboardOptIn) {
        t26 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const firstSectionItems = [
                ...isAifcEnabled && !splitButtonExperimentEnabled ? [
                    smartCreate
                ] : [],
                ...isTemplateTouchpointEnabled ? [
                    startFromTemplate
                ] : []
            ];
            const loomAndCreateAgentItems = [
                ...isAgentItemEligible && (0, $6mKj3.expValEquals)("cc_fd_agent_creation_connie_create", "isEnabled", true) ? [
                    createAgent
                ] : [],
                ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                    loom
                ] : []
            ];
            if (splitButtonExperimentEnabled) {
                const isVariant2 = cwrSplitButtonCohort === "variant_2";
                let t27;
                if ($[133] !== blog || $[134] !== canCreateSpace || $[135] !== createAgent || $[136] !== database || $[137] !== embed || $[138] !== getSlideItem || $[139] !== isAgentItemEligible || $[140] !== isCreateBlogEnabled || $[141] !== isCreateDatabaseEnabled || $[142] !== isCreateLiveDocEnabled || $[143] !== isCreateSmartLinkEnabled || $[144] !== isCreateWhiteboardEnabled || $[145] !== isLoomEntryPointEnabled || $[146] !== isTemplateTouchpointEnabled || $[147] !== isVariant2 || $[148] !== liveDoc || $[149] !== loom || $[150] !== page || $[151] !== space || $[152] !== startFromTemplate || $[153] !== whiteboard || $[154] !== whiteboardOptIn) {
                    const cwrDropdownItems = [
                        ...isCreateLiveDocEnabled ? [
                            liveDoc
                        ] : [],
                        page,
                        ...getSlideItem(),
                        ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                            whiteboard
                        ] : [],
                        ...isCreateDatabaseEnabled && databaseOptIn ? [
                            database
                        ] : [],
                        ...canCreateSpace ? [
                            space
                        ] : [],
                        ...isCreateSmartLinkEnabled ? [
                            embed
                        ] : [],
                        ...isAgentItemEligible && (0, $6mKj3.expValEquals)("cc_fd_agent_creation_connie_create", "isEnabled", true) ? [
                            createAgent
                        ] : [],
                        ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                            loom
                        ] : [],
                        ...isCreateBlogEnabled ? [
                            blog
                        ] : []
                    ];
                    const cwrFoldableThreshold = isVariant2 ? 6 : $279d18c421fdc96b$export$9c9b6bde1131681e;
                    let t28;
                    if ($[156] !== isTemplateTouchpointEnabled || $[157] !== startFromTemplate) {
                        t28 = isTemplateTouchpointEnabled ? [
                            $279d18c421fdc96b$var$toAppDefinedSection({
                                items: [
                                    startFromTemplate
                                ]
                            })
                        ] : [];
                        $[156] = isTemplateTouchpointEnabled;
                        $[157] = startFromTemplate;
                        $[158] = t28;
                    } else t28 = $[158];
                    t27 = [
                        ...t28,
                        $279d18c421fdc96b$var$toAppDefinedSection({
                            items: cwrDropdownItems,
                            foldable: cwrFoldableThreshold,
                            ...(0, $9wGTI.fg)("navx_enable_overflow_evaluation_for_cwr") ? {
                                personalize: "overflow"
                            } : {}
                        })
                    ];
                    $[133] = blog;
                    $[134] = canCreateSpace;
                    $[135] = createAgent;
                    $[136] = database;
                    $[137] = embed;
                    $[138] = getSlideItem;
                    $[139] = isAgentItemEligible;
                    $[140] = isCreateBlogEnabled;
                    $[141] = isCreateDatabaseEnabled;
                    $[142] = isCreateLiveDocEnabled;
                    $[143] = isCreateSmartLinkEnabled;
                    $[144] = isCreateWhiteboardEnabled;
                    $[145] = isLoomEntryPointEnabled;
                    $[146] = isTemplateTouchpointEnabled;
                    $[147] = isVariant2;
                    $[148] = liveDoc;
                    $[149] = loom;
                    $[150] = page;
                    $[151] = space;
                    $[152] = startFromTemplate;
                    $[153] = whiteboard;
                    $[154] = whiteboardOptIn;
                    $[155] = t27;
                } else t27 = $[155];
                t26 = t27;
                break bb0;
            }
            if (isTemplateTouchpointEnabled) {
                const t27 = firstSectionItems.length > 0 ? [
                    $279d18c421fdc96b$var$toAppDefinedSection({
                        items: firstSectionItems
                    })
                ] : [];
                let t28;
                if ($[159] !== getRemainingItems) {
                    t28 = $279d18c421fdc96b$var$toAppDefinedSection({
                        items: getRemainingItems(),
                        foldable: $279d18c421fdc96b$export$9c9b6bde1131681e
                    });
                    $[159] = getRemainingItems;
                    $[160] = t28;
                } else t28 = $[160];
                let t29;
                if ($[161] !== t27 || $[162] !== t28) {
                    t29 = [
                        ...t27,
                        t28
                    ];
                    $[161] = t27;
                    $[162] = t28;
                    $[163] = t29;
                } else t29 = $[163];
                t26 = t29;
                break bb0;
            }
            let t27;
            if ($[164] !== getNativeItems) {
                t27 = $279d18c421fdc96b$var$toAppDefinedSection({
                    items: getNativeItems()
                });
                $[164] = getNativeItems;
                $[165] = t27;
            } else t27 = $[165];
            t25 = [
                t27,
                ...loomAndCreateAgentItems.length > 0 ? [
                    $279d18c421fdc96b$var$toAppDefinedSection({
                        heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
                        items: loomAndCreateAgentItems
                    })
                ] : []
            ];
        }
        $[103] = blog;
        $[104] = canCreateSpace;
        $[105] = createAgent;
        $[106] = cwrSplitButtonCohort;
        $[107] = database;
        $[108] = embed;
        $[109] = formatMessage;
        $[110] = getNativeItems;
        $[111] = getRemainingItems;
        $[112] = getSlideItem;
        $[113] = isAgentItemEligible;
        $[114] = isAifcEnabled;
        $[115] = isCreateBlogEnabled;
        $[116] = isCreateDatabaseEnabled;
        $[117] = isCreateLiveDocEnabled;
        $[118] = isCreateSmartLinkEnabled;
        $[119] = isCreateWhiteboardEnabled;
        $[120] = isLoomEntryPointEnabled;
        $[121] = isTemplateTouchpointEnabled;
        $[122] = liveDoc;
        $[123] = loom;
        $[124] = page;
        $[125] = smartCreate;
        $[126] = space;
        $[127] = splitButtonExperimentEnabled;
        $[128] = startFromTemplate;
        $[129] = whiteboard;
        $[130] = whiteboardOptIn;
        $[131] = t25;
        $[132] = t26;
    } else {
        t25 = $[131];
        t26 = $[132];
    }
    if (t26 !== Symbol.for("react.early_return_sentinel")) return t26;
    return t25;
}








var $jTxSS = parcelRequire("jTxSS");




const $a52e0e6bf8a40dbe$export$a558e476d93d8da8 = (0, $aXWIB.defineMessages)({
    commonConfirm: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm",
        defaultMessage: "OK"
    },
    commonConfirmSecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm-second",
        defaultMessage: "Got it"
    },
    commonCreateWithRovo: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.create-with-rovo",
        defaultMessage: "Create with Rovo"
    },
    commonTitle: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.title",
        defaultMessage: "We\u2019re evolving how work starts"
    },
    cwrModalBodyFirst: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-first",
        defaultMessage: "Choose <b>Create</b> to get started instantly with Rovo\u2019s help."
    },
    cwrModalBodySecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-second",
        defaultMessage: "Or select the dropdown to start a new doc, whiteboard, database, or slides."
    },
    ucDropdownBodyFirst: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-first",
        defaultMessage: "Use the dropdown for a new doc, whiteboard, database, or slides."
    },
    ucDropdownBodySecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-second",
        defaultMessage: "Or choose <b>Create</b> to get started instantly with Rovo\u2019s help."
    }
});






var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

const $68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY = (0, $1UApO.keys).NAVX_UC_CWR_EXPERIMENT_SPOTLIGHT_SEEN;
const $68762274af90cc37$var$hasSeen = {
    current: false
};
const $68762274af90cc37$var$listeners = new Set();
const $68762274af90cc37$var$markSessionHasSeenSpotlight = ()=>{
    if ($68762274af90cc37$var$hasSeen.current) return false;
    $68762274af90cc37$var$hasSeen.current = true;
    return true;
};
const $68762274af90cc37$var$notifySpotlightSeen = ()=>{
    $68762274af90cc37$var$listeners.forEach((listener)=>{
        try {
            listener(true);
        } catch  {
        // ignore — a throwing listener must not prevent remaining instances from being notified
        }
    });
};
const $68762274af90cc37$export$99a178eaddf8b36f = ()=>{
    $68762274af90cc37$var$hasSeen.current = false;
    $68762274af90cc37$var$listeners.clear();
};
const $68762274af90cc37$export$f62f78e205629f77 = ()=>$68762274af90cc37$var$listeners;
const $68762274af90cc37$export$523e463438887ddd = ()=>{
    const [hasSeenSpotlight, setHasSeenSpotlight] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(function syncFromStorage() {
        if (!$68762274af90cc37$var$hasSeen.current) try {
            $68762274af90cc37$var$hasSeen.current = (0, $17wUi.confluenceLocalStorageInstance)?.getItem($68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY) === 'true';
        } catch  {
            $68762274af90cc37$var$hasSeen.current = false;
        }
        if (!$68762274af90cc37$var$hasSeen.current) setHasSeenSpotlight(false);
        const listener = (nextHasSeenSpotlight)=>{
            setHasSeenSpotlight(nextHasSeenSpotlight);
        };
        $68762274af90cc37$var$listeners.add(listener);
        return ()=>{
            $68762274af90cc37$var$listeners.delete(listener);
        };
    }, []);
    const markSpotlightSeen = (0, $42omo.useCallback)(()=>{
        if (!$68762274af90cc37$var$markSessionHasSeenSpotlight()) return;
        $68762274af90cc37$var$notifySpotlightSeen();
        try {
            (0, $17wUi.confluenceLocalStorageInstance)?.setItem($68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY, 'true');
        } catch  {
        // storage errors are ignored — in-memory flag prevents re-showing
        }
    }, []);
    return {
        hasSeenSpotlight: hasSeenSpotlight,
        markSpotlightSeen: markSpotlightSeen
    };
};


/* useRenderCwRSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $caX7N = parcelRequire("caX7N");




var $eyWa4 = parcelRequire("eyWa4");


























var $fdtRy = parcelRequire("fdtRy");



var $8tIbq = parcelRequire("8tIbq");


var $kcIQr = parcelRequire("kcIQr");


var $lsxnT = parcelRequire("lsxnT");


var $4UYoK = parcelRequire("4UYoK");


var $ivb8S = parcelRequire("ivb8S");




var $5df80e0ea2030766$exports = {};
$5df80e0ea2030766$exports = new URL("SplitButton.fc5c11e3.gif", import.meta.url).toString();










var $8EsbU = parcelRequire("8EsbU");

function $2bd5ea936eebb583$export$59e7f2eafb999a15(selector, t0) {
    const $ = (0, $frIzR.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { disabled: t2 } = t1;
    const disabled = t2 === undefined ? false : t2;
    const [element, setElement] = (0, $42omo.useState)(null);
    let t3;
    let t4;
    if ($[2] !== disabled || $[3] !== selector) {
        t3 = ()=>{
            if (!(0, $8EsbU.isClientSide)()) return;
            if (disabled) return;
            const resolve = ()=>{
                const next = document.querySelector(selector);
                setElement((current)=>current === next ? current : next);
            };
            resolve();
            const observer = new MutationObserver(resolve);
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
                setElement(null);
            };
        };
        t4 = [
            selector,
            disabled
        ];
        $[2] = disabled;
        $[3] = selector;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    return element;
}


const $d1559ad272a98aae$var$ONBOARDING_STATE_KEYS_TO_FETCH = Object.values((0, $4UYoK.UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS));
const $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID = 'universalCreateCwRExperimentSpotlight';
const $d1559ad272a98aae$var$CHOREOGRAPHER_BLOCKED_STATUS = 'blocked';
const $d1559ad272a98aae$var$spotlightAnchorStyles = {
    menuAnchorWrapper: "_1e0c1ule _kqswstnw _154ixy5q _1ltvx0bf _1bsbt94y _4t3it94y",
    buttonAnchorWrapper: "_1e0c1ule _kqswstnw _94n5x0bf _1ltv1ssb _t9eczr6s _1bsbt94y _4t3it94y"
};
const $d1559ad272a98aae$var$RICH_TEXT_VALUES = {
    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "bold"
        }, chunks)
};
const $d1559ad272a98aae$var$isKeyboardDismissEvent = (event)=>'key' in event;
const $d1559ad272a98aae$var$isDismissButtonEvent = (event)=>'nativeEvent' in event && typeof HTMLButtonElement !== 'undefined' && event.currentTarget instanceof HTMLButtonElement;
const $d1559ad272a98aae$export$59afd03a8f79b543 = (event)=>{
    if ($d1559ad272a98aae$var$isKeyboardDismissEvent(event)) return 'escape';
    return $d1559ad272a98aae$var$isDismissButtonEvent(event) ? 'dismissButton' : 'blanket';
};
const $d1559ad272a98aae$export$2b0a29a923d36d62 = ({ anchorSelector: anchorSelector, choreographerMessageId: choreographerMessageId, spotlightTarget: spotlightTarget, messages: messages, placement: placement, isEnabled: isEnabled, requireAnchorForStart: requireAnchorForStart = false, onCtaClick: onCtaClick, onClosed: onClosed, onBlocked: onBlocked })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const { hasSeenSpotlight: hasSeenSpotlightInStorage, markSpotlightSeen: markSpotlightSeenInStorage } = (0, $68762274af90cc37$export$523e463438887ddd)();
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const skipOnboardingStateQuery = hasSeenSpotlightInStorage || !isEnabled || isServerPlaceholder;
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)($d1559ad272a98aae$var$ONBOARDING_STATE_KEYS_TO_FETCH, skipOnboardingStateQuery);
    const { hasSeenUniversalCreateCwRExperimentSpotlight: hasSeenUniversalCreateCwRExperimentSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldSuppressSpotlight = Boolean(hasSeenUniversalCreateCwRExperimentSpotlight) || hasSeenSpotlightInStorage; // When the backend onboarding state reports the spotlight has been seen but local storage has
    // not been updated yet, mirror it into local storage so subsequent renders short-circuit the
    // `useGetOnboardingState` query (which is otherwise re-run on every render).
    (0, $42omo.useEffect)(()=>{
        if (hasSeenUniversalCreateCwRExperimentSpotlight && !hasSeenSpotlightInStorage) markSpotlightSeenInStorage();
    }, [
        hasSeenUniversalCreateCwRExperimentSpotlight,
        hasSeenSpotlightInStorage,
        markSpotlightSeenInStorage
    ]);
    const anchorEl = (0, $2bd5ea936eebb583$export$59e7f2eafb999a15)(anchorSelector, {
        disabled: isServerPlaceholder || shouldSuppressSpotlight || Boolean(isOnboardingStateError)
    });
    const hasStoppedRef = (0, $42omo.useRef)(false);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(true);
        hasStoppedRef.current = false;
        createEvent({
            type: 'sendScreenEvent',
            data: {
                name: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        createEvent,
        spotlightTarget
    ]);
    const markSpotlightSeen = (0, $42omo.useCallback)(()=>{
        markSpotlightSeenInStorage();
        setOnboardingState({
            key: (0, $4UYoK.UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS).hasSeenUniversalCreateCwRExperimentSpotlight,
            value: 'true'
        });
    }, [
        markSpotlightSeenInStorage,
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []); // eslint-disable-next-line -- useChoreographer is the stable hook exposed by choreographer context.
    const choreographer = useChoreographer(choreographerMessageId, {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const fireSpotlightDisplayRequestedEvent = (0, $42omo.useCallback)(()=>{
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'requested',
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        createEvent,
        spotlightTarget
    ]);
    const fireSpotlightNotDisplayedEvent = (0, $42omo.useCallback)((reason)=>{
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'notDisplayed',
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    choreographerMessageId: choreographerMessageId,
                    reason: reason,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        choreographerMessageId,
        createEvent,
        spotlightTarget
    ]);
    const startSpotlight = (0, $42omo.useCallback)(()=>{
        if (isOnboardingStateLoading || isOnboardingStateError || shouldSuppressSpotlight || requireAnchorForStart && anchorEl === null) return false;
        fireSpotlightDisplayRequestedEvent();
        choreographer.startMessage().then((status)=>{
            if (status === $d1559ad272a98aae$var$CHOREOGRAPHER_BLOCKED_STATUS) {
                fireSpotlightNotDisplayedEvent('choreographerBlocked');
                onBlocked?.(spotlightTarget);
            }
        }).catch(()=>{
            fireSpotlightNotDisplayedEvent('choreographerError');
        });
        return true;
    }, [
        choreographer,
        fireSpotlightNotDisplayedEvent,
        fireSpotlightDisplayRequestedEvent,
        onBlocked,
        spotlightTarget,
        shouldSuppressSpotlight,
        requireAnchorForStart,
        isOnboardingStateError,
        isOnboardingStateLoading,
        anchorEl
    ]);
    const stopSpotlight = (0, $42omo.useCallback)(()=>{
        if (hasStoppedRef.current) return;
        hasStoppedRef.current = true;
        choreographer.stopMessage();
    }, [
        choreographer
    ]);
    const closeSpotlight = (0, $42omo.useCallback)((action, interactionType)=>{
        markSpotlightSeen();
        createEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    interactionType: interactionType,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
        stopSpotlight();
        onClosed?.();
    }, [
        createEvent,
        markSpotlightSeen,
        spotlightTarget,
        stopSpotlight,
        onClosed
    ]);
    const handleDismiss = (0, $42omo.useCallback)((event)=>closeSpotlight('dismissed', $d1559ad272a98aae$export$59afd03a8f79b543(event)), [
        closeSpotlight
    ]);
    const handleCtaClick = (0, $42omo.useCallback)((event_0)=>{
        closeSpotlight('clicked', 'cta');
        onCtaClick?.(event_0);
    }, [
        closeSpotlight,
        onCtaClick
    ]);
    const canRender = !isServerPlaceholder && isEnabled && anchorEl !== null && !isOnboardingStateLoading && !shouldSuppressSpotlight;
    const spotlight = canRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        "aria-hidden": true,
        testId: "hidden-mounting-target",
        xcss: placement === 'left-end' ? $d1559ad272a98aae$var$spotlightAnchorStyles.menuAnchorWrapper : $d1559ad272a98aae$var$spotlightAnchorStyles.buttonAnchorWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }))), anchorEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleDismiss,
        isVisible: isSpotlightActive,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), {
        selectors: [
            anchorSelector
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "universal-create-cwr-experiment-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage(messages.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5df80e0ea2030766$exports))),
        alt: "",
        width: 295,
        height: 135
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...messages.bodyLine1,
        values: $d1559ad272a98aae$var$RICH_TEXT_VALUES
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...messages.bodyLine2,
        values: $d1559ad272a98aae$var$RICH_TEXT_VALUES
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: handleCtaClick
    }, formatMessage(messages.cta)))))))) : null;
    return {
        spotlight: spotlight,
        startSpotlight: startSpotlight,
        stopSpotlight: stopSpotlight,
        isSpotlightActive: isSpotlightActive
    };
};


const $d6b7fe885cb9ec2d$var$MENU_ANCHOR_SELECTOR = '[data-testid="global-create-content-popover-menu--hidden"]';
const $d6b7fe885cb9ec2d$var$BUTTON_ANCHOR_SELECTOR = '[data-testid="uc-trigger-button-primary"]';
const $d6b7fe885cb9ec2d$var$SHARED_CHOREOGRAPHER_MESSAGE_ID = 'UniversalCreateCwRExperimentSpotlight';
const $d6b7fe885cb9ec2d$var$MENU_VARIANT_CONFIG = {
    anchorSelector: $d6b7fe885cb9ec2d$var$MENU_ANCHOR_SELECTOR,
    messages: {
        title: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonTitle,
        bodyLine1: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).ucDropdownBodyFirst,
        bodyLine2: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).ucDropdownBodySecond,
        cta: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonConfirm
    },
    placement: 'left-end',
    requireAnchorForStart: false
};
const $d6b7fe885cb9ec2d$var$BUTTON_VARIANT_CONFIG = {
    anchorSelector: $d6b7fe885cb9ec2d$var$BUTTON_ANCHOR_SELECTOR,
    messages: {
        title: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonTitle,
        bodyLine1: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).cwrModalBodyFirst,
        bodyLine2: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).cwrModalBodySecond,
        cta: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonCreateWithRovo
    },
    placement: 'bottom-start',
    requireAnchorForStart: true
};
const $d6b7fe885cb9ec2d$var$SPOTLIGHT_VARIANT_CONFIGS = {
    button: $d6b7fe885cb9ec2d$var$BUTTON_VARIANT_CONFIG,
    menu: $d6b7fe885cb9ec2d$var$MENU_VARIANT_CONFIG
};
function $d6b7fe885cb9ec2d$export$98e75a504ceeacc2({ isMenuOpen: isMenuOpen, onCloseMenu: onCloseMenu, onClick: dropdownOnClick, primaryActionItem: primaryActionItem, enabled: enabled = true }) {
    const { hasSeenSpotlight: hasSeenSpotlight } = (0, $68762274af90cc37$export$523e463438887ddd)();
    const [spotlightVariant, setSpotlightVariant] = (0, $42omo.useState)('button');
    const [hasInteracted, setHasInteracted] = (0, $42omo.useState)(false);
    const pendingVariantRef = (0, $42omo.useRef)(null);
    const pendingOnClickRef = (0, $42omo.useRef)(undefined);
    const startSpotlightRef = (0, $42omo.useRef)(()=>false);
    const stopSpotlightRef = (0, $42omo.useRef)(()=>{});
    const flushPendingOnClick = (0, $42omo.useCallback)(()=>{
        const pending = pendingOnClickRef.current;
        pendingOnClickRef.current = undefined;
        pending?.();
    }, []);
    const spotlightVariantRef = (0, $42omo.useRef)(spotlightVariant);
    spotlightVariantRef.current = spotlightVariant;
    const handleMenuClosed = (0, $42omo.useCallback)(()=>{
        const variantActiveOrPending = spotlightVariantRef.current === 'menu' || pendingVariantRef.current === 'menu';
        if (variantActiveOrPending) {
            stopSpotlightRef.current();
            pendingVariantRef.current = null;
        }
        onCloseMenu?.();
    }, [
        onCloseMenu
    ]);
    const handleCtaClick = (0, $42omo.useCallback)((event)=>{
        if (spotlightVariantRef.current === 'menu') {
            // Prevent the click from bubbling to the underlying popup/menu
            // (e.g. as a click-outside) so the dropdown stays open when the
            // spotlight's primary action is pressed. Mirrors the reference
            // example at
            // platform/packages/navigation/universal-create/examples/29-menu-dropdown-spotlight-selector-only.tsx.
            event.preventDefault();
            event.stopPropagation();
            // Stop the spotlight but keep the menu dropdown open.
            stopSpotlightRef.current();
            pendingVariantRef.current = null;
        }
    }, []);
    const handleSpotlightClosed = (0, $42omo.useCallback)(()=>{
        if (spotlightVariantRef.current === 'button') flushPendingOnClick();
    }, [
        flushPendingOnClick
    ]);
    const handleSpotlightBlocked = (0, $42omo.useCallback)((blockedVariant)=>{
        // Ignore stale blocked callbacks from older start attempts.
        if (pendingVariantRef.current !== blockedVariant) return;
        pendingVariantRef.current = null;
        if (blockedVariant === 'button') flushPendingOnClick();
    }, [
        flushPendingOnClick
    ]);
    const activeSpotlightConfig = $d6b7fe885cb9ec2d$var$SPOTLIGHT_VARIANT_CONFIGS[spotlightVariant];
    const { spotlight: spotlight, startSpotlight: startSpotlight, stopSpotlight: stopSpotlight } = (0, $d1559ad272a98aae$export$2b0a29a923d36d62)({
        ...activeSpotlightConfig,
        choreographerMessageId: $d6b7fe885cb9ec2d$var$SHARED_CHOREOGRAPHER_MESSAGE_ID,
        isEnabled: enabled && (spotlightVariant === 'button' || isMenuOpen),
        spotlightTarget: spotlightVariant,
        onCtaClick: handleCtaClick,
        onClosed: handleSpotlightClosed,
        onBlocked: handleSpotlightBlocked
    });
    startSpotlightRef.current = startSpotlight;
    stopSpotlightRef.current = stopSpotlight;
    const scheduleSpotlightStart = (0, $42omo.useCallback)((variant)=>{
        pendingVariantRef.current = variant;
        if (spotlightVariantRef.current !== variant || !hasInteracted) (0, $jTxSS.flushSync)(()=>{
            setHasInteracted(true);
            setSpotlightVariant(variant);
        });
        const didStart = startSpotlightRef.current();
        if (!didStart) {
            pendingVariantRef.current = null;
            if (variant === 'button') flushPendingOnClick();
        }
    }, [
        flushPendingOnClick,
        hasInteracted
    ]);
    const interceptedDropdownOnClick = (0, $42omo.useCallback)(()=>{
        dropdownOnClick?.();
        if (hasSeenSpotlight || pendingVariantRef.current !== null) return;
        scheduleSpotlightStart('menu');
    }, [
        hasSeenSpotlight,
        dropdownOnClick,
        scheduleSpotlightStart
    ]);
    const interceptedPrimaryActionItem = (0, $42omo.useMemo)(()=>{
        if (!primaryActionItem || hasSeenSpotlight) return primaryActionItem;
        const originalPrimaryOnClick = primaryActionItem.onClick;
        const interceptedPrimaryOnClick = (event_0)=>{
            pendingOnClickRef.current = originalPrimaryOnClick ? ()=>originalPrimaryOnClick(event_0) : undefined;
            scheduleSpotlightStart('button');
        };
        return {
            ...primaryActionItem,
            onClick: interceptedPrimaryOnClick
        };
    }, [
        hasSeenSpotlight,
        primaryActionItem,
        scheduleSpotlightStart
    ]);
    if (!enabled) return {
        onClick: dropdownOnClick,
        onCloseMenu: onCloseMenu ?? (()=>{}),
        primaryActionItem: primaryActionItem,
        spotlight: null
    };
    return {
        onClick: hasSeenSpotlight ? dropdownOnClick : interceptedDropdownOnClick,
        onCloseMenu: handleMenuClosed,
        primaryActionItem: interceptedPrimaryActionItem,
        spotlight: hasInteracted ? spotlight : null
    };
}



const $f44feda85e5453ef$var$messages = (0, $aXWIB.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = (t0)=>{
    const $ = (0, $frIzR.c)(58);
    const { flags: flags } = t0;
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $eB1TF.useUniversalCreateActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== setIsOpen) {
        t1 = ()=>setIsOpen(false);
        $[0] = setIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    const menuItems = (0, $279d18c421fdc96b$export$aad046bd9909db8f)(flags, t1, undefined, isOpen);
    let t2;
    if ($[2] !== theme) {
        t2 = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[2] = theme;
        $[3] = t2;
    } else t2 = $[3];
    const buttonTheme = t2;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const isAIFCCreateEnabled = isRovoLLMEnabled && !isAnonymousUser;
    let t3;
    if ($[4] !== isAIFCCreateEnabled || $[5] !== isCwrSplitButtonEnabled || $[6] !== isServerPlaceholder) {
        t3 = !isServerPlaceholder && isAIFCCreateEnabled && isCwrSplitButtonEnabled && (0, $9wGTI.fg)("navx_uc_cwr_experiment_spotlight_enabled");
        $[4] = isAIFCCreateEnabled;
        $[5] = isCwrSplitButtonEnabled;
        $[6] = isServerPlaceholder;
        $[7] = t3;
    } else t3 = $[7];
    const experimentSpotlightEnabled = t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== isOnEditRoute || $[10] !== isOpen || $[11] !== match?.name || $[12] !== setIsOpen) {
        t4 = ()=>{
            const willOpen = !isOpen;
            setIsOpen(willOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[8] = createAnalyticsEvent;
        $[9] = isOnEditRoute;
        $[10] = isOpen;
        $[11] = match?.name;
        $[12] = setIsOpen;
        $[13] = t4;
    } else t4 = $[13];
    const onCreateClick = t4;
    let t5;
    if ($[14] !== createAnalyticsEvent || $[15] !== isLivePage || $[16] !== isOnEditRoute || $[17] !== routeDataRef) {
        t5 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: (0, $279d18c421fdc96b$export$9131280d9d18988b),
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[14] = createAnalyticsEvent;
        $[15] = isLivePage;
        $[16] = isOnEditRoute;
        $[17] = routeDataRef;
        $[18] = t5;
    } else t5 = $[18];
    const handleAnalyticsAndResetStickySearch = t5;
    let t6;
    if ($[19] !== handleAnalyticsAndResetStickySearch || $[20] !== setIsOpen) {
        t6 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            setIsOpen(false);
        };
        $[19] = handleAnalyticsAndResetStickySearch;
        $[20] = setIsOpen;
        $[21] = t6;
    } else t6 = $[21];
    const onSmartCreateClick = t6;
    const t7 = !isAIFCCreateEnabled;
    let t8;
    if ($[22] !== onSmartCreateClick || $[23] !== spaceKey || $[24] !== t7) {
        t8 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onSmartCreateClick,
            isDisabled: t7
        };
        $[22] = onSmartCreateClick;
        $[23] = spaceKey;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    const smartCreateItem = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t8);
    const t9 = !isAIFCCreateEnabled;
    let t10;
    if ($[26] !== t9) {
        t10 = {
            isDisabled: t9,
            includePromptSuggestions: false
        };
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    const { preload: preloadSmartCreate } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t10);
    const hasPreloadedSmartCreateRef = (0, $42omo.useRef)(false);
    let t11;
    if ($[28] !== isAIFCCreateEnabled || $[29] !== isCwrSplitButtonEnabled || $[30] !== preloadSmartCreate) {
        t11 = ()=>{
            if (hasPreloadedSmartCreateRef.current || !isAIFCCreateEnabled || !isCwrSplitButtonEnabled) return;
            hasPreloadedSmartCreateRef.current = true;
            preloadSmartCreate();
        };
        $[28] = isAIFCCreateEnabled;
        $[29] = isCwrSplitButtonEnabled;
        $[30] = preloadSmartCreate;
        $[31] = t11;
    } else t11 = $[31];
    const onTriggerMouseEnter = t11;
    let t12;
    if ($[32] !== setIsOpen || $[33] !== setOpenFrom) {
        t12 = ()=>{
            setIsOpen(false);
            setOpenFrom("");
        };
        $[32] = setIsOpen;
        $[33] = setOpenFrom;
        $[34] = t12;
    } else t12 = $[34];
    const onClose = t12;
    let t13;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
            enabled: false
        };
        $[35] = t13;
    } else t13 = $[35];
    const crossAppCreationConfig = t13;
    const originalPrimaryActionItem = isAIFCCreateEnabled && isCwrSplitButtonEnabled ? smartCreateItem : undefined;
    let t14;
    if ($[36] !== experimentSpotlightEnabled || $[37] !== isOpen || $[38] !== onClose || $[39] !== onCreateClick || $[40] !== originalPrimaryActionItem) {
        t14 = {
            enabled: experimentSpotlightEnabled,
            isMenuOpen: isOpen,
            onCloseMenu: onClose,
            onClick: onCreateClick,
            primaryActionItem: originalPrimaryActionItem
        };
        $[36] = experimentSpotlightEnabled;
        $[37] = isOpen;
        $[38] = onClose;
        $[39] = onCreateClick;
        $[40] = originalPrimaryActionItem;
        $[41] = t14;
    } else t14 = $[41];
    const { onClick: createOnClick, onCloseMenu: createOnCloseMenu, primaryActionItem: createPrimaryActionItem, spotlight: spotlight } = (0, $d6b7fe885cb9ec2d$export$98e75a504ceeacc2)(t14);
    const t15 = createOnClick ?? onCreateClick;
    let t16;
    if ($[42] !== createPrimaryActionItem) {
        t16 = createPrimaryActionItem ? {
            primaryActionItem: createPrimaryActionItem
        } : {};
        $[42] = createPrimaryActionItem;
        $[43] = t16;
    } else t16 = $[43];
    let t17;
    if ($[44] !== formatMessage) {
        t17 = formatMessage($f44feda85e5453ef$var$messages.create);
        $[44] = formatMessage;
        $[45] = t17;
    } else t17 = $[45];
    let t18;
    if ($[46] !== buttonTheme || $[47] !== createOnCloseMenu || $[48] !== isOpen || $[49] !== menuItems || $[50] !== onTriggerMouseEnter || $[51] !== t15 || $[52] !== t16 || $[53] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3c02e04bd46fd309$export$5c89068caaa33f77), {
            sections: menuItems,
            crossAppCreationConfig: crossAppCreationConfig,
            onMouseEnter: onTriggerMouseEnter,
            triggerButtonSpotlightTarget: "top-nav-create",
            enableTriggerPulse: false,
            isOpen: isOpen,
            onClose: createOnCloseMenu,
            onClick: t15,
            product: "confluence",
            buttonTheme: buttonTheme,
            testId: "create-content-popover-button",
            shouldRenderToParent: true,
            ...t16
        }, t17);
        $[46] = buttonTheme;
        $[47] = createOnCloseMenu;
        $[48] = isOpen;
        $[49] = menuItems;
        $[50] = onTriggerMouseEnter;
        $[51] = t15;
        $[52] = t16;
        $[53] = t17;
        $[54] = t18;
    } else t18 = $[54];
    let t19;
    if ($[55] !== spotlight || $[56] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t18, spotlight);
        $[55] = spotlight;
        $[56] = t18;
        $[57] = t19;
    } else t19 = $[57];
    return t19;
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}






var $jqe2L = parcelRequire("jqe2L");








var $5cryL = parcelRequire("5cryL");





var $fywGr = parcelRequire("fywGr");





var $7yn0t = parcelRequire("7yn0t");


var $6MlZq = parcelRequire("6MlZq");







var $luv00 = parcelRequire("luv00");











var $7DERG = parcelRequire("7DERG");





const $14f8b7ba4c44a126$export$96098f07afe80f94 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xXIQx",
    name: "EngagementInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("g8JXt"))).EngagementInlineDialogWrapper
});


'use no memo';
const $433f7c954f8755e5$var$containerStyles = null;

const $433f7c954f8755e5$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZXF2b",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("d7J1w"))).CreateButton
});
const $433f7c954f8755e5$var$LIVE_DOCS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $433f7c954f8755e5$var$CreateComponentContent = ({ flags: flags })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { setQueryParams: setQueryParams, match: match, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-component'
    });
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)
    }), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = (0, $ivb8S.deserializeState)(data);
    const fireAnalytics = (additionalAttributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'create',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    ...additionalAttributes
                }
            }
        }).fire();
    };
    const openCreateDialog = ()=>{
        fireAnalytics();
        setQueryParams({
            createDialog: true
        });
    };
    const shouldCreateBlankFabricPage = ()=>{
        if (data && editorOnboardingEligiblity) (0, $fywGr.preloadEditorOnboardingState)();
        return true;
    };
    const createPageHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: 'createBlankFabricPage',
        withFallback: true,
        spaceKey: spaceKey,
        parentPageId: contentId
    });
    const handleCreatePageShortcut = ()=>{
        setEditSource((0, $7NoF3.CREATE_PAGE_SHORTCUT));
        fireAnalytics({
            keyboardShortcut: true
        });
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) push(createPageHref);
    };
    const handleCreatePageButtonClick = (e)=>{
        fireAnalytics();
        const shouldCreate_0 = shouldCreateBlankFabricPage();
        if (shouldCreate_0) {
            if (e.metaKey || e.ctrlKey) window.open(createPageHref, '_blank', 'noreferrer');
            else push(createPageHref);
        } else // creation is handled by href for button click
        e.preventDefault();
    };
    const createBlog = ()=>{
        const createBlogLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            source: 'globalCreateBlogShortcut',
            spaceKey: spaceKey
        });
        push(createBlogLink);
    };
    const createLiveDoc = ()=>{
        const createLiveDocLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: contentId,
            withFallback: true,
            source: 'globalCreateLiveDocShortcut',
            spaceKey: spaceKey
        });
        push(createLiveDocLink);
    };
    const showLiveDocNotEnabledFlag = ()=>{
        flags.showErrorFlag({
            id: 'live-doc-not-enabled-shortcut-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledAction),
                    onClick: ()=>{
                        window.open($433f7c954f8755e5$var$LIVE_DOCS_LINK, '_blank');
                    }
                }
            ]
        });
    };
    const [createPageClickListener, createPageShortcutListener] = (0, $jqe2L.isCreateBlankFabricPageEnabled)() ? [
        handleCreatePageButtonClick,
        handleCreatePageShortcut
    ] : [
        openCreateDialog,
        openCreateDialog
    ];
    const universalGlobalCreateShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN);
    const handlePreload = ()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) // preload smart creation
        (0, $7DERG.ConfluenceSmartCreationModalLoader).preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "app-navigation-create",
        "data-pendo-id": "con-*/wiki/home-create",
        "data-vc": "create-component",
        ...ssrPlaceholderIdProp,
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $14f8b7ba4c44a126$export$96098f07afe80f94), {
        engagementId: "createComponentButton",
        dataVC: "app-navigation-create-engagement-inline-dialog"
    }, isCreationDropdownEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f44feda85e5453ef$export$b8b0dfc3e3d56c92), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: universalGlobalCreateShortcut,
            isTooltip: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7yn0t.CreateContentButtonPreloader), {
        editSource: (0, $7NoF3.CREATE_NAV_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($433f7c954f8755e5$var$CreateButton, {
        onClick: enforceStorageLimit(createPageClickListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $433f7c954f8755e5$var$i18n.create))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GLOBAL_CREATE_SHORTCUT) : undefined,
        accelerator: universalGlobalCreateShortcut,
        listener: enforceStorageLimit(createPageShortcutListener),
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.BLOG_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_BLOG_SHORTCUT),
        listener: enforceStorageLimit(createBlog),
        isAppNavigationShortcut: true
    }), isCreateLiveDocEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(createLiveDoc),
        isAppNavigationShortcut: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(showLiveDocNotEnabledFlag),
        isAppNavigationShortcut: true
    }));
};
const $433f7c954f8755e5$var$i18n = (0, $aXWIB.defineMessages)({
    create: {
        id: "app-navigation.top-navigation.create",
        defaultMessage: "Create"
    },
    liveDocsNotEnabledTitle: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.title",
        defaultMessage: "Live docs aren\u2019t enabled in this space"
    },
    liveDocsNotEnabledDescription: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.description",
        defaultMessage: "To use this shortcut, your space admin will need to enable live docs."
    },
    liveDocsNotEnabledAction: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.action",
        defaultMessage: "Find out more"
    }
});
const $433f7c954f8755e5$export$a9a76753cd947d5c = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $42omo.memo)($433f7c954f8755e5$var$CreateComponentContent));



var $eDVeb = parcelRequire("eDVeb");


var $cAMBp = parcelRequire("cAMBp");

const $d7fa51f310118f21$var$TopNavigationQuery = (0, $hAiCi.default);
const $d7fa51f310118f21$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $d7fa51f310118f21$var$CRITERION_BOTS_CONFIG_KEY = 'cc_criterion_bots';
const $d7fa51f310118f21$export$8a421bddecb2bf5b = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d7fa51f310118f21$var$TopNavigationQuery, {
        __callerPackage__: "@confluence/app-navigation"
    });
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    if (loading) return null;
    let t1;
    if ($[0] !== customTheme || $[1] !== data || $[2] !== defaultCollapsed || $[3] !== isLimitedNav || $[4] !== isNav4CollapseReminderSpotlightActive || $[5] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7fa51f310118f21$var$TopNavigationInner, {
            data: data,
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
            isLimitedNav: isLimitedNav
        });
        $[0] = customTheme;
        $[1] = data;
        $[2] = defaultCollapsed;
        $[3] = isLimitedNav;
        $[4] = isNav4CollapseReminderSpotlightActive;
        $[5] = setIsNav4CollapseReminderSpotlightActive;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== error) {
        t2 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[7] = error;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};
const $d7fa51f310118f21$var$isAtlassianStaff = (data)=>{
    const criterionBots = (0, $1xpoY.default).getStringList($d7fa51f310118f21$var$CRITERION_BOTS_CONFIG_KEY, []);
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com') || criterionBots.includes(email.value))) || false;
};
const $d7fa51f310118f21$var$TopNavigationInner = (t0)=>{
    const $ = (0, $frIzR.c)(91);
    const { data: data, defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const { isLoggedIn: isLoggedIn, cloudId: cloudId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] !== data) {
        t1 = $d7fa51f310118f21$var$isAtlassianStaff(data);
        $[0] = data;
        $[1] = t1;
    } else t1 = $[1];
    const isAtlassianStaffMemoized = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $78QFu.getUniquePageLoadId)();
        $[2] = t2;
    } else t2 = $[2];
    const { uuid: uuid, isInitial: isInitial } = t2;
    const hasCustomTheme = !!customTheme?.highlightColor || !!customTheme?.backgroundColor;
    const [customLogoSize, setCustomLogoSize] = (0, $42omo.useState)(null);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (event)=>{
            const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
            setCustomLogoSize({
                width: naturalWidth,
                height: naturalHeight
            });
        };
        $[3] = t3;
    } else t3 = $[3];
    const handleOnLoadCustomLogo = t3;
    let t4;
    if ($[4] !== cloudId || $[5] !== createAnalyticsEvent || $[6] !== customLogoSize || $[7] !== customTheme?.backgroundColor || $[8] !== customTheme?.highlightColor || $[9] !== data) {
        t4 = ()=>{
            if (data && isInitial && uuid) {
                const hasCustomSiteTitle = !!data.siteSettings?.showApplicationTitle && !!data.siteSettings?.siteTitle;
                const hasCustomLogo = !!data.siteConfiguration?.customSiteLogo && !!data.siteDescription?.logoUrl;
                if (hasCustomLogo && !customLogoSize) return;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "globalNavigation",
                        action: "viewed",
                        actionSubject: "topNav",
                        actionSubjectId: "customTheme",
                        attributes: {
                            cloudId: cloudId,
                            hasCustomLogo: hasCustomLogo,
                            hasCustomSiteTitle: hasCustomSiteTitle,
                            hasCustomHighlightColor: !!customTheme?.highlightColor,
                            hasCustomBGColor: !!customTheme?.backgroundColor,
                            ...hasCustomLogo && customLogoSize ? customLogoSize : undefined,
                            ...hasCustomSiteTitle && {
                                customSiteTitleLength: data.siteSettings?.siteTitle.length
                            }
                        }
                    }
                }).fire();
            }
        };
        $[4] = cloudId;
        $[5] = createAnalyticsEvent;
        $[6] = customLogoSize;
        $[7] = customTheme?.backgroundColor;
        $[8] = customTheme?.highlightColor;
        $[9] = data;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== cloudId || $[12] !== createAnalyticsEvent || $[13] !== customLogoSize || $[14] !== customTheme || $[15] !== data) {
        t5 = [
            cloudId,
            createAnalyticsEvent,
            customLogoSize,
            data,
            isInitial,
            customTheme,
            uuid
        ];
        $[11] = cloudId;
        $[12] = createAnalyticsEvent;
        $[13] = customLogoSize;
        $[14] = customTheme;
        $[15] = data;
        $[16] = t5;
    } else t5 = $[16];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[17] !== isOnEditRoute) {
        t6 = (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                contentBefore: label,
                shortcut: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                isEditorShortcut: isOnEditRoute,
                isTooltip: true
            });
        $[17] = isOnEditRoute;
        $[18] = t6;
    } else t6 = $[18];
    const getShortcutVisualizer = t6;
    const { exitMultiSelect: exitMultiSelect } = (0, $bwL2u.useContentTreeSelectionActions)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t7;
    if ($[19] !== createAnalyticsEvent || $[20] !== exitMultiSelect || $[21] !== isMultiSelectActive) {
        t7 = ()=>{
            if (isMultiSelectActive) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: "globalNavigation",
                        action: "closed",
                        actionSubject: "bulkActionsMenu",
                        attributes: {
                            method: "collapseSideNavButton"
                        }
                    }
                }).fire();
                exitMultiSelect();
            }
        };
        $[19] = createAnalyticsEvent;
        $[20] = exitMultiSelect;
        $[21] = isMultiSelectActive;
        $[22] = t7;
    } else t7 = $[22];
    const handleMultiSelectOnCollapse = t7;
    const t8 = isFhsEnabled ? undefined : defaultCollapsed;
    let t9;
    if ($[23] !== formatMessage || $[24] !== getShortcutVisualizer || $[25] !== isFhsEnabled) {
        t9 = isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel));
        $[23] = formatMessage;
        $[24] = getShortcutVisualizer;
        $[25] = isFhsEnabled;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== formatMessage || $[28] !== getShortcutVisualizer || $[29] !== isFhsEnabled) {
        t10 = isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel));
        $[27] = formatMessage;
        $[28] = getShortcutVisualizer;
        $[29] = isFhsEnabled;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== handleMultiSelectOnCollapse || $[32] !== t10 || $[33] !== t8 || $[34] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNavToggleButton), {
            defaultCollapsed: t8,
            collapseLabel: t9,
            expandLabel: t10,
            onClick: handleMultiSelectOnCollapse
        });
        $[31] = handleMultiSelectOnCollapse;
        $[32] = t10;
        $[33] = t8;
        $[34] = t9;
        $[35] = t11;
    } else t11 = $[35];
    const sideNavToggleButtonComponent = t11;
    let t12;
    if ($[36] !== isNav4CollapseReminderSpotlightActive) {
        t12 = isNav4CollapseReminderSpotlightActive && (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration");
        $[36] = isNav4CollapseReminderSpotlightActive;
        $[37] = t12;
    } else t12 = $[37];
    const shouldShowNewSpotlight = t12;
    let t13;
    if ($[38] !== isNav4CollapseReminderSpotlightActive || $[39] !== setIsNav4CollapseReminderSpotlightActive || $[40] !== shouldShowNewSpotlight || $[41] !== sideNavToggleButtonComponent) {
        t13 = shouldShowNewSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0356f01208b13d1$export$6cddb4d20889bca4), {
            isVisible: !!isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        }, sideNavToggleButtonComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "nav4-spotlight-1"
        }, sideNavToggleButtonComponent);
        $[38] = isNav4CollapseReminderSpotlightActive;
        $[39] = setIsNav4CollapseReminderSpotlightActive;
        $[40] = shouldShowNewSpotlight;
        $[41] = sideNavToggleButtonComponent;
        $[42] = t13;
    } else t13 = $[42];
    const sideNavToggleButton = t13;
    let t14;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eBBZq.AppSwitcherButton), null);
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== isAtlassianStaffMemoized) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1B659.DeveloperButtons), {
            isAtlassianStaff: isAtlassianStaffMemoized
        });
        $[44] = isAtlassianStaffMemoized;
        $[45] = t15;
    } else t15 = $[45];
    const t16 = data?.siteConfiguration;
    const t17 = data?.siteSettings;
    const t18 = data?.siteDescription;
    let t19;
    if ($[46] !== t16 || $[47] !== t17 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $760ef9e13b699b30$export$48df75a983e1f3fb), {
            siteConfiguration: t16,
            siteSettings: t17,
            siteDescription: t18,
            onLoadCustomLogo: handleOnLoadCustomLogo
        });
        $[46] = t16;
        $[47] = t17;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== data?.siteSettings) {
        t20 = data?.siteSettings?.showApplicationTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1eDr.CustomTitle), null, data?.siteSettings.siteTitle) : null;
        $[50] = data?.siteSettings;
        $[51] = t20;
    } else t20 = $[51];
    let t21;
    if ($[52] !== sideNavToggleButton || $[53] !== t15 || $[54] !== t19 || $[55] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vGun.TopNavStart), {
            sideNavToggleButton: sideNavToggleButton
        }, t14, t15, t19, t20);
        $[52] = sideNavToggleButton;
        $[53] = t15;
        $[54] = t19;
        $[55] = t20;
        $[56] = t21;
    } else t21 = $[56];
    let t22;
    if ($[57] !== isLimitedNav) {
        t22 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDVeb.SearchBar), null);
        $[57] = isLimitedNav;
        $[58] = t22;
    } else t22 = $[58];
    let t23;
    if ($[59] !== isLimitedNav) {
        t23 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $433f7c954f8755e5$export$a9a76753cd947d5c), null);
        $[59] = isLimitedNav;
        $[60] = t23;
    } else t23 = $[60];
    let t24;
    if ($[61] !== t22 || $[62] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idPUB.TopNavMiddle), null, t22, t23);
        $[61] = t22;
        $[62] = t23;
        $[63] = t24;
    } else t24 = $[63];
    let t25;
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e0f0aa871cc51c1$export$a55b02efe3d62583), null);
        t26 = (0, $9wGTI.fg)("edition_awareness_standard_upsell_confluence_ab_fg") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5zvz.EditionAwarenessUpsellExperiment), {
            navVersion: "nav4"
        });
        $[64] = t25;
        $[65] = t26;
    } else {
        t25 = $[64];
        t26 = $[65];
    }
    let t27;
    if ($[66] !== isLimitedNav) {
        t27 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cAMBp.RovoButton), null);
        $[66] = isLimitedNav;
        $[67] = t27;
    } else t27 = $[67];
    let t28;
    if ($[68] !== isLimitedNav) {
        t28 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MAeh.NotificationsButton), null);
        $[68] = isLimitedNav;
        $[69] = t28;
    } else t28 = $[69];
    let t29;
    let t30;
    if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48d2632049a03f8d$export$78bddedbcf2939ac), null);
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f8faa2e47e4a6d0$export$e2457e1974c298c3), null);
        $[70] = t29;
        $[71] = t30;
    } else {
        t29 = $[70];
        t30 = $[71];
    }
    let t31;
    if ($[72] !== data || $[73] !== isLoggedIn) {
        t31 = isLoggedIn && data?.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7fa51f310118f21$var$RemovedSpotlightTarget, {
            name: "nav-profile"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e40e4f4e333d3274$export$6d6e8f8ac62271dd), {
            user: data.user
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3yPEN.LoginButton), null);
        $[72] = data;
        $[73] = isLoggedIn;
        $[74] = t31;
    } else t31 = $[74];
    let t32;
    if ($[75] !== t27 || $[76] !== t28 || $[77] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dTIqH.TopNavEnd), null, t25, t26, t27, t28, t29, t30, t31);
        $[75] = t27;
        $[76] = t28;
        $[77] = t31;
        $[78] = t32;
    } else t32 = $[78];
    let t33;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE),
            attributes: {
                navVersion: "4"
            }
        });
        $[79] = t33;
    } else t33 = $[79];
    const t34 = !isLoggedIn;
    let t35;
    if ($[80] !== hasCustomTheme || $[81] !== isLicensed || $[82] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $8w1c1.APP_NAVIGATION_METRIC),
            customData: {
                isAnonymous: t34,
                isLicensed: isLicensed,
                hasCustomTheme: hasCustomTheme
            }
        });
        $[80] = hasCustomTheme;
        $[81] = isLicensed;
        $[82] = t34;
        $[83] = t35;
    } else t35 = $[83];
    let t36;
    let t37;
    if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading",
            includeFeatureFlags: true,
            details: $d7fa51f310118f21$var$nav4Details
        });
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationFMP),
            subjectId: "NavigationFMP",
            includeFeatureFlags: true,
            details: $d7fa51f310118f21$var$nav4Details
        });
        $[84] = t36;
        $[85] = t37;
    } else {
        t36 = $[84];
        t37 = $[85];
    }
    let t38;
    if ($[86] !== t21 || $[87] !== t24 || $[88] !== t32 || $[89] !== t35) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t21, t24, t32, t33, t35, t36, t37);
        $[86] = t21;
        $[87] = t24;
        $[88] = t32;
        $[89] = t35;
        $[90] = t38;
    } else t38 = $[90];
    return t38;
};
const $d7fa51f310118f21$var$i18n = (0, $aXWIB.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-collapse-label",
        defaultMessage: "Collapse sidebar"
    },
    sideNavToggleButtonExpandLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-expand-label",
        defaultMessage: "Expand sidebar"
    }
});
const $d7fa51f310118f21$var$nav4Details = {
    navVersion: '4'
};


const $d782f4c4ad49c391$export$eff75454f2208b30 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            errorBoundaryId: "TopNavigation"
        };
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== customTheme || $[3] !== defaultCollapsed || $[4] !== isLimitedNav || $[5] !== isNav4CollapseReminderSpotlightActive || $[6] !== setIsNav4CollapseReminderSpotlightActive) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t1
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7fa51f310118f21$export$8a421bddecb2bf5b), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
            isLimitedNav: isLimitedNav
        }));
        $[2] = customTheme;
        $[3] = defaultCollapsed;
        $[4] = isLimitedNav;
        $[5] = isNav4CollapseReminderSpotlightActive;
        $[6] = setIsNav4CollapseReminderSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["TopNavigationBase"] = $d782f4c4ad49c391$export$eff75454f2208b30;

});

parcelRegister("77oON", function(module, exports) {

let $52ec703ffac8ce44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $52ec703ffac8ce44$var$load("W7CG2"),
    $52ec703ffac8ce44$var$load("5JMjw"),
    $52ec703ffac8ce44$var$load("hsLOm"),
    $52ec703ffac8ce44$var$load("jgDEy"),
    $52ec703ffac8ce44$var$load("6wr18"),
    $52ec703ffac8ce44$var$load("6jjGk"),
    $52ec703ffac8ce44$var$load("8TN4y"),
    $52ec703ffac8ce44$var$load("56zd8"),
    $52ec703ffac8ce44$var$load("j4CTh"),
    $52ec703ffac8ce44$var$load("1GCFv"),
    $52ec703ffac8ce44$var$load("jyuXn"),
    $52ec703ffac8ce44$var$load("eeaKR"),
    $52ec703ffac8ce44$var$load("Wowvf"),
    $52ec703ffac8ce44$var$load("ffEVr"),
    $52ec703ffac8ce44$var$load("7EorR"),
    $52ec703ffac8ce44$var$load("8H6xE")
]).then(()=>parcelRequire('lw7p7'));

});

parcelRegister("8DSzV", function(module, exports) {

let $64ac4d64eaa9e2dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64ac4d64eaa9e2dc$var$load("60m6Z").then(()=>parcelRequire('1FDBc'));

});

parcelRegister("5YH7h", function(module, exports) {

let $011f8c64b6d9604e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $011f8c64b6d9604e$var$load("dJC82").then(()=>parcelRequire('kM0Bh'));

});

parcelRegister("3ft1X", function(module, exports) {

let $25d94ab196212a61$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25d94ab196212a61$var$load("4ukY5").then(()=>parcelRequire('ea6sq'));

});

parcelRegister("9qutx", function(module, exports) {

let $6dce2e91a69be01a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6dce2e91a69be01a$var$load("hhss7"),
    $6dce2e91a69be01a$var$load("6wPv6")
]).then(()=>parcelRequire('hEuLk'));

});

parcelRegister("bIfof", function(module, exports) {

let $886fbdef56661466$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $886fbdef56661466$var$load("943D1").then(()=>parcelRequire('ddp7n'));

});

parcelRegister("9A2e6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $5IDSL = parcelRequire("5IDSL");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");

function $31bd555df287b548$export$9e9b5b3f9c08ce57({ children: children, name: name, interactionId: interactionId, fallback: fallback = null, onError: onError, app: app }) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $19BZl.useUniversalCreateState)();
    const tags = {
        component: (0, $jjCkw.PACKAGE_PREFIX),
        subProduct: subProduct || subProductV1
    };
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        location: name,
        disableSentry: false,
        disableAnalytics: true,
        onError: onError,
        sentryConfig: {
            product: app || product || productV1
        },
        interactionId: interactionId,
        tags: tags
    });
    const handleOnError = (0, $42omo.useCallback)(async (error)=>{
        handleError(error);
    }, [
        handleError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: fallback,
        onError: handleOnError
    }, children);
}
module.exports["GenericErrorBoundary"] = $31bd555df287b548$export$9e9b5b3f9c08ce57;

});

parcelRegister("jjCkw", function(module, exports) {
const $38e5614694cf6bb5$export$373682275c03fc63 = 'universal-create';
const $38e5614694cf6bb5$export$4fbca0e866deff63 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button-target`;
const $38e5614694cf6bb5$export$3f4cc858c0cb6e84 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button`;
const $38e5614694cf6bb5$export$85183a312807388d = 'navigation';
const $38e5614694cf6bb5$export$4e49778ae689b92a = 3;
const $38e5614694cf6bb5$export$c2ae99333adf8094 = 'universal-create';
const $38e5614694cf6bb5$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $38e5614694cf6bb5$export$441df76988f6d01 = 344;
const $38e5614694cf6bb5$export$7bceb8a76dd93d51 = 430;
const $38e5614694cf6bb5$export$d268f31a83479f83 = 'sm';
const $38e5614694cf6bb5$export$aca7035f4c6a6c0b = -1;
module.exports["PACKAGE_PREFIX"] = $38e5614694cf6bb5$export$373682275c03fc63;
module.exports["TRIGGER_BUTTON_TEST_ID"] = $38e5614694cf6bb5$export$3f4cc858c0cb6e84;
module.exports["MAX_ALLOWED_SECTIONS"] = $38e5614694cf6bb5$export$4e49778ae689b92a;
module.exports["SOURCE_LOCATION"] = $38e5614694cf6bb5$export$c2ae99333adf8094;
module.exports["REQUIRED_USER_ITEMS"] = $38e5614694cf6bb5$export$4c7df19e787d8989;
module.exports["MAX_MENU_HEIGHT"] = $38e5614694cf6bb5$export$441df76988f6d01;
module.exports["MAX_MENU_HEIGHT_EXPANDED"] = $38e5614694cf6bb5$export$7bceb8a76dd93d51;
module.exports["RESPONSIVE_BREAKPOINT"] = $38e5614694cf6bb5$export$d268f31a83479f83;
module.exports["PRIMARY_ACTION_ITEM_INDEX"] = $38e5614694cf6bb5$export$aca7035f4c6a6c0b;

});

parcelRegister("19BZl", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8e4be96129d634f8$var$defaultSectionExpansionContext = {
    sectionExpansionState: {},
    setSectionExpansionState: function() {}
};
const $8e4be96129d634f8$export$fc9ae5c4169099cb = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultSectionExpansionContext);
function $8e4be96129d634f8$export$b316af36f410c3ff() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$fc9ae5c4169099cb);
}
const $8e4be96129d634f8$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {}
};
const $8e4be96129d634f8$export$39aa3c8950714d79 = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControls);
function $8e4be96129d634f8$export$56d95dc846453c64() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
}
const $8e4be96129d634f8$export$24aad8519b95b41b = (0, $42omo.createContext)({
    isV2Mode: false,
    items: [],
    product: 'unknown',
    subProduct: undefined,
    growthRecommendationsSessionId: undefined,
    setGrowthRecommendationsSessionId: undefined,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: [],
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    preventClose: undefined
});
function $8e4be96129d634f8$export$efa3856fc0e85e7f() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
}
function $8e4be96129d634f8$export$c7381b2490bb4d36() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
}
function $8e4be96129d634f8$export$2cd627eaf555af8f() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
}
module.exports["SectionExpansionContext"] = $8e4be96129d634f8$export$fc9ae5c4169099cb;
module.exports["useSectionExpansionContext"] = $8e4be96129d634f8$export$b316af36f410c3ff;
module.exports["MenuControlContext"] = $8e4be96129d634f8$export$39aa3c8950714d79;
module.exports["MenuStateContext"] = $8e4be96129d634f8$export$24aad8519b95b41b;
module.exports["useMenuStateContext"] = $8e4be96129d634f8$export$efa3856fc0e85e7f;
module.exports["useUniversalCreateState"] = $8e4be96129d634f8$export$c7381b2490bb4d36;
module.exports["useUniversalCreateControl"] = $8e4be96129d634f8$export$2cd627eaf555af8f;

});

parcelRegister("VSkIN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $5qzNs = parcelRequire("5qzNs");


var $lvsjl = parcelRequire("lvsjl");

function $d27513c3e3d1447c$export$270a88864b52a4aa(items) {
    if (Array.isArray(items)) return items.every((item)=>{
        return typeof item === 'object' && item !== null && 'ati' in item;
    });
    return false;
}
function $d27513c3e3d1447c$export$5a8ab32aeea5694f(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItem have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $d27513c3e3d1447c$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}
const $d27513c3e3d1447c$export$f8e186cd2da1abff = 100;
const $d27513c3e3d1447c$var$MOBILE_WIDTH_BREAKPOINT = 767;
function $d27513c3e3d1447c$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $42omo.useState)(window.innerWidth <= $d27513c3e3d1447c$var$MOBILE_WIDTH_BREAKPOINT);
    const [handleResizeDebounced] = (0, $lvsjl.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= $d27513c3e3d1447c$var$MOBILE_WIDTH_BREAKPOINT;
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, $d27513c3e3d1447c$export$f8e186cd2da1abff);
    (0, $42omo.useEffect)(()=>{
        let unbind;
        unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}
const $d27513c3e3d1447c$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(item, ...properties);
const $d27513c3e3d1447c$export$fdd2c0ba94025c3c = (contextConfig)=>contextConfig.enabled ? contextConfig.cloudId : '';
const $d27513c3e3d1447c$export$5a762450d50ca901 = (contextConfig)=>contextConfig.enabled ? contextConfig.orgId : undefined;
module.exports["findSelectedItem"] = $d27513c3e3d1447c$export$5a8ab32aeea5694f;
module.exports["useIsResponsiveView"] = $d27513c3e3d1447c$export$2a50c0408cf3ddb8;
module.exports["omitSafely"] = $d27513c3e3d1447c$export$d6eadbd047ebd460;
module.exports["getCloudId"] = $d27513c3e3d1447c$export$fdd2c0ba94025c3c;
module.exports["getOrgId"] = $d27513c3e3d1447c$export$5a762450d50ca901;

});

parcelRegister("7K3dX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $9DI9J = parcelRequire("9DI9J");


var $19BZl = parcelRequire("19BZl");

function $c3ddb99f3c87e2eb$export$eebe354ebe67c94c() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { growthRecommendationsSessionId: growthRecommendationsSessionId, product: product, subProduct: subProduct } = (0, $19BZl.useUniversalCreateState)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const includeGrowthSessionInAnalytics = (0, $dh538.fg)('navx-3810-re-instrument-growth-session-id');
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct,
            ...includeGrowthSessionInAnalytics && growthRecommendationsSessionId !== undefined && {
                recommendationSessionId: growthRecommendationsSessionId
            }
        }), [
        growthRecommendationsSessionId,
        includeGrowthSessionInAnalytics,
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonHovered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'hovered',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireEntryPointLoadTriggered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            actionSubject: 'universalCreateEntryPointLoad',
            action: 'triggered',
            eventType: 'track',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNativeMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireSuggestionsMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNativeMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireSuggestionsMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireMenuItemsViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/100116
    const fireMenuContentClosed = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'closed',
            actionSubjectId: 'universalCreateMenuContent',
            attributes: {
                ...baseAttributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92730
    const fireShowMoreButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateShowMoreButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/96626
    const fireJSChunkLoadTime = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'loaded',
            actionSubject: 'universalCreateJSChunkLoad',
            actionSubjectId: 'universalCreateJSChunkLoad',
            eventType: 'operational',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireCreateButtonHovered: fireCreateButtonHovered,
        fireCreateButtonViewed: fireCreateButtonViewed,
        fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
        fireNativeMenuItemClicked: fireNativeMenuItemClicked,
        fireSuggestionsMenuItemClicked: fireSuggestionsMenuItemClicked,
        fireMenuItemClicked: fireMenuItemClicked,
        fireNativeMenuViewed: fireNativeMenuViewed,
        fireSuggestionsMenuViewed: fireSuggestionsMenuViewed,
        fireMenuItemsViewed: fireMenuItemsViewed,
        fireMenuContentClosed: fireMenuContentClosed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes,
        fireShowMoreButtonClicked: fireShowMoreButtonClicked,
        fireJSChunkLoadTime: fireJSChunkLoadTime
    };
}
module.exports["useUniversalCreateAnalytics"] = $c3ddb99f3c87e2eb$export$eebe354ebe67c94c;

});

parcelRegister("9DI9J", function(module, exports) {
const $7387c4ee4c968c68$export$85183a312807388d = 'navigation';
const $7387c4ee4c968c68$export$1f0ede2864ffece6 = 'navigationExperiences';
const $7387c4ee4c968c68$export$40fae459cb78b698 = 'global';
const $7387c4ee4c968c68$export$2ee98aa1b18a8f41 = 'top';
const $7387c4ee4c968c68$export$b4ed8a331b8fd4cc = 4;
const $7387c4ee4c968c68$export$f7109619a5e9e0d6 = 'topNav';
const $7387c4ee4c968c68$export$c091fab9d8f83000 = {
    PAGE: 'ati:cloud:confluence:page',
    WHITEBOARD: 'ati:cloud:confluence:whiteboard',
    GOAL: 'ati:cloud:townsquare:goal',
    WORK_ITEM: 'ati:cloud:jira:issue',
    LOOM: 'ati:cloud:loom:video',
    PROJECT: 'ati:cloud:townsquare:project',
    TEAM: 'ati:cloud:townsquare:team',
    TRELLO_BOARD: 'ati:cloud:trello:board'
};
const $7387c4ee4c968c68$export$9449803ae25a1ccd = $7387c4ee4c968c68$export$c091fab9d8f83000.LOOM;
module.exports["ANALYTICS_CHANNEL"] = $7387c4ee4c968c68$export$85183a312807388d;
module.exports["ANALYTICS_TAG"] = $7387c4ee4c968c68$export$1f0ede2864ffece6;
module.exports["NAV_LAYER"] = $7387c4ee4c968c68$export$40fae459cb78b698;
module.exports["NAV_CONTAINER"] = $7387c4ee4c968c68$export$2ee98aa1b18a8f41;
module.exports["NAV_VERSION"] = $7387c4ee4c968c68$export$b4ed8a331b8fd4cc;
module.exports["ANALYTICS_SOURCE"] = $7387c4ee4c968c68$export$f7109619a5e9e0d6;
module.exports["ATI_PRESETS"] = $7387c4ee4c968c68$export$c091fab9d8f83000;

});

parcelRegister("a1Oiu", function(module, exports) {
// ===============================
// UC Menu Items V2 API Communication
// ===============================

var $42omo = parcelRequire("42omo");


var $ekTM6 = parcelRequire("ekTM6");

var $5IDSL = parcelRequire("5IDSL");


var $l7sDu = parcelRequire("l7sDu");

/**
 * Encode configuration to binary format with query parameters
 */ /**
 * Encode ATI string to binary representation
 */ /**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 
var $6yCpa = parcelRequire("6yCpa");

function $0bf79e81331e4541$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $6yCpa.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $0bf79e81331e4541$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $6yCpa.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $0bf79e81331e4541$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $6yCpa.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $0bf79e81331e4541$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}


/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
const $dccf36f4b2146e6b$export$3167453beff01750 = 2;
const $dccf36f4b2146e6b$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $dccf36f4b2146e6b$export$61beacecbf214ae6 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$b2144c689c2ff042);
const $dccf36f4b2146e6b$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $dccf36f4b2146e6b$export$83dfff18be6bef06 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$89e1a37ecee09500);
const $dccf36f4b2146e6b$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $dccf36f4b2146e6b$export$38830b2321100ef2 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9dd62a2b56d5462d);
const $dccf36f4b2146e6b$export$b1e8f8dc54861a99 = 3;
const $dccf36f4b2146e6b$export$21d9e5eeb6ffaecd = 1;
const $dccf36f4b2146e6b$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $dccf36f4b2146e6b$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $dccf36f4b2146e6b$export$597234ac346c7ad8 = 256;
const $dccf36f4b2146e6b$export$8c22d9b338278eca = 4096;
const $dccf36f4b2146e6b$export$3010378ceda42048 = 256;
const $dccf36f4b2146e6b$export$6048538928ea261a = 4096;
const $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa = 2;
const $dccf36f4b2146e6b$export$4030221cfc1fb63c = 5;
const $dccf36f4b2146e6b$export$ece7c64a85a33d85 = 255;
const $dccf36f4b2146e6b$export$6747badc61b8e57b = 512;
const $dccf36f4b2146e6b$export$48ffef5fac2e11a = 10;
const $dccf36f4b2146e6b$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $dccf36f4b2146e6b$export$3dcfc8418d714114 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c38e76af505e38a1);
const $dccf36f4b2146e6b$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow',
    'growthRecommendations'
];
const $dccf36f4b2146e6b$export$6cabc9b146da4ac8 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c89f8194e7716284);
const $dccf36f4b2146e6b$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $dccf36f4b2146e6b$export$1e5c4f2c7d35f342 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9c3e0a77c247e0c);
const $dccf36f4b2146e6b$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];


/**
 * Get configuration for a specific component kind
 */ function $bcdba2959b20769a$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $dccf36f4b2146e6b$export$3010378ceda42048),
                errorMessage: `Too many unknown resource owners (max ${0, $dccf36f4b2146e6b$export$3010378ceda42048})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $dccf36f4b2146e6b$export$6048538928ea261a),
                errorMessage: `Too many unknown resource types (max ${0, $dccf36f4b2146e6b$export$6048538928ea261a})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $bcdba2959b20769a$var$ensureCapacity(unknowns, kind) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $bcdba2959b20769a$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $bcdba2959b20769a$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $bcdba2959b20769a$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $bcdba2959b20769a$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $bcdba2959b20769a$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $0bf79e81331e4541$export$5597e67f4dded1e6)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $dccf36f4b2146e6b$export$61beacecbf214ae6)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $dccf36f4b2146e6b$export$83dfff18be6bef06)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $dccf36f4b2146e6b$export$38830b2321100ef2)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $bcdba2959b20769a$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}


/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $iA9co = parcelRequire("iA9co");

var $5120b89f81d97ddd$require$Buffer = $iA9co.Buffer;
function $5120b89f81d97ddd$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $5120b89f81d97ddd$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}



// =============================================================================
// Configuration Validation
// =============================================================================
const $e39212095b0d4be5$var$MAX_SECTIONS = 15;
function $e39212095b0d4be5$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $e39212095b0d4be5$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$e39212095b0d4be5$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $bcdba2959b20769a$export$4b052fcb66ebb451)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $bcdba2959b20769a$export$9fa514be131db9ec)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $e39212095b0d4be5$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $e39212095b0d4be5$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $dccf36f4b2146e6b$export$dab292c7293b69ae)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $e39212095b0d4be5$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $e39212095b0d4be5$var$encodeMenuItem(item, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const typeCode = item.type !== undefined ? $e39212095b0d4be5$var$getCodeByType(item) : undefined;
    const atiBase64 = $e39212095b0d4be5$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $e39212095b0d4be5$var$PROMOTED_FLAG : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $e39212095b0d4be5$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $dccf36f4b2146e6b$export$3dcfc8418d714114)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $e39212095b0d4be5$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $dccf36f4b2146e6b$export$1e5c4f2c7d35f342)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $e39212095b0d4be5$var$personalizeCodeByMode(mode) {
    const code = (0, $dccf36f4b2146e6b$export$6cabc9b146da4ac8)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an overflow threshold
 *
 * @param overflowThreshold - Overflow threshold
 * @returns Encoded overflow threshold string
 */ function $e39212095b0d4be5$var$encodeOverflowThreshold(overflowThreshold) {
    if (overflowThreshold < 0) throw new Error('Overflow threshold must be positive');
    return overflowThreshold.toString();
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$e39212095b0d4be5$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $e39212095b0d4be5$var$personalizeCodeByMode(section.personalize) : undefined;
    const overflowThreshold = personalizeCode !== undefined && section.personalize === 'overflow' && section.overflowThreshold !== undefined ? $e39212095b0d4be5$var$encodeOverflowThreshold(section.overflowThreshold) : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode,
        overflowThreshold
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $e39212095b0d4be5$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $e39212095b0d4be5$var$encodeATIList(section.preferredAtis, unknowns);
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $e39212095b0d4be5$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $e39212095b0d4be5$var$buildRawConfigString(encodedSections) {
    return `v${0, $dccf36f4b2146e6b$export$3167453beff01750}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $e39212095b0d4be5$export$1282978798683232(config) {
    $e39212095b0d4be5$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$e39212095b0d4be5$var$encodeSection(section, unknowns));
    const rawConfigString = $e39212095b0d4be5$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(utf8Bytes);
    return $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns);
}



var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");


var $cei05 = parcelRequire("cei05");


var $6lFYf = parcelRequire("6lFYf");







/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $67bf03c55a136376$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $67bf03c55a136376$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $caUKj.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $42omo.useMemo)(()=>{
        const sortedJsonString = $67bf03c55a136376$var$createSortedCacheKey(props);
        return `gc-${consumer}-${sortedJsonString}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $42omo.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev.cache;
            return {
                ...prev,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey)=>cache[targetCacheKey] !== undefined;
    return {
        cachedObject: cachedObject,
        cacheKey: cacheKey,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        removeCachedObject: removeCachedObject,
        setCachedObject: setCachedObject
    };
}



var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $3ef0e6a21c4da545$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const boundaryConfig = (0, $42omo.useMemo)(()=>({
            location: 'useUCMenuItems',
            disableSentry: false,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)(boundaryConfig);
    const { inFlightRequests: inFlightRequests, setInFlightRequests: setInFlightRequests } = (0, $cei05.useUniversalCreateBFFContext)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    /**
	 * Helper functions for feature gated inflight request tracking
	 */ const isRequestInflight = (0, $42omo.useCallback)((requestKey)=>{
        return inFlightRequests.has(requestKey);
    }, [
        inFlightRequests
    ]);
    const setRequestInFlight = (0, $42omo.useCallback)((requestKey, value)=>{
        return setInFlightRequests(requestKey, value);
    }, [
        setInFlightRequests
    ]);
    const clearInFlightRequest = (0, $42omo.useCallback)((requestKey)=>{
        return inFlightRequests.delete(requestKey);
    }, [
        inFlightRequests
    ]);
    // Encode the config to get binary parameters
    const encodedConfig = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $e39212095b0d4be5$export$1282978798683232)(appMenuConfig);
        } catch  {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $67bf03c55a136376$export$53a1e737d45016e2)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $42omo.useCallback)(async ()=>{
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in flight
        if (isRequestInflight(requestKey)) return;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $l7sDu.createExperienceTracker)('universalCreatePrefetch');
        experience?.start();
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            // Mark request key as in-flight before fetch fires to prevent race conditions
            setRequestInFlight(requestKey, true);
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (isRequestInflight(requestKey)) clearInFlightRequest(requestKey);
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                clearInFlightRequest(requestKey);
                handleError(new (0, $ekTM6.BFFNetworkError)('Failed to fetch universal create menu items', {
                    url: url,
                    status: response.status,
                    originalError: response.error,
                    additionalContext: {
                        requestKey: requestKey
                    }
                }));
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                clearInFlightRequest(requestKey);
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            clearInFlightRequest(requestKey);
            handleError(new (0, $ekTM6.BFFError)('Error occurred during fetchUCMenuItems', {
                status: (0, $4jETc.RequestStatus).ERROR,
                originalError: error,
                additionalContext: {
                    requestKey: requestKey
                }
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        skipInitialization,
        encodedConfig,
        cachedObject,
        product,
        userId,
        locale,
        subProduct,
        isRequestInflight,
        setStatus,
        buildUCMenuItemsURL,
        setRequestInFlight,
        clearInFlightRequest,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return false;
        // We check if the current loading requests include UC menu items rather than the BFF status directly
        // to ensure that it only returns true for UC menu items and not other BFF requests.
        const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
        // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
        // before running things like onResultChange, so that we don't do those things an unnecessary extra time
        // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
        const hasMenuItemDataBeenReturned = data !== undefined || hasError;
        return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}
module.exports["useUCMenuItems"] = $3ef0e6a21c4da545$export$23f37315094bc4d3;

});

parcelRegister("hpf3U", function(module, exports) {
const $55643944f8b24c01$export$e5a5b1df38d9e289 = 4;



var $5VnWj = parcelRequire("5VnWj");

const $e08ba7c77d4e4820$export$20ae29efbf02e075 = (item)=>({
        type: (0, $5VnWj.isNativeMenuItem)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $e08ba7c77d4e4820$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') {
        const overflowThreshold = Boolean(section.foldable) ? typeof section.foldable === 'number' ? section.foldable : (0, $55643944f8b24c01$export$e5a5b1df38d9e289) : undefined;
        return {
            type: 'appDefinedSection',
            items: section.items.map($e08ba7c77d4e4820$export$20ae29efbf02e075),
            personalize: section.personalize,
            ...overflowThreshold && {
                overflowThreshold: overflowThreshold
            }
        };
    }
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $e08ba7c77d4e4820$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($e08ba7c77d4e4820$export$95539883fd80ce6)
    });
module.exports["sectionsToAppMenuConfig"] = $e08ba7c77d4e4820$export$c9ba238fd04e08d2;

});

parcelRegister("5VnWj", function(module, exports) {
const $c3f9ab6a3e4f20d8$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};
module.exports["isNativeMenuItem"] = $c3f9ab6a3e4f20d8$export$68f958d92a17ef71;

});

parcelRegister("dv953", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $41db8bac43dc4cde$export$61de563e38fe014d() {
    const fetchUser = (0, $42omo.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
}
module.exports["useFetchUser"] = $41db8bac43dc4cde$export$61de563e38fe014d;

});

parcelRegister("kOiVn", function(module, exports) {

let $f26728225047ff68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f26728225047ff68$var$load("3VpLA").then(()=>parcelRequire('b6A6z'));

});

parcelRegister("25I5T", function(module, exports) {

let $185e409158537583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $185e409158537583$var$load("3VpLA"),
    $185e409158537583$var$load("2NjlT")
]).then(()=>parcelRequire('irQ3Q'));

});

parcelRegister("amdkE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $9DI9J = parcelRequire("9DI9J");


var $7WMLZ = parcelRequire("7WMLZ");

const $cfb31863b8c4fcaa$var$styles = {
    wrapper: "_1ul91dhz",
    wrapperWithPadding: "_1ul91dhz _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi"
};
function $cfb31863b8c4fcaa$export$dab1248df0cdf0ab({ padded: padded = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // Intentional inline this analytics events due to
        // loading menu component can be used outside of context
        createAnalyticsEvent({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            action: 'viewed',
            actionSubjectId: 'universalCreateLoadingMenu',
            attributes: {}
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $cfb31863b8c4fcaa$var$styles.wrapperWithPadding : $cfb31863b8c4fcaa$var$styles.wrapper
    }, Array.from({
        length: 6
    }, (_, index)=>/*#__PURE__*/ $42omo.createElement((0, $7WMLZ.SkeletonItem), {
            key: `loading-skeleton-item-${index}`,
            contentHeight: 8
        })));
}
module.exports["LoadingMenu"] = $cfb31863b8c4fcaa$export$dab1248df0cdf0ab;

});

parcelRegister("7WMLZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $aXWIB = parcelRequire("aXWIB");


var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");




const $63d1bead1b1651fc$var$messages = (0, $aXWIB.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $63d1bead1b1651fc$export$2e2bcd8739ae039 = $63d1bead1b1651fc$var$messages;


const $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT = 8;
const $f0781448a6f252f4$var$menuSkeletonStyles = {
    wrapper: "_4t3izwfg _1bsb1osq _19bv1b66 _u5f31b66"
};
const $f0781448a6f252f4$export$cde35cc9e1359709 = ({ testId: testId, contentHeight: contentHeight = $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        xcss: $f0781448a6f252f4$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $kpYGL.default), {
        testId: "skeleton-item-v2",
        width: "100%",
        height: contentHeight,
        isShimmering: true
    })), /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, formatMessage((0, $63d1bead1b1651fc$export$2e2bcd8739ae039).menuItemLoading)));
};


const $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0781448a6f252f4$export$cde35cc9e1359709), props);
};
module.exports["SkeletonItem"] = $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e;

});

parcelRegister("fNh3C", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $keVvA = parcelRequire("keVvA");


var $i2kCO = parcelRequire("i2kCO");

function $503da3927b063db6$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $503da3927b063db6$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("4DBlL"));
        case 'da':
            return (parcelRequire("QiHJH"));
        case 'de':
            return (parcelRequire("5fKfY"));
        case 'en-GB':
            return (parcelRequire("bd60H"));
        case 'en-ZZ':
            return (parcelRequire("lhFMp"));
        case 'en':
            return Promise.resolve((parcelRequire("i2kCO")));
        case 'es':
            return (parcelRequire("lkfj4"));
        case 'fi':
            return (parcelRequire("7i5RS"));
        case 'fr':
            return (parcelRequire("k04cn"));
        case 'hu':
            return (parcelRequire("lkAKZ"));
        case 'it':
            return (parcelRequire("gGAak"));
        case 'ja':
            return (parcelRequire("4tZ4k"));
        case 'ko':
            return (parcelRequire("8pvft"));
        case 'nb':
            return (parcelRequire("hgimn"));
        case 'nl':
            return (parcelRequire("lSter"));
        case 'pl':
            return (parcelRequire("lqL92"));
        case 'pt':
            return (parcelRequire("4n76O"));
        case 'ru':
            return (parcelRequire("4tj0T"));
        case 'sv':
            return (parcelRequire("kxm5g"));
        case 'th':
            return (parcelRequire("gm7mX"));
        case 'tr':
            return (parcelRequire("kuMWv"));
        case 'uk':
            return (parcelRequire("c9eij"));
        case 'vi':
            return (parcelRequire("ejhdq"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("bazzC"));
        case 'zh':
            return (parcelRequire("jg5rQ"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $503da3927b063db6$export$12346a674644c156 = 'operational';
const $503da3927b063db6$export$515664faa1398f37 = 'navigation';
function $503da3927b063db6$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $503da3927b063db6$var$fetchLanguageFile($503da3927b063db6$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $503da3927b063db6$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($503da3927b063db6$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $i2kCO.default)
    }, children);
}
const $503da3927b063db6$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($503da3927b063db6$var$Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, props));
module.exports["withIntlProvider"] = $503da3927b063db6$export$a5d940130f33be3f;

});

parcelRegister("i2kCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2e0f4708d02b569e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2e0f4708d02b569e$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'goal-create-success-flag-action': 'Go to goal',
    'goal-create-success-flag-title': 'Goal has been created',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.area-label': 'Toggle for {text}{heading} options',
    'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
    'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title': 'Sorry, something went wrong',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title': 'Team has been created',
    'platform.navigation-experiences.universal-create.project.create-error-flag-description': 'There was an error while creating your project. Please try again.',
    'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
    'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
    'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
    'platform.navigation-experiences.universal-create.secondary-tooltip-text': 'More create options',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More',
    'platform.navigation-experiences.universal-create.show-more.area-label': 'Show {text} {heading} options',
    'platform.navigation-experiences.universal-create.suggestion.section-heading': '{count, plural, one {Suggestion} other {Suggestions}}'
};

});

parcelRegister("4DBlL", function(module, exports) {

let $3607c6dd4bca7053$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3607c6dd4bca7053$var$load("46t5f").then(()=>parcelRequire('2nrO6'));

});

parcelRegister("QiHJH", function(module, exports) {

let $09d35dc07c3f53c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d35dc07c3f53c0$var$load("1YqfS").then(()=>parcelRequire('cmlqi'));

});

parcelRegister("5fKfY", function(module, exports) {

let $3d323c0b9ff3507e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d323c0b9ff3507e$var$load("9DYyx").then(()=>parcelRequire('lbNO6'));

});

parcelRegister("bd60H", function(module, exports) {

let $829592226ac5d9b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $829592226ac5d9b4$var$load("42ZJx").then(()=>parcelRequire('egI7t'));

});

parcelRegister("lhFMp", function(module, exports) {

let $f7eb9814fa81261d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7eb9814fa81261d$var$load("jtt0C").then(()=>parcelRequire('gkIoe'));

});

parcelRegister("lkfj4", function(module, exports) {

let $f86756cad7363fec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f86756cad7363fec$var$load("3vk3N").then(()=>parcelRequire('B195q'));

});

parcelRegister("7i5RS", function(module, exports) {

let $54eec418d2bda09e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $54eec418d2bda09e$var$load("hbGGN").then(()=>parcelRequire('j0Mtc'));

});

parcelRegister("k04cn", function(module, exports) {

let $e8f7107c0ef79cdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8f7107c0ef79cdb$var$load("dopc8").then(()=>parcelRequire('8fG30'));

});

parcelRegister("lkAKZ", function(module, exports) {

let $f877fa6788db847d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f877fa6788db847d$var$load("9RJgs").then(()=>parcelRequire('kh2Eq'));

});

parcelRegister("gGAak", function(module, exports) {

let $c25c9f54fb8c6898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c25c9f54fb8c6898$var$load("jo6RJ").then(()=>parcelRequire('klvFQ'));

});

parcelRegister("4tZ4k", function(module, exports) {

let $34393ddc80962779$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34393ddc80962779$var$load("lKoae").then(()=>parcelRequire('fXwAq'));

});

parcelRegister("8pvft", function(module, exports) {

let $61f8e5d7d86bc7b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $61f8e5d7d86bc7b4$var$load("1MIK8").then(()=>parcelRequire('8ZHVH'));

});

parcelRegister("hgimn", function(module, exports) {

let $c9122c2aaae4ba3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9122c2aaae4ba3b$var$load("jh74O").then(()=>parcelRequire('5kpn9'));

});

parcelRegister("lSter", function(module, exports) {

let $fed550f81f03cdfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fed550f81f03cdfd$var$load("alBoB").then(()=>parcelRequire('cql7z'));

});

parcelRegister("lqL92", function(module, exports) {

let $f9a098a6bb598d2c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9a098a6bb598d2c$var$load("fwQyo").then(()=>parcelRequire('gYqMF'));

});

parcelRegister("4n76O", function(module, exports) {

let $32eed3125117c801$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32eed3125117c801$var$load("jnFv5").then(()=>parcelRequire('oyKRX'));

});

parcelRegister("4tj0T", function(module, exports) {

let $34189e868e18467b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $34189e868e18467b$var$load("3wEVm").then(()=>parcelRequire('9FWL3'));

});

parcelRegister("kxm5g", function(module, exports) {

let $ef3805190066c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ef3805190066c0ae$var$load("1AYDD").then(()=>parcelRequire('5SliH'));

});

parcelRegister("gm7mX", function(module, exports) {

let $be846acecf57dbc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be846acecf57dbc9$var$load("503rY").then(()=>parcelRequire('ecW9b'));

});

parcelRegister("kuMWv", function(module, exports) {

let $eebc92fc4bed7c07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eebc92fc4bed7c07$var$load("h5gGf").then(()=>parcelRequire('lGdFo'));

});

parcelRegister("c9eij", function(module, exports) {

let $8d8169e24e713ab7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d8169e24e713ab7$var$load("kgjXg").then(()=>parcelRequire('jf2AA'));

});

parcelRegister("ejhdq", function(module, exports) {

let $a6b031af64134360$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a6b031af64134360$var$load("jvpmI").then(()=>parcelRequire('50EZL'));

});

parcelRegister("bazzC", function(module, exports) {

let $821c39039eb64b47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $821c39039eb64b47$var$load("8ajSg").then(()=>parcelRequire('dZU7K'));

});

parcelRegister("jg5rQ", function(module, exports) {

let $e053bcd6d21f570b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e053bcd6d21f570b$var$load("cz5Vg").then(()=>parcelRequire('7yjbB'));

});

parcelRegister("2UkG4", function(module, exports) {

let $21e0d9d71734f788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $21e0d9d71734f788$var$load("5o4Kn"),
    $21e0d9d71734f788$var$load("6rS39"),
    $21e0d9d71734f788$var$load("3VpLA"),
    $21e0d9d71734f788$var$load("ixLhb")
]).then(()=>parcelRequire('6C7bq'));

});

parcelRegister("dcUvx", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});

parcelRegister("g8JXt", function(module, exports) {

let $0308465f38a4ffa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0308465f38a4ffa1$var$load("b8oHe").then(()=>parcelRequire('1Q21q'));

});

parcelRegister("d7J1w", function(module, exports) {

let $98deda8fdae93c1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $98deda8fdae93c1d$var$load("gdwbX"),
    $98deda8fdae93c1d$var$load("6wr18"),
    $98deda8fdae93c1d$var$load("bAAhx"),
    $98deda8fdae93c1d$var$load("hLjS5"),
    $98deda8fdae93c1d$var$load("7EorR"),
    $98deda8fdae93c1d$var$load("hhss7"),
    $98deda8fdae93c1d$var$load("48rvp"),
    $98deda8fdae93c1d$var$load("iMSgb"),
    $98deda8fdae93c1d$var$load("ffEVr"),
    $98deda8fdae93c1d$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("cei05", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $132077623536365b$export$c037b66df971b916 = /*#__PURE__*/ (0, $42omo.createContext)({
    inFlightRequests: new Map(),
    setInFlightRequests: ()=>{}
});
function $132077623536365b$export$1bb2b4064846aef2() {
    return (0, $42omo.useContext)($132077623536365b$export$c037b66df971b916);
}
function $132077623536365b$export$afffe3cb36bf5e6e({ children: children }) {
    const inFlightRequestsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(new Map());
    const setInFlightRequests = (0, $42omo.useCallback)((requestKey, value)=>{
        inFlightRequestsRef.current.set(requestKey, value);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            inFlightRequests: inFlightRequestsRef.current,
            setInFlightRequests: setInFlightRequests
        }), [
        setInFlightRequests
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($132077623536365b$export$c037b66df971b916.Provider, {
        value: contextValue
    }, children);
}
module.exports["useUniversalCreateBFFContext"] = $132077623536365b$export$1bb2b4064846aef2;
module.exports["UniversalCreateBFFProvider"] = $132077623536365b$export$afffe3cb36bf5e6e;

});


//# sourceMappingURL=PageLayout.2f925198.js.map
